//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    runActualsAdfPipeline(): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePAdfPipelines/RunActualsAdfPipeline";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunActualsAdfPipeline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunActualsAdfPipeline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunActualsAdfPipeline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param runId (optional) 
     * @return OK
     */
    getActualsAdfPipelineRunStatus(runId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePAdfPipelines/GetActualsAdfPipelineRunStatus?";
        if (runId === null)
            throw new globalThis.Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualsAdfPipelineRunStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualsAdfPipelineRunStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetActualsAdfPipelineRunStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getFileAttachmentList(initiativeId: number | undefined, page: number | undefined, pageSize: number | undefined): Observable<OnePAttachmentFileDTO[]> {
        let url_ = this.baseUrl + "/api/OnePAttachments/GetFileAttachmentList?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileAttachmentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileAttachmentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePAttachmentFileDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePAttachmentFileDTO[]>;
        }));
    }

    protected processGetFileAttachmentList(response: HttpResponseBase): Observable<OnePAttachmentFileDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePAttachmentFileDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @return OK
     */
    link(initiativeId: number | undefined, attachmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePAttachments/GetFileAttachmentLink{attachmentId}/link?";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @return OK
     */
    onePAttachmentsGET(initiativeId: number | undefined, attachmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePAttachments/DownloadFileAttachment{attachmentId}?";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePAttachmentsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePAttachmentsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePAttachmentsGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAttachmentFilesByInitiatives(body: number[] | undefined): Observable<OnePInitiativesAttachmentFileDTO[]> {
        let url_ = this.baseUrl + "/api/OnePAttachments/GetAttachmentFilesByInitiatives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentFilesByInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentFilesByInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativesAttachmentFileDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativesAttachmentFileDTO[]>;
        }));
    }

    protected processGetAttachmentFilesByInitiatives(response: HttpResponseBase): Observable<OnePInitiativesAttachmentFileDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativesAttachmentFileDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param breakInOutId (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadFileAttachment(initiativeId: number | undefined, breakInOutId: number | undefined, file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/OnePAttachments/UploadFileAttachment?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (breakInOutId === null)
            throw new globalThis.Error("The parameter 'breakInOutId' cannot be null.");
        else if (breakInOutId !== undefined)
            url_ += "breakInOutId=" + encodeURIComponent("" + breakInOutId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFileAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFileAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFileAttachment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @return OK
     */
    onePAttachmentsDELETE(initiativeId: number | undefined, attachmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePAttachments/DeleteFileAttachment{attachmentId}?";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePAttachmentsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePAttachmentsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePAttachmentsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllPendingBreakInOuts(body: GridQuery | undefined): Observable<OnePBreakInOutReadDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/GetAllPendingBreakInOuts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPendingBreakInOuts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPendingBreakInOuts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePBreakInOutReadDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePBreakInOutReadDTOGridPagedResult>;
        }));
    }

    protected processGetAllPendingBreakInOuts(response: HttpResponseBase): Observable<OnePBreakInOutReadDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePBreakInOutReadDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPLTeamBreakInOuts(body: GridQuery | undefined): Observable<OnePBreakInOutReadDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/GetPLTeamBreakInOuts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPLTeamBreakInOuts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPLTeamBreakInOuts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePBreakInOutReadDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePBreakInOutReadDTOGridPagedResult>;
        }));
    }

    protected processGetPLTeamBreakInOuts(response: HttpResponseBase): Observable<OnePBreakInOutReadDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePBreakInOutReadDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePBreakInOutAll(id: number): Observable<OnePBreakInOutReadDTO[]> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/GetBreakInOutByInitiativeId{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePBreakInOutAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePBreakInOutAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePBreakInOutReadDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePBreakInOutReadDTO[]>;
        }));
    }

    protected processOnePBreakInOutAll(response: HttpResponseBase): Observable<OnePBreakInOutReadDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePBreakInOutReadDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param breakInOutId (optional) 
     * @return OK
     */
    getBreakInOutProjectCostTotals(breakInOutId: number | undefined): Observable<OnePProjectCostTotalsDTO> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/GetBreakInOutProjectCostTotals?";
        if (breakInOutId === null)
            throw new globalThis.Error("The parameter 'breakInOutId' cannot be null.");
        else if (breakInOutId !== undefined)
            url_ += "breakInOutId=" + encodeURIComponent("" + breakInOutId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBreakInOutProjectCostTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBreakInOutProjectCostTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCostTotalsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCostTotalsDTO>;
        }));
    }

    protected processGetBreakInOutProjectCostTotals(response: HttpResponseBase): Observable<OnePProjectCostTotalsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectCostTotalsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param breakInOutId (optional) 
     * @param initiativeId (optional) 
     * @return OK
     */
    getCombinedBreakInOutInitiativeCostTotals(breakInOutId: number | undefined, initiativeId: number | undefined): Observable<OnePProjectCostTotalsDTO> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/GetCombinedBreakInOutInitiativeCostTotals?";
        if (breakInOutId === null)
            throw new globalThis.Error("The parameter 'breakInOutId' cannot be null.");
        else if (breakInOutId !== undefined)
            url_ += "breakInOutId=" + encodeURIComponent("" + breakInOutId) + "&";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCombinedBreakInOutInitiativeCostTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCombinedBreakInOutInitiativeCostTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCostTotalsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCostTotalsDTO>;
        }));
    }

    protected processGetCombinedBreakInOutInitiativeCostTotals(response: HttpResponseBase): Observable<OnePProjectCostTotalsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectCostTotalsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param breakInOutId (optional) 
     * @param body (optional) 
     * @return OK
     */
    upsertBreakInOutCostTotals(breakInOutId: number | undefined, body: OnePProjectCostTotalsDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/UpsertBreakInOutCostTotals?";
        if (breakInOutId === null)
            throw new globalThis.Error("The parameter 'breakInOutId' cannot be null.");
        else if (breakInOutId !== undefined)
            url_ += "breakInOutId=" + encodeURIComponent("" + breakInOutId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertBreakInOutCostTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertBreakInOutCostTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertBreakInOutCostTotals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createBreakInOut(body: CreateBreakInOutCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/CreateBreakInOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBreakInOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBreakInOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBreakInOut(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBreakInOut(body: UpdateBreakInOutCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/UpdateBreakInOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBreakInOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBreakInOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBreakInOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBreakInOutConfirmation(body: UpdateBreakInOutConfirmationCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/UpdateBreakInOutConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBreakInOutConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBreakInOutConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBreakInOutConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBreakInOutApproval(body: UpdateBreakInOutApprovalCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/UpdateBreakInOutApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBreakInOutApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBreakInOutApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBreakInOutApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateBreakInOutCommentFields(body: UpdateBreakInOutCommentFieldsCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/UpdateBreakInOutCommentFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBreakInOutCommentFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBreakInOutCommentFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBreakInOutCommentFields(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePBreakInOut(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/CancelBreakInOut{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePBreakInOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePBreakInOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePBreakInOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePBreakInOut2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePBreakInOut/DeleteBreakInOutCostTotals{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePBreakInOut2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePBreakInOut2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePBreakInOut2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAreaOwners(): Observable<OnePAreaOwner[]> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetAreaOwners";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaOwners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePAreaOwner[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePAreaOwner[]>;
        }));
    }

    protected processGetAreaOwners(response: HttpResponseBase): Observable<OnePAreaOwner[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePAreaOwner.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET(id: number): Observable<OnePAreaOwner> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetAreaOwnerById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePAreaOwner>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePAreaOwner>;
        }));
    }

    protected processOnePDictionariesGET(response: HttpResponseBase): Observable<OnePAreaOwner> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePAreaOwner.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET2(areaName: string): Observable<OnePAreaOwner> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetAreaOwnerByAreaName{areaName}";
        if (areaName === undefined || areaName === null)
            throw new globalThis.Error("The parameter 'areaName' must be defined.");
        url_ = url_.replace("{areaName}", encodeURIComponent("" + areaName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePAreaOwner>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePAreaOwner>;
        }));
    }

    protected processOnePDictionariesGET2(response: HttpResponseBase): Observable<OnePAreaOwner> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePAreaOwner.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createAreaOwner(body: CreateAreaOwnerCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/CreateAreaOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAreaOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAreaOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAreaOwner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAreaOwner(body: UpdateAreaOwnerCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/UpdateAreaOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAreaOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAreaOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAreaOwner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/DeleteAreaOwner{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePDictionariesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProjectTeams(): Observable<OnePProjectTeam[]> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetProjectTeams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectTeams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectTeams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectTeam[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectTeam[]>;
        }));
    }

    protected processGetProjectTeams(response: HttpResponseBase): Observable<OnePProjectTeam[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePProjectTeam.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET3(id: number): Observable<OnePProjectTeam> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetProjectTeamById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectTeam>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectTeam>;
        }));
    }

    protected processOnePDictionariesGET3(response: HttpResponseBase): Observable<OnePProjectTeam> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectTeam.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET4(teamName: string): Observable<OnePProjectTeam> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetProjectTeamByTeamName{teamName}";
        if (teamName === undefined || teamName === null)
            throw new globalThis.Error("The parameter 'teamName' must be defined.");
        url_ = url_.replace("{teamName}", encodeURIComponent("" + teamName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectTeam>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectTeam>;
        }));
    }

    protected processOnePDictionariesGET4(response: HttpResponseBase): Observable<OnePProjectTeam> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectTeam.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProjectTeam(body: CreateProjectTeamCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/CreateProjectTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProjectTeam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProjectTeam(body: UpdateProjectTeamCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/UpdateProjectTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProjectTeam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesDELETE2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/DeleteProjectTeam{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesDELETE2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesDELETE2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePDictionariesDELETE2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFinanceStatuses(): Observable<OnePFinanceStatusReadDTO[]> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetFinanceStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinanceStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinanceStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePFinanceStatusReadDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePFinanceStatusReadDTO[]>;
        }));
    }

    protected processGetFinanceStatuses(response: HttpResponseBase): Observable<OnePFinanceStatusReadDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePFinanceStatusReadDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET5(id: number): Observable<OnePFinanceStatusReadDTO> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetFinanceStatusById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePFinanceStatusReadDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePFinanceStatusReadDTO>;
        }));
    }

    protected processOnePDictionariesGET5(response: HttpResponseBase): Observable<OnePFinanceStatusReadDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePFinanceStatusReadDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET6(statusName: string): Observable<OnePFinanceStatusReadDTO> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetFinanceStatusByStatusName{statusName}";
        if (statusName === undefined || statusName === null)
            throw new globalThis.Error("The parameter 'statusName' must be defined.");
        url_ = url_.replace("{statusName}", encodeURIComponent("" + statusName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePFinanceStatusReadDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePFinanceStatusReadDTO>;
        }));
    }

    protected processOnePDictionariesGET6(response: HttpResponseBase): Observable<OnePFinanceStatusReadDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePFinanceStatusReadDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createFinanceStatus(body: CreateFinanceStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/CreateFinanceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFinanceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFinanceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateFinanceStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFinanceStatus(body: UpdateFinanceStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/UpdateFinanceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFinanceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinanceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFinanceStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesDELETE3(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/DeleteFinanceStatus{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesDELETE3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesDELETE3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePDictionariesDELETE3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMciPrograms(): Observable<OnePMciProgramReadDTO[]> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetMciPrograms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMciPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMciPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePMciProgramReadDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePMciProgramReadDTO[]>;
        }));
    }

    protected processGetMciPrograms(response: HttpResponseBase): Observable<OnePMciProgramReadDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePMciProgramReadDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET7(id: number): Observable<OnePMciProgramReadDTO> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetMciProgramById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePMciProgramReadDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePMciProgramReadDTO>;
        }));
    }

    protected processOnePDictionariesGET7(response: HttpResponseBase): Observable<OnePMciProgramReadDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePMciProgramReadDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET8(programName: string): Observable<OnePMciProgramReadDTO> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetMciProgramByProgramName{programName}";
        if (programName === undefined || programName === null)
            throw new globalThis.Error("The parameter 'programName' must be defined.");
        url_ = url_.replace("{programName}", encodeURIComponent("" + programName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePMciProgramReadDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePMciProgramReadDTO>;
        }));
    }

    protected processOnePDictionariesGET8(response: HttpResponseBase): Observable<OnePMciProgramReadDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePMciProgramReadDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMciProgram(body: CreateMciProgramCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/CreateMciProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMciProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMciProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMciProgram(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMciProgram(body: UpdateMciProgramCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/UpdateMciProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMciProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMciProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMciProgram(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesDELETE4(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/DeleteMciProgram{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesDELETE4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesDELETE4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePDictionariesDELETE4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getProjectCoordinators(): Observable<OnePProjectCoordinatorReadDTO[]> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetProjectCoordinators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectCoordinators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectCoordinators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCoordinatorReadDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCoordinatorReadDTO[]>;
        }));
    }

    protected processGetProjectCoordinators(response: HttpResponseBase): Observable<OnePProjectCoordinatorReadDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePProjectCoordinatorReadDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET9(id: number): Observable<OnePProjectCoordinatorReadDTO> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetProjectCoordinatorByIdQuery{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET9(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET9(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCoordinatorReadDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCoordinatorReadDTO>;
        }));
    }

    protected processOnePDictionariesGET9(response: HttpResponseBase): Observable<OnePProjectCoordinatorReadDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectCoordinatorReadDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesGET10(coordinatorName: string): Observable<OnePProjectCoordinatorReadDTO> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/GetProjectCoordinatorByCoordinatorName{coordinatorName}";
        if (coordinatorName === undefined || coordinatorName === null)
            throw new globalThis.Error("The parameter 'coordinatorName' must be defined.");
        url_ = url_.replace("{coordinatorName}", encodeURIComponent("" + coordinatorName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesGET10(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesGET10(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCoordinatorReadDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCoordinatorReadDTO>;
        }));
    }

    protected processOnePDictionariesGET10(response: HttpResponseBase): Observable<OnePProjectCoordinatorReadDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectCoordinatorReadDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProjectCoordinator(body: CreateProjectCoordinatorCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/CreateProjectCoordinator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectCoordinator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectCoordinator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateProjectCoordinator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProjectCoordinator(body: UpdateProjectCoordinatorCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/UpdateProjectCoordinator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectCoordinator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectCoordinator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProjectCoordinator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePDictionariesDELETE5(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePDictionaries/DeleteProjectCoordinator{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePDictionariesDELETE5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePDictionariesDELETE5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePDictionariesDELETE5(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param projectYear (optional) 
     * @return OK
     */
    getForecastCostTotals(initiativeId: number | undefined, projectYear: number | undefined): Observable<OnePProjectCostTotalsDTO> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetForecastCostTotals?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (projectYear === null)
            throw new globalThis.Error("The parameter 'projectYear' cannot be null.");
        else if (projectYear !== undefined)
            url_ += "projectYear=" + encodeURIComponent("" + projectYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastCostTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastCostTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCostTotalsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCostTotalsDTO>;
        }));
    }

    protected processGetForecastCostTotals(response: HttpResponseBase): Observable<OnePProjectCostTotalsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectCostTotalsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectYear (optional) 
     * @return OK
     */
    getForecastCostTotalsForAllInitiatives(projectYear: number | undefined): Observable<OnePInitiativesCostTotalsDTO[]> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetForecastCostTotalsForAllInitiatives?";
        if (projectYear === null)
            throw new globalThis.Error("The parameter 'projectYear' cannot be null.");
        else if (projectYear !== undefined)
            url_ += "projectYear=" + encodeURIComponent("" + projectYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastCostTotalsForAllInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastCostTotalsForAllInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativesCostTotalsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativesCostTotalsDTO[]>;
        }));
    }

    protected processGetForecastCostTotalsForAllInitiatives(response: HttpResponseBase): Observable<OnePInitiativesCostTotalsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativesCostTotalsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getForecastEditStatus(): Observable<string> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetForecastEditStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastEditStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastEditStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetForecastEditStatus(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActiveForecastEditState(): Observable<OnePForecastEditState> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetActiveForecastEditState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveForecastEditState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveForecastEditState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePForecastEditState>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePForecastEditState>;
        }));
    }

    protected processGetActiveForecastEditState(response: HttpResponseBase): Observable<OnePForecastEditState> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePForecastEditState.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param year (optional) 
     * @return OK
     */
    getLatestClosedForecastRevisionMonthlyOutlooks(year: number | undefined): Observable<OnePProjectCostTotalsOutlookDTO[]> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetLatestClosedForecastRevisionMonthlyOutlooks?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestClosedForecastRevisionMonthlyOutlooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestClosedForecastRevisionMonthlyOutlooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCostTotalsOutlookDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCostTotalsOutlookDTO[]>;
        }));
    }

    protected processGetLatestClosedForecastRevisionMonthlyOutlooks(response: HttpResponseBase): Observable<OnePProjectCostTotalsOutlookDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePProjectCostTotalsOutlookDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    exportForecastExcelFileToIBP(): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePForecast/ExportForecastExcelFileToIBP";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportForecastExcelFileToIBP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportForecastExcelFileToIBP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportForecastExcelFileToIBP(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @return OK
     */
    getPendingBreakInOutChangeSetId(initiativeId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetPendingBreakInOutChangeSetId?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingBreakInOutChangeSetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingBreakInOutChangeSetId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPendingBreakInOutChangeSetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @return OK
     */
    getForecastCostTotalsChangeHistory(initiativeId: number | undefined): Observable<OnePForecastCostTotalsChangeSetDTO[]> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetForecastCostTotalsChangeHistory?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastCostTotalsChangeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastCostTotalsChangeHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePForecastCostTotalsChangeSetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePForecastCostTotalsChangeSetDTO[]>;
        }));
    }

    protected processGetForecastCostTotalsChangeHistory(response: HttpResponseBase): Observable<OnePForecastCostTotalsChangeSetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePForecastCostTotalsChangeSetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllForecasts(body: GridQuery | undefined): Observable<OnePInitiativeWithBreakInOutDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetAllForecasts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForecasts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForecasts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeWithBreakInOutDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeWithBreakInOutDTOGridPagedResult>;
        }));
    }

    protected processGetAllForecasts(response: HttpResponseBase): Observable<OnePInitiativeWithBreakInOutDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeWithBreakInOutDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllForecastRevision(body: GridQuery | undefined): Observable<OnePForecastRevisionDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetAllForecastRevision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForecastRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForecastRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePForecastRevisionDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePForecastRevisionDTOGridPagedResult>;
        }));
    }

    protected processGetAllForecastRevision(response: HttpResponseBase): Observable<OnePForecastRevisionDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePForecastRevisionDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param forecastSourceEditId (optional) 
     * @param body (optional) 
     * @return OK
     */
    getForecastRevisionCostTotals(forecastSourceEditId: number | undefined, body: GridQuery | undefined): Observable<OnePForecastInitiativeWithBreakInOutDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetForecastRevisionCostTotals?";
        if (forecastSourceEditId === null)
            throw new globalThis.Error("The parameter 'forecastSourceEditId' cannot be null.");
        else if (forecastSourceEditId !== undefined)
            url_ += "forecastSourceEditId=" + encodeURIComponent("" + forecastSourceEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastRevisionCostTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastRevisionCostTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePForecastInitiativeWithBreakInOutDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePForecastInitiativeWithBreakInOutDTOGridPagedResult>;
        }));
    }

    protected processGetForecastRevisionCostTotals(response: HttpResponseBase): Observable<OnePForecastInitiativeWithBreakInOutDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePForecastInitiativeWithBreakInOutDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getForecastPlanInitiativeFact(body: GridQuery | undefined): Observable<OnePInitiativeFactWithForecastPlanDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePForecast/GetForecastPlanInitiativeFact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastPlanInitiativeFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastPlanInitiativeFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeFactWithForecastPlanDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeFactWithForecastPlanDTOGridPagedResult>;
        }));
    }

    protected processGetForecastPlanInitiativeFact(response: HttpResponseBase): Observable<OnePInitiativeFactWithForecastPlanDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeFactWithForecastPlanDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportForecastToExcelFile(body: GetExportForecastActualsQuery | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePForecast/ExportForecastToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportForecastToExcelFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportForecastToExcelFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportForecastToExcelFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    openForecastEdit(): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePForecast/OpenForecastEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenForecastEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenForecastEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpenForecastEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param breakInOutId (optional) 
     * @param revisedOutlook (optional) 
     * @param body (optional) 
     * @return OK
     */
    upsertForecastCostTotals(initiativeId: number | undefined, breakInOutId: number | undefined, revisedOutlook: number | undefined, body: OnePProjectCostTotalsDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePForecast/UpsertForecastCostTotals?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (breakInOutId === null)
            throw new globalThis.Error("The parameter 'breakInOutId' cannot be null.");
        else if (breakInOutId !== undefined)
            url_ += "breakInOutId=" + encodeURIComponent("" + breakInOutId) + "&";
        if (revisedOutlook === null)
            throw new globalThis.Error("The parameter 'revisedOutlook' cannot be null.");
        else if (revisedOutlook !== undefined)
            url_ += "revisedOutlook=" + encodeURIComponent("" + revisedOutlook) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertForecastCostTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertForecastCostTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertForecastCostTotals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param revisedOutlook (optional) 
     * @return OK
     */
    seedForecastCTFromInitiativeCT(initiativeId: number | undefined, revisedOutlook: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePForecast/SeedForecastCTFromInitiativeCT?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (revisedOutlook === null)
            throw new globalThis.Error("The parameter 'revisedOutlook' cannot be null.");
        else if (revisedOutlook !== undefined)
            url_ += "revisedOutlook=" + encodeURIComponent("" + revisedOutlook) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeedForecastCTFromInitiativeCT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeedForecastCTFromInitiativeCT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSeedForecastCTFromInitiativeCT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    closeForecastEdit(): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePForecast/CloseForecastEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseForecastEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseForecastEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseForecastEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getGeneralInitiatives(body: GridQuery | undefined): Observable<OnePInitiativeDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetGeneralInitiatives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeDTOGridPagedResult>;
        }));
    }

    protected processGetGeneralInitiatives(response: HttpResponseBase): Observable<OnePInitiativeDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMyInitiatives(body: GridQuery | undefined): Observable<OnePInitiativeDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetMyInitiatives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeDTOGridPagedResult>;
        }));
    }

    protected processGetMyInitiatives(response: HttpResponseBase): Observable<OnePInitiativeDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getInitiativesByCreator(body: GridQuery | undefined): Observable<OnePInitiativeDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetInitiativesByCreator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitiativesByCreator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitiativesByCreator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeDTOGridPagedResult>;
        }));
    }

    protected processGetInitiativesByCreator(response: HttpResponseBase): Observable<OnePInitiativeDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getInitiativesWithApprovedBudget(body: number[] | undefined): Observable<OnePInitiativesWithApprovedBudgetDTO[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetInitiativesWithApprovedBudget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitiativesWithApprovedBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitiativesWithApprovedBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativesWithApprovedBudgetDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativesWithApprovedBudgetDTO[]>;
        }));
    }

    protected processGetInitiativesWithApprovedBudget(response: HttpResponseBase): Observable<OnePInitiativesWithApprovedBudgetDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativesWithApprovedBudgetDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePGeneralInitiativeGET(initiativeId: number): Observable<OnePInitiativeDTO> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetInitiativeById{initiativeId}";
        if (initiativeId === undefined || initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePGeneralInitiativeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePGeneralInitiativeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeDTO>;
        }));
    }

    protected processOnePGeneralInitiativeGET(response: HttpResponseBase): Observable<OnePInitiativeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param afeNumber (optional) 
     * @return OK
     */
    checkAfeNumberUniqueness(afeNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/CheckAfeNumberUniqueness?";
        if (afeNumber === null)
            throw new globalThis.Error("The parameter 'afeNumber' cannot be null.");
        else if (afeNumber !== undefined)
            url_ += "afeNumber=" + encodeURIComponent("" + afeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAfeNumberUniqueness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAfeNumberUniqueness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckAfeNumberUniqueness(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param year (optional) 
     * @return OK
     */
    getInitiativeCostTotals(initiativeId: number | undefined, year: number | undefined): Observable<OnePProjectCostTotalsWithActualsFlagDTO> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetInitiativeCostTotals?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitiativeCostTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitiativeCostTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectCostTotalsWithActualsFlagDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectCostTotalsWithActualsFlagDTO>;
        }));
    }

    protected processGetInitiativeCostTotals(response: HttpResponseBase): Observable<OnePProjectCostTotalsWithActualsFlagDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectCostTotalsWithActualsFlagDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectYear (optional) 
     * @return OK
     */
    getInitiativeCostTotalsForAllInitiatives(projectYear: number | undefined): Observable<OnePInitiativesCostTotalsWithFlagsDTO[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetInitiativeCostTotalsForAllInitiatives?";
        if (projectYear === null)
            throw new globalThis.Error("The parameter 'projectYear' cannot be null.");
        else if (projectYear !== undefined)
            url_ += "projectYear=" + encodeURIComponent("" + projectYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitiativeCostTotalsForAllInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitiativeCostTotalsForAllInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativesCostTotalsWithFlagsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativesCostTotalsWithFlagsDTO[]>;
        }));
    }

    protected processGetInitiativeCostTotalsForAllInitiatives(response: HttpResponseBase): Observable<OnePInitiativesCostTotalsWithFlagsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativesCostTotalsWithFlagsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param identifier (optional) 
     * @return OK
     */
    findPSWSPerson(identifier: string | undefined): Observable<ExtPswsDimPersonInfoSearchedResultDTO> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/FindPSWSPerson?";
        if (identifier === null)
            throw new globalThis.Error("The parameter 'identifier' cannot be null.");
        else if (identifier !== undefined)
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindPSWSPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindPSWSPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtPswsDimPersonInfoSearchedResultDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtPswsDimPersonInfoSearchedResultDTO>;
        }));
    }

    protected processFindPSWSPerson(response: HttpResponseBase): Observable<ExtPswsDimPersonInfoSearchedResultDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtPswsDimPersonInfoSearchedResultDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param search (optional) 
     * @return OK
     */
    onePGeneralInitiativeAll(search: string | undefined, type: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetAllProjectId{type}?";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePGeneralInitiativeAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePGeneralInitiativeAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processOnePGeneralInitiativeAll(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param search (optional) 
     * @return OK
     */
    getAllProjectAFE(search: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetAllProjectAFE?";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectAFE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectAFE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllProjectAFE(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param ownEmail (optional) 
     * @return OK
     */
    getUserInitiativeScopesByEmail(initiativeId: number | undefined, ownEmail: string | undefined): Observable<OnePInitiativeScopesByEmailDTO> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetUserInitiativeScopesByEmail?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (ownEmail === null)
            throw new globalThis.Error("The parameter 'ownEmail' cannot be null.");
        else if (ownEmail !== undefined)
            url_ += "ownEmail=" + encodeURIComponent("" + ownEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInitiativeScopesByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInitiativeScopesByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeScopesByEmailDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeScopesByEmailDTO>;
        }));
    }

    protected processGetUserInitiativeScopesByEmail(response: HttpResponseBase): Observable<OnePInitiativeScopesByEmailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeScopesByEmailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getInitiativeComplexities(): Observable<OnePInitiativeComplexityDTO[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetInitiativeComplexities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInitiativeComplexities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInitiativeComplexities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeComplexityDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeComplexityDTO[]>;
        }));
    }

    protected processGetInitiativeComplexities(response: HttpResponseBase): Observable<OnePInitiativeComplexityDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativeComplexityDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getRelatedCarriedOverInitiatives(id: number | undefined): Observable<OnePInitiativeDTO[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetRelatedCarriedOverInitiatives?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatedCarriedOverInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedCarriedOverInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeDTO[]>;
        }));
    }

    protected processGetRelatedCarriedOverInitiatives(response: HttpResponseBase): Observable<OnePInitiativeDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativeDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    getProjectAuditHistory(initiativeId: number | undefined, from: Date | undefined, to: Date | undefined): Observable<OnePProjectAuditHistoryItemDTO[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetProjectAuditHistory?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectAuditHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectAuditHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectAuditHistoryItemDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectAuditHistoryItemDTO[]>;
        }));
    }

    protected processGetProjectAuditHistory(response: HttpResponseBase): Observable<OnePProjectAuditHistoryItemDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePProjectAuditHistoryItemDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectYear (optional) 
     * @return OK
     */
    getAllCarriedOverFinanceStatusInitiatives(projectYear: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetAllCarriedOverFinanceStatusInitiatives?";
        if (projectYear === null)
            throw new globalThis.Error("The parameter 'projectYear' cannot be null.");
        else if (projectYear !== undefined)
            url_ += "projectYear=" + encodeURIComponent("" + projectYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCarriedOverFinanceStatusInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCarriedOverFinanceStatusInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllCarriedOverFinanceStatusInitiatives(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param link (optional) 
     * @return OK
     */
    getRiptDataByLink(link: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetRiptDataByLink?";
        if (link === null)
            throw new globalThis.Error("The parameter 'link' cannot be null.");
        else if (link !== undefined)
            url_ += "link=" + encodeURIComponent("" + link) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRiptDataByLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiptDataByLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRiptDataByLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMyApprovalInitiatives(body: GridQuery | undefined): Observable<OnePApprovalInitiativesReadDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/GetMyApprovalInitiatives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyApprovalInitiatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyApprovalInitiatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePApprovalInitiativesReadDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePApprovalInitiativesReadDTOGridPagedResult>;
        }));
    }

    protected processGetMyApprovalInitiatives(response: HttpResponseBase): Observable<OnePApprovalInitiativesReadDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePApprovalInitiativesReadDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createGeneralInitiative(body: CreateInitiativeCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/CreateGeneralInitiative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGeneralInitiative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGeneralInitiative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateGeneralInitiative(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeCarriedOverProject(body: CreateInitiativeCarriedOverProjectCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/CreateInitiativeCarriedOverProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeCarriedOverProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeCarriedOverProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeCarriedOverProject(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    copyInitiativeCapexProject(body: CopyInitiativeCapexProjectCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/CopyInitiativeCapexProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyInitiativeCapexProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyInitiativeCapexProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCopyInitiativeCapexProject(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeCoordinator(body: CreateInitiativeCoordinatorCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/CreateInitiativeCoordinator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeCoordinator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeCoordinator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeCoordinator(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onePGeneralInitiativePOST(initiativeId: number, body: OnePProjectCostTotalsDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpsertInitiativeCostTotals{initiativeId}";
        if (initiativeId === undefined || initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePGeneralInitiativePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePGeneralInitiativePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePGeneralInitiativePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onePGeneralInitiativePOST2(initiativeId: number, body: OnePProjectCostTotalsDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpdateInitiativeCostTotalsExecution{initiativeId}";
        if (initiativeId === undefined || initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePGeneralInitiativePOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePGeneralInitiativePOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePGeneralInitiativePOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    onePGeneralInitiativePOST3(initiativeId: number, body: OnePProjectCostTotalsDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/CopyInitiativeCostTotals{initiativeId}";
        if (initiativeId === undefined || initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePGeneralInitiativePOST3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePGeneralInitiativePOST3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePGeneralInitiativePOST3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInitiative(body: UpdateInitiativeCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpdateInitiative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInitiative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInitiative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInitiative(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProjectTotalCostField(body: UpdateProjectTotalCostFieldCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpdateProjectTotalCostField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectTotalCostField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectTotalCostField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProjectTotalCostField(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInitiativeCoordinator(body: UpdateInitiativeCoordinatorCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpdateInitiativeCoordinator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInitiativeCoordinator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInitiativeCoordinator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInitiativeCoordinator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upsertCostController(body: UpsertCostControllerCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpsertCostController";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCostController(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCostController(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertCostController(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInitiativeStage(body: UpdateInitiativeStageCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpdateInitiativeStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInitiativeStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInitiativeStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInitiativeStage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePGeneralInitiativePUT(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/CancelInitiative{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePGeneralInitiativePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePGeneralInitiativePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePGeneralInitiativePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInitiativeComplexity(body: UpdateInitiativeComplexityCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpdateInitiativeComplexity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInitiativeComplexity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInitiativeComplexity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInitiativeComplexity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateForecastUpdatedField(body: UpdateForecastUpdatedFieldCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/UpdateForecastUpdatedField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForecastUpdatedField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForecastUpdatedField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateForecastUpdatedField(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePGeneralInitiativeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePGeneralInitiative/DeleteInitiativeCostTotals{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePGeneralInitiativeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePGeneralInitiativeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePGeneralInitiativeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActualCostCodeDictionaries(): Observable<OnePInitiativeActualCostCodeDictionaryDTO[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeActuals/GetActualCostCodeDictionaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualCostCodeDictionaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualCostCodeDictionaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeActualCostCodeDictionaryDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeActualCostCodeDictionaryDTO[]>;
        }));
    }

    protected processGetActualCostCodeDictionaries(response: HttpResponseBase): Observable<OnePInitiativeActualCostCodeDictionaryDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativeActualCostCodeDictionaryDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeActualsGET(id: number): Observable<OnePInitiativeActualCostCodeDictionary> {
        let url_ = this.baseUrl + "/api/OnePInitiativeActuals/GetActualCostCodeDictionaryById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeActualsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeActualsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeActualCostCodeDictionary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeActualCostCodeDictionary>;
        }));
    }

    protected processOnePInitiativeActualsGET(response: HttpResponseBase): Observable<OnePInitiativeActualCostCodeDictionary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeActualCostCodeDictionary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createActualCostCodeDictionary(body: CreateActualCostCodeDictionariesCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePInitiativeActuals/CreateActualCostCodeDictionary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActualCostCodeDictionary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActualCostCodeDictionary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateActualCostCodeDictionary(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateActualCostCodeDictionary(body: UpdateActualCostCodeDictionariesCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeActuals/UpdateActualCostCodeDictionary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActualCostCodeDictionary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActualCostCodeDictionary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActualCostCodeDictionary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeActualsDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeActuals/DeleteActualCostCodeDictionary{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeActualsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeActualsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePInitiativeActualsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeLink(initiativeId: number): Observable<OnePInitiativeLinkListDTO> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllLinksByInitiativeId{initiativeId}";
        if (initiativeId === undefined || initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeLinkListDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeLinkListDTO>;
        }));
    }

    protected processOnePInitiativeLink(response: HttpResponseBase): Observable<OnePInitiativeLinkListDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeLinkListDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeLinkAll(badActorId: string): Observable<ExtBadActorData[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetBadActorById{badActorId}";
        if (badActorId === undefined || badActorId === null)
            throw new globalThis.Error("The parameter 'badActorId' must be defined.");
        url_ = url_.replace("{badActorId}", encodeURIComponent("" + badActorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeLinkAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeLinkAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtBadActorData[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtBadActorData[]>;
        }));
    }

    protected processOnePInitiativeLinkAll(response: HttpResponseBase): Observable<ExtBadActorData[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExtBadActorData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeLinkAll2(ewrId: string): Observable<ExtEwr[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetEwrById{ewrId}";
        if (ewrId === undefined || ewrId === null)
            throw new globalThis.Error("The parameter 'ewrId' must be defined.");
        url_ = url_.replace("{ewrId}", encodeURIComponent("" + ewrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeLinkAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeLinkAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtEwr[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtEwr[]>;
        }));
    }

    protected processOnePInitiativeLinkAll2(response: HttpResponseBase): Observable<ExtEwr[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExtEwr.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeLinkAll3(fdmId: string): Observable<ExtFdm[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetFdmById{fdmId}";
        if (fdmId === undefined || fdmId === null)
            throw new globalThis.Error("The parameter 'fdmId' must be defined.");
        url_ = url_.replace("{fdmId}", encodeURIComponent("" + fdmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeLinkAll3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeLinkAll3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtFdm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtFdm[]>;
        }));
    }

    protected processOnePInitiativeLinkAll3(response: HttpResponseBase): Observable<ExtFdm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExtFdm.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWorkOrderItems(): Observable<OnePInitiativeFdmWorkOrder[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllWorkOrderItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeFdmWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeFdmWorkOrder[]>;
        }));
    }

    protected processGetAllWorkOrderItems(response: HttpResponseBase): Observable<OnePInitiativeFdmWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativeFdmWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeLinkAll4(tagNumber: string): Observable<DimEquipmentDTO[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetDimEquipmentByTagNumber{tagNumber}";
        if (tagNumber === undefined || tagNumber === null)
            throw new globalThis.Error("The parameter 'tagNumber' must be defined.");
        url_ = url_.replace("{tagNumber}", encodeURIComponent("" + tagNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeLinkAll4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeLinkAll4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DimEquipmentDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DimEquipmentDTO[]>;
        }));
    }

    protected processOnePInitiativeLinkAll4(response: HttpResponseBase): Observable<DimEquipmentDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DimEquipmentDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeLink2(workOrderNumberCode: string): Observable<WorkOrderDTO> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetWorkOrderByNumberCode{workOrderNumberCode}";
        if (workOrderNumberCode === undefined || workOrderNumberCode === null)
            throw new globalThis.Error("The parameter 'workOrderNumberCode' must be defined.");
        url_ = url_.replace("{workOrderNumberCode}", encodeURIComponent("" + workOrderNumberCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeLink2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeLink2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderDTO>;
        }));
    }

    protected processOnePInitiativeLink2(response: HttpResponseBase): Observable<WorkOrderDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeLinkAll5(year: number): Observable<OnePTopUnitLevelDetailViewRowDTO[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetTopUnitLevelDetail{year}";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeLinkAll5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeLinkAll5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePTopUnitLevelDetailViewRowDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePTopUnitLevelDetailViewRowDTO[]>;
        }));
    }

    protected processOnePInitiativeLinkAll5(response: HttpResponseBase): Observable<OnePTopUnitLevelDetailViewRowDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePTopUnitLevelDetailViewRowDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllLinks(body: GridQuery | undefined): Observable<OnePInitiativesLinksGridDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllLinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativesLinksGridDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativesLinksGridDTOGridPagedResult>;
        }));
    }

    protected processGetAllLinks(response: HttpResponseBase): Observable<OnePInitiativesLinksGridDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativesLinksGridDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllBadActorItems(body: GridQuery | undefined): Observable<ExtBadActorDataGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllBadActorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBadActorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBadActorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtBadActorDataGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtBadActorDataGridPagedResult>;
        }));
    }

    protected processGetAllBadActorItems(response: HttpResponseBase): Observable<ExtBadActorDataGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtBadActorDataGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllBadActorLinkedEquipments(body: GridQuery | undefined): Observable<OnePBALinkedEquipmentViewRowDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllBadActorLinkedEquipments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBadActorLinkedEquipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBadActorLinkedEquipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePBALinkedEquipmentViewRowDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePBALinkedEquipmentViewRowDTOGridPagedResult>;
        }));
    }

    protected processGetAllBadActorLinkedEquipments(response: HttpResponseBase): Observable<OnePBALinkedEquipmentViewRowDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePBALinkedEquipmentViewRowDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllFdmItems(body: GridQuery | undefined): Observable<ExtFdmGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllFdmItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFdmItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFdmItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtFdmGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtFdmGridPagedResult>;
        }));
    }

    protected processGetAllFdmItems(response: HttpResponseBase): Observable<ExtFdmGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtFdmGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllFdmLinkedEquipments(body: GridQuery | undefined): Observable<OnePFDMLinkedEquipmentViewRowDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllFdmLinkedEquipments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFdmLinkedEquipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFdmLinkedEquipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePFDMLinkedEquipmentViewRowDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePFDMLinkedEquipmentViewRowDTOGridPagedResult>;
        }));
    }

    protected processGetAllFdmLinkedEquipments(response: HttpResponseBase): Observable<OnePFDMLinkedEquipmentViewRowDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePFDMLinkedEquipmentViewRowDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllEwrItems(body: GridQuery | undefined): Observable<ExtEwrGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllEwrItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEwrItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEwrItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtEwrGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtEwrGridPagedResult>;
        }));
    }

    protected processGetAllEwrItems(response: HttpResponseBase): Observable<ExtEwrGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtEwrGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllEquipmentItems(body: GridQuery | undefined): Observable<OnePInitiativeFdmDimEquipmentGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/GetAllEquipmentItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEquipmentItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEquipmentItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeFdmDimEquipmentGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeFdmDimEquipmentGridPagedResult>;
        }));
    }

    protected processGetAllEquipmentItems(response: HttpResponseBase): Observable<OnePInitiativeFdmDimEquipmentGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePInitiativeFdmDimEquipmentGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeBadActorLink(body: CreateInitiativeBALinkCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/CreateInitiativeBadActorLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeBadActorLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeBadActorLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeBadActorLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeEWRLink(body: CreateInitiativeEWRLinkCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/CreateInitiativeEWRLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeEWRLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeEWRLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeEWRLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeFDMLink(body: CreateInitiativeFDMLinkCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/CreateInitiativeFDMLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeFDMLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeFDMLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeFDMLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeEquipmentLink(body: CreateInitiativeEquipmentLinkCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/CreateInitiativeEquipmentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeEquipmentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeEquipmentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeEquipmentLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeWorkOrderLink(body: CreateInitiativeWorkOrderLinkCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/CreateInitiativeWorkOrderLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeWorkOrderLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeWorkOrderLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeWorkOrderLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteInitiativeBadActorLink(body: DeleteInitiativeBALinkCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/DeleteInitiativeBadActorLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInitiativeBadActorLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInitiativeBadActorLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInitiativeBadActorLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteInitiativeEWRLink(body: DeleteInitiativeEWRLinkCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/DeleteInitiativeEWRLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInitiativeEWRLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInitiativeEWRLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInitiativeEWRLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteInitiativeFDMLink(body: DeleteInitiativeFDMLinkCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/DeleteInitiativeFDMLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInitiativeFDMLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInitiativeFDMLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInitiativeFDMLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteInitiativeEquipmentLink(body: DeleteInitiativeEquipmentLinkCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/DeleteInitiativeEquipmentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInitiativeEquipmentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInitiativeEquipmentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInitiativeEquipmentLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteInitiativeWorkOrderLink(body: DeleteInitiativeWorkOrderLinkCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeLink/DeleteInitiativeWorkOrderLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInitiativeWorkOrderLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInitiativeWorkOrderLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInitiativeWorkOrderLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeNoteAll(initiativeId: number): Observable<OnePInitiativeNoteDTO[]> {
        let url_ = this.baseUrl + "/api/OnePInitiativeNote/GetInitiativeNotesByInitiativeId{initiativeId}";
        if (initiativeId === undefined || initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeNoteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeNoteAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePInitiativeNoteDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePInitiativeNoteDTO[]>;
        }));
    }

    protected processOnePInitiativeNoteAll(response: HttpResponseBase): Observable<OnePInitiativeNoteDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePInitiativeNoteDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createInitiativeNote(body: CreateInitiativeNoteCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePInitiativeNote/CreateInitiativeNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInitiativeNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInitiativeNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInitiativeNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInitiativeNote(body: UpdateInitiativeNoteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeNote/UpdateInitiativeNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInitiativeNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInitiativeNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInitiativeNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePInitiativeNote(pk: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePInitiativeNote/DeleteInitiativeNote{pk}";
        if (pk === undefined || pk === null)
            throw new globalThis.Error("The parameter 'pk' must be defined.");
        url_ = url_.replace("{pk}", encodeURIComponent("" + pk));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePInitiativeNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePInitiativeNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePInitiativeNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePMasterInitiativeLink(pk: number): Observable<OnePMasterInitiativeLink> {
        let url_ = this.baseUrl + "/api/OnePMasterInitiativeLink/GetDetailedMasterInitiativeLinkByPk{pk}";
        if (pk === undefined || pk === null)
            throw new globalThis.Error("The parameter 'pk' must be defined.");
        url_ = url_.replace("{pk}", encodeURIComponent("" + pk));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePMasterInitiativeLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePMasterInitiativeLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePMasterInitiativeLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePMasterInitiativeLink>;
        }));
    }

    protected processOnePMasterInitiativeLink(response: HttpResponseBase): Observable<OnePMasterInitiativeLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePMasterInitiativeLink.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePMasterInitiativeLinkAll(initiativeId: number): Observable<OnePMasterInitiativeLink[]> {
        let url_ = this.baseUrl + "/api/OnePMasterInitiativeLink/GetDetailedMasterInitiativeLinksByInitiativeId{initiativeId}";
        if (initiativeId === undefined || initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePMasterInitiativeLinkAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePMasterInitiativeLinkAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePMasterInitiativeLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePMasterInitiativeLink[]>;
        }));
    }

    protected processOnePMasterInitiativeLinkAll(response: HttpResponseBase): Observable<OnePMasterInitiativeLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePMasterInitiativeLink.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllMasterInitiativeLinks(): Observable<OnePMasterInitiativeLinksDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMasterInitiativeLink/GetAllMasterInitiativeLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterInitiativeLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterInitiativeLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePMasterInitiativeLinksDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePMasterInitiativeLinksDTO[]>;
        }));
    }

    protected processGetAllMasterInitiativeLinks(response: HttpResponseBase): Observable<OnePMasterInitiativeLinksDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePMasterInitiativeLinksDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllMasterLinkedProjects(body: GridQuery | undefined): Observable<OnePMasterLinkedProjectsDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePMasterInitiativeLink/GetAllMasterLinkedProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMasterLinkedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterLinkedProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePMasterLinkedProjectsDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePMasterLinkedProjectsDTOGridPagedResult>;
        }));
    }

    protected processGetAllMasterLinkedProjects(response: HttpResponseBase): Observable<OnePMasterLinkedProjectsDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePMasterLinkedProjectsDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMasterInitiativeLink(body: CreateMasterInitiativeLinkCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePMasterInitiativeLink/CreateMasterInitiativeLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMasterInitiativeLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMasterInitiativeLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMasterInitiativeLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMasterInitiativeLink(body: UpdateMasterInitiativeLinkCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePMasterInitiativeLink/UpdateMasterInitiativeLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMasterInitiativeLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMasterInitiativeLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMasterInitiativeLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    deleteMasterInitiativeLink(body: DeleteMasterInitiativeLinkCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePMasterInitiativeLink/DeleteMasterInitiativeLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMasterInitiativeLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMasterInitiativeLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMasterInitiativeLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMejCutLine(body: ComputeMejCutLineQuery | undefined): Observable<MejCutLineDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMejCutLine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMejCutLine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineDTO[]>;
        }));
    }

    protected processGetMejCutLine(response: HttpResponseBase): Observable<MejCutLineDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    computeMejCutLineByArea(body: ComputeMejCutLineByAreaQuery | undefined): Observable<MejCutLineDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/ComputeMejCutLineByArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeMejCutLineByArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeMejCutLineByArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineDTO[]>;
        }));
    }

    protected processComputeMejCutLineByArea(response: HttpResponseBase): Observable<MejCutLineDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMejCutLineOnlyByBudget(body: ComputeMejCutLineBudgetOnlyQuery | undefined): Observable<MejCutLineDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLineOnlyByBudget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMejCutLineOnlyByBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMejCutLineOnlyByBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineDTO[]>;
        }));
    }

    protected processGetMejCutLineOnlyByBudget(response: HttpResponseBase): Observable<MejCutLineDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMejCutLineScenario(body: CreateCutlineScenarioCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/CreateMejCutLineScenario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMejCutLineScenario(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMejCutLineScenario(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMejCutLineScenario(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectYear (optional) 
     * @return OK
     */
    getCapexInitiativesRiptPriority(projectYear: number | undefined): Observable<MejCutLineDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetCapexInitiativesRiptPriority?";
        if (projectYear === null)
            throw new globalThis.Error("The parameter 'projectYear' cannot be null.");
        else if (projectYear !== undefined)
            url_ += "projectYear=" + encodeURIComponent("" + projectYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCapexInitiativesRiptPriority(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCapexInitiativesRiptPriority(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineDTO[]>;
        }));
    }

    protected processGetCapexInitiativesRiptPriority(response: HttpResponseBase): Observable<MejCutLineDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePMejCutLineGET(id: number): Observable<MejCutLineAreaSettingsDTO> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLineAreaSettingsById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePMejCutLineGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePMejCutLineGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineAreaSettingsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineAreaSettingsDTO>;
        }));
    }

    protected processOnePMejCutLineGET(response: HttpResponseBase): Observable<MejCutLineAreaSettingsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MejCutLineAreaSettingsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMejCutLineAreaSettingsList(): Observable<MejCutLineAreaSettingsDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLineAreaSettingsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMejCutLineAreaSettingsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMejCutLineAreaSettingsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineAreaSettingsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineAreaSettingsDTO[]>;
        }));
    }

    protected processGetMejCutLineAreaSettingsList(response: HttpResponseBase): Observable<MejCutLineAreaSettingsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineAreaSettingsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMejCutLineSettingsList(): Observable<MejCutLineSettingsDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLineSettingsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMejCutLineSettingsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMejCutLineSettingsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineSettingsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineSettingsDTO[]>;
        }));
    }

    protected processGetMejCutLineSettingsList(response: HttpResponseBase): Observable<MejCutLineSettingsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineSettingsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePMejCutLineGET2(id: number): Observable<MejCutLineSettingsDTO> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLineSettingsById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePMejCutLineGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePMejCutLineGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineSettingsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineSettingsDTO>;
        }));
    }

    protected processOnePMejCutLineGET2(response: HttpResponseBase): Observable<MejCutLineSettingsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MejCutLineSettingsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getMejCutLineScenarioList(): Observable<MejCutLineScenarioDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLineScenarioList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMejCutLineScenarioList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMejCutLineScenarioList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineScenarioDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineScenarioDTO[]>;
        }));
    }

    protected processGetMejCutLineScenarioList(response: HttpResponseBase): Observable<MejCutLineScenarioDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineScenarioDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePMejCutLineAll(id: number): Observable<MejCutLineScenarioItemDTO[]> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/GetMejCutLineScenarioItemById{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePMejCutLineAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePMejCutLineAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MejCutLineScenarioItemDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MejCutLineScenarioItemDTO[]>;
        }));
    }

    protected processOnePMejCutLineAll(response: HttpResponseBase): Observable<MejCutLineScenarioItemDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MejCutLineScenarioItemDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMejCutLineSettings(body: CreateMejCutLineSettingsCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/CreateMejCutLineSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMejCutLineSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMejCutLineSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMejCutLineSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMejCutLineAreaSettings(body: CreateMejCutLineAreaSettingsCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/CreateMejCutLineAreaSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMejCutLineAreaSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMejCutLineAreaSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMejCutLineAreaSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMejCutLineSettings(body: UpdateMejCutLineSettingsCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/UpdateMejCutLineSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMejCutLineSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMejCutLineSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMejCutLineSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMejCutLineAreaSettings(body: UpdateMejCutLineAreaSettingsCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/UpdateMejCutLineAreaSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMejCutLineAreaSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMejCutLineAreaSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMejCutLineAreaSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePMejCutLineDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/DeleteMejCutLineSettings{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePMejCutLineDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePMejCutLineDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePMejCutLineDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePMejCutLineDELETE2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePMejCutLine/DeleteMejCutLineAreaSettings{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePMejCutLineDELETE2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePMejCutLineDELETE2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePMejCutLineDELETE2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePNotificationSchedules(forecastEditStatePk: number): Observable<OnePNotificationScheduleSettingDTO[]> {
        let url_ = this.baseUrl + "/api/OnePNotificationSchedules/GetForecastReminderSchedules{forecastEditStatePk}";
        if (forecastEditStatePk === undefined || forecastEditStatePk === null)
            throw new globalThis.Error("The parameter 'forecastEditStatePk' must be defined.");
        url_ = url_.replace("{forecastEditStatePk}", encodeURIComponent("" + forecastEditStatePk));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePNotificationSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePNotificationSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePNotificationScheduleSettingDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePNotificationScheduleSettingDTO[]>;
        }));
    }

    protected processOnePNotificationSchedules(response: HttpResponseBase): Observable<OnePNotificationScheduleSettingDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePNotificationScheduleSettingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param forecastEditStatePk (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateForecastReminderSchedule(forecastEditStatePk: number | undefined, body: Date[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePNotificationSchedules/UpdateForecastReminderSchedule?";
        if (forecastEditStatePk === null)
            throw new globalThis.Error("The parameter 'forecastEditStatePk' cannot be null.");
        else if (forecastEditStatePk !== undefined)
            url_ += "forecastEditStatePk=" + encodeURIComponent("" + forecastEditStatePk) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForecastReminderSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForecastReminderSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateForecastReminderSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllNotificationSettings(): Observable<OnePNotificationSettingDTO[]> {
        let url_ = this.baseUrl + "/api/OnePNotificationSettings/GetAllNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePNotificationSettingDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePNotificationSettingDTO[]>;
        }));
    }

    protected processGetAllNotificationSettings(response: HttpResponseBase): Observable<OnePNotificationSettingDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePNotificationSettingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePNotificationSettings(notificationCode: string): Observable<OnePNotificationSettingDTO> {
        let url_ = this.baseUrl + "/api/OnePNotificationSettings/GetNotificationSettingsByCode{notificationCode}";
        if (notificationCode === undefined || notificationCode === null)
            throw new globalThis.Error("The parameter 'notificationCode' must be defined.");
        url_ = url_.replace("{notificationCode}", encodeURIComponent("" + notificationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePNotificationSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePNotificationSettingDTO>;
        }));
    }

    protected processOnePNotificationSettings(response: HttpResponseBase): Observable<OnePNotificationSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePNotificationSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateNotificationSettings(body: UpdateNotificationSettingsCommand | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/OnePNotificationSettings/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllProjectGeneralSettings(): Observable<OnePProjectGeneralSettingsDTO[]> {
        let url_ = this.baseUrl + "/api/OnePProjectGeneralSettings/GetAllProjectGeneralSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectGeneralSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectGeneralSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectGeneralSettingsDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectGeneralSettingsDTO[]>;
        }));
    }

    protected processGetAllProjectGeneralSettings(response: HttpResponseBase): Observable<OnePProjectGeneralSettingsDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePProjectGeneralSettingsDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePProjectGeneralSettings(key: string): Observable<OnePProjectGeneralSettingsDTO> {
        let url_ = this.baseUrl + "/api/OnePProjectGeneralSettings/GetProjectGeneralSettingsByKey{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePProjectGeneralSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePProjectGeneralSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePProjectGeneralSettingsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePProjectGeneralSettingsDTO>;
        }));
    }

    protected processOnePProjectGeneralSettings(response: HttpResponseBase): Observable<OnePProjectGeneralSettingsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePProjectGeneralSettingsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createProjectGeneralSettings(body: CreateProjectGeneralSettingsCommand | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/OnePProjectGeneralSettings/CreateProjectGeneralSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProjectGeneralSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectGeneralSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateProjectGeneralSettings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateProjectGeneralSettings(body: UpdateProjectGeneralSettingsCommand | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/OnePProjectGeneralSettings/UpdateProjectGeneralSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProjectGeneralSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectGeneralSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateProjectGeneralSettings(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getStagesHistory(): Observable<OnePStageHistoryReadDTO[]> {
        let url_ = this.baseUrl + "/api/OnePStageHistory/GetStagesHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStagesHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStagesHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePStageHistoryReadDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePStageHistoryReadDTO[]>;
        }));
    }

    protected processGetStagesHistory(response: HttpResponseBase): Observable<OnePStageHistoryReadDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePStageHistoryReadDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param initiativeId (optional) 
     * @param body (optional) 
     * @return OK
     */
    getStageBudgetHistory(initiativeId: number | undefined, body: GridQuery | undefined): Observable<StageBudgetHistoryDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePStageHistory/GetStageBudgetHistory?";
        if (initiativeId === null)
            throw new globalThis.Error("The parameter 'initiativeId' cannot be null.");
        else if (initiativeId !== undefined)
            url_ += "initiativeId=" + encodeURIComponent("" + initiativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStageBudgetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStageBudgetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageBudgetHistoryDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageBudgetHistoryDTOGridPagedResult>;
        }));
    }

    protected processGetStageBudgetHistory(response: HttpResponseBase): Observable<StageBudgetHistoryDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StageBudgetHistoryDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllInitiativesStageBudgetHistory(body: GridQuery | undefined): Observable<StageAllInitiativesBudgetHistoryDTOGridPagedResult> {
        let url_ = this.baseUrl + "/api/OnePStageHistory/GetAllInitiativesStageBudgetHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInitiativesStageBudgetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInitiativesStageBudgetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StageAllInitiativesBudgetHistoryDTOGridPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StageAllInitiativesBudgetHistoryDTOGridPagedResult>;
        }));
    }

    protected processGetAllInitiativesStageBudgetHistory(response: HttpResponseBase): Observable<StageAllInitiativesBudgetHistoryDTOGridPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StageAllInitiativesBudgetHistoryDTOGridPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    startUserLoginSession(): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePUserLoginSessions/StartUserLoginSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartUserLoginSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartUserLoginSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartUserLoginSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePUserLoginSessions(sessionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePUserLoginSessions/HeartbeatUserLoginSession{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePUserLoginSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePUserLoginSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePUserLoginSessions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onePUserLoginSessions2(sessionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/OnePUserLoginSessions/EndUserLoginSession{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnePUserLoginSessions2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnePUserLoginSessions2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOnePUserLoginSessions2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum BreakInOutDecision {
    Approved = "Approved",
    Declined = "Declined",
    OnHold = "OnHold",
}

export enum BreakInOutStatus {
    Pending = "Pending",
    Confirmed = "Confirmed",
    Declined = "Declined",
}

export enum BudgetType {
    CAPEX = "CAPEX",
    OPEX = "OPEX",
    NotAssigned = "NotAssigned",
}

export enum CcAfe {
    CostCenter = "CostCenter",
    AFE = "AFE",
}

export class ComputeMejCutLineBudgetOnlyQuery implements IComputeMejCutLineBudgetOnlyQuery {
    year?: number;

    constructor(data?: IComputeMejCutLineBudgetOnlyQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ComputeMejCutLineBudgetOnlyQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeMejCutLineBudgetOnlyQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        return data;
    }
}

export interface IComputeMejCutLineBudgetOnlyQuery {
    year?: number;
}

export class ComputeMejCutLineByAreaQuery implements IComputeMejCutLineByAreaQuery {
    year?: number;
    area?: string | undefined;

    constructor(data?: IComputeMejCutLineByAreaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): ComputeMejCutLineByAreaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeMejCutLineByAreaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["area"] = this.area;
        return data;
    }
}

export interface IComputeMejCutLineByAreaQuery {
    year?: number;
    area?: string | undefined;
}

export class ComputeMejCutLineQuery implements IComputeMejCutLineQuery {
    budget?: number | undefined;
    year?: number;
    inactiveStages?: string[] | undefined;
    inactiveAreas?: string[] | undefined;
    excludedStages?: string[] | undefined;
    excludedFinStatuses?: string[] | undefined;
    excludedBudgetType?: string | undefined;

    constructor(data?: IComputeMejCutLineQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budget = _data["budget"];
            this.year = _data["year"];
            if (Array.isArray(_data["inactiveStages"])) {
                this.inactiveStages = [] as any;
                for (let item of _data["inactiveStages"])
                    this.inactiveStages!.push(item);
            }
            if (Array.isArray(_data["inactiveAreas"])) {
                this.inactiveAreas = [] as any;
                for (let item of _data["inactiveAreas"])
                    this.inactiveAreas!.push(item);
            }
            if (Array.isArray(_data["excludedStages"])) {
                this.excludedStages = [] as any;
                for (let item of _data["excludedStages"])
                    this.excludedStages!.push(item);
            }
            if (Array.isArray(_data["excludedFinStatuses"])) {
                this.excludedFinStatuses = [] as any;
                for (let item of _data["excludedFinStatuses"])
                    this.excludedFinStatuses!.push(item);
            }
            this.excludedBudgetType = _data["excludedBudgetType"];
        }
    }

    static fromJS(data: any): ComputeMejCutLineQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeMejCutLineQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budget"] = this.budget;
        data["year"] = this.year;
        if (Array.isArray(this.inactiveStages)) {
            data["inactiveStages"] = [];
            for (let item of this.inactiveStages)
                data["inactiveStages"].push(item);
        }
        if (Array.isArray(this.inactiveAreas)) {
            data["inactiveAreas"] = [];
            for (let item of this.inactiveAreas)
                data["inactiveAreas"].push(item);
        }
        if (Array.isArray(this.excludedStages)) {
            data["excludedStages"] = [];
            for (let item of this.excludedStages)
                data["excludedStages"].push(item);
        }
        if (Array.isArray(this.excludedFinStatuses)) {
            data["excludedFinStatuses"] = [];
            for (let item of this.excludedFinStatuses)
                data["excludedFinStatuses"].push(item);
        }
        data["excludedBudgetType"] = this.excludedBudgetType;
        return data;
    }
}

export interface IComputeMejCutLineQuery {
    budget?: number | undefined;
    year?: number;
    inactiveStages?: string[] | undefined;
    inactiveAreas?: string[] | undefined;
    excludedStages?: string[] | undefined;
    excludedFinStatuses?: string[] | undefined;
    excludedBudgetType?: string | undefined;
}

export class CopyInitiativeCapexProjectCommand implements ICopyInitiativeCapexProjectCommand {
    initiativeId?: number;

    constructor(data?: ICopyInitiativeCapexProjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
        }
    }

    static fromJS(data: any): CopyInitiativeCapexProjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyInitiativeCapexProjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        return data;
    }
}

export interface ICopyInitiativeCapexProjectCommand {
    initiativeId?: number;
}

export class CreateActualCostCodeDictionariesCommand implements ICreateActualCostCodeDictionariesCommand {
    onePInitiativeActualDTO?: OnePInitiativeActualCostCodeDictionaryDTO;

    constructor(data?: ICreateActualCostCodeDictionariesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePInitiativeActualDTO = _data["onePInitiativeActualDTO"] ? OnePInitiativeActualCostCodeDictionaryDTO.fromJS(_data["onePInitiativeActualDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateActualCostCodeDictionariesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActualCostCodeDictionariesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePInitiativeActualDTO"] = this.onePInitiativeActualDTO ? this.onePInitiativeActualDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateActualCostCodeDictionariesCommand {
    onePInitiativeActualDTO?: OnePInitiativeActualCostCodeDictionaryDTO;
}

export class CreateAreaOwnerCommand implements ICreateAreaOwnerCommand {
    onePAreaOwnerCreateDTO?: OnePAreaOwnerCreateDTO;

    constructor(data?: ICreateAreaOwnerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePAreaOwnerCreateDTO = _data["onePAreaOwnerCreateDTO"] ? OnePAreaOwnerCreateDTO.fromJS(_data["onePAreaOwnerCreateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateAreaOwnerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAreaOwnerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePAreaOwnerCreateDTO"] = this.onePAreaOwnerCreateDTO ? this.onePAreaOwnerCreateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateAreaOwnerCommand {
    onePAreaOwnerCreateDTO?: OnePAreaOwnerCreateDTO;
}

export class CreateBreakInOutCommand implements ICreateBreakInOutCommand {
    onePBreakInOutCreateDTO?: OnePBreakInOutCreateDTO;

    constructor(data?: ICreateBreakInOutCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePBreakInOutCreateDTO = _data["onePBreakInOutCreateDTO"] ? OnePBreakInOutCreateDTO.fromJS(_data["onePBreakInOutCreateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateBreakInOutCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBreakInOutCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePBreakInOutCreateDTO"] = this.onePBreakInOutCreateDTO ? this.onePBreakInOutCreateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateBreakInOutCommand {
    onePBreakInOutCreateDTO?: OnePBreakInOutCreateDTO;
}

export class CreateCutlineScenarioCommand implements ICreateCutlineScenarioCommand {
    name?: string | undefined;
    year?: number;
    comment?: string | undefined;
    filterJson?: string | undefined;
    orderOverrides?: OrderOverride[] | undefined;
    budget?: number | undefined;
    inactiveStages?: string[] | undefined;
    inactiveAreas?: string[] | undefined;
    excludedStages?: string[] | undefined;
    excludedFinStatuses?: string[] | undefined;
    excludedBudgetType?: string | undefined;

    constructor(data?: ICreateCutlineScenarioCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.year = _data["year"];
            this.comment = _data["comment"];
            this.filterJson = _data["filterJson"];
            if (Array.isArray(_data["orderOverrides"])) {
                this.orderOverrides = [] as any;
                for (let item of _data["orderOverrides"])
                    this.orderOverrides!.push(OrderOverride.fromJS(item));
            }
            this.budget = _data["budget"];
            if (Array.isArray(_data["inactiveStages"])) {
                this.inactiveStages = [] as any;
                for (let item of _data["inactiveStages"])
                    this.inactiveStages!.push(item);
            }
            if (Array.isArray(_data["inactiveAreas"])) {
                this.inactiveAreas = [] as any;
                for (let item of _data["inactiveAreas"])
                    this.inactiveAreas!.push(item);
            }
            if (Array.isArray(_data["excludedStages"])) {
                this.excludedStages = [] as any;
                for (let item of _data["excludedStages"])
                    this.excludedStages!.push(item);
            }
            if (Array.isArray(_data["excludedFinStatuses"])) {
                this.excludedFinStatuses = [] as any;
                for (let item of _data["excludedFinStatuses"])
                    this.excludedFinStatuses!.push(item);
            }
            this.excludedBudgetType = _data["excludedBudgetType"];
        }
    }

    static fromJS(data: any): CreateCutlineScenarioCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCutlineScenarioCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["year"] = this.year;
        data["comment"] = this.comment;
        data["filterJson"] = this.filterJson;
        if (Array.isArray(this.orderOverrides)) {
            data["orderOverrides"] = [];
            for (let item of this.orderOverrides)
                data["orderOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        data["budget"] = this.budget;
        if (Array.isArray(this.inactiveStages)) {
            data["inactiveStages"] = [];
            for (let item of this.inactiveStages)
                data["inactiveStages"].push(item);
        }
        if (Array.isArray(this.inactiveAreas)) {
            data["inactiveAreas"] = [];
            for (let item of this.inactiveAreas)
                data["inactiveAreas"].push(item);
        }
        if (Array.isArray(this.excludedStages)) {
            data["excludedStages"] = [];
            for (let item of this.excludedStages)
                data["excludedStages"].push(item);
        }
        if (Array.isArray(this.excludedFinStatuses)) {
            data["excludedFinStatuses"] = [];
            for (let item of this.excludedFinStatuses)
                data["excludedFinStatuses"].push(item);
        }
        data["excludedBudgetType"] = this.excludedBudgetType;
        return data;
    }
}

export interface ICreateCutlineScenarioCommand {
    name?: string | undefined;
    year?: number;
    comment?: string | undefined;
    filterJson?: string | undefined;
    orderOverrides?: OrderOverride[] | undefined;
    budget?: number | undefined;
    inactiveStages?: string[] | undefined;
    inactiveAreas?: string[] | undefined;
    excludedStages?: string[] | undefined;
    excludedFinStatuses?: string[] | undefined;
    excludedBudgetType?: string | undefined;
}

export class CreateFinanceStatusCommand implements ICreateFinanceStatusCommand {
    onePFinanceStatusDTO?: OnePFinanceStatusCreateUpdateDTO;

    constructor(data?: ICreateFinanceStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePFinanceStatusDTO = _data["onePFinanceStatusDTO"] ? OnePFinanceStatusCreateUpdateDTO.fromJS(_data["onePFinanceStatusDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateFinanceStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinanceStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePFinanceStatusDTO"] = this.onePFinanceStatusDTO ? this.onePFinanceStatusDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateFinanceStatusCommand {
    onePFinanceStatusDTO?: OnePFinanceStatusCreateUpdateDTO;
}

export class CreateInitiativeBALinkCommand implements ICreateInitiativeBALinkCommand {
    linkDTO?: OnePInitiativeCreateLinkDTO;

    constructor(data?: ICreateInitiativeBALinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkDTO = _data["linkDTO"] ? OnePInitiativeCreateLinkDTO.fromJS(_data["linkDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateInitiativeBALinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeBALinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkDTO"] = this.linkDTO ? this.linkDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateInitiativeBALinkCommand {
    linkDTO?: OnePInitiativeCreateLinkDTO;
}

export class CreateInitiativeCarriedOverProjectCommand implements ICreateInitiativeCarriedOverProjectCommand {
    initiativeId?: number;

    constructor(data?: ICreateInitiativeCarriedOverProjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
        }
    }

    static fromJS(data: any): CreateInitiativeCarriedOverProjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeCarriedOverProjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        return data;
    }
}

export interface ICreateInitiativeCarriedOverProjectCommand {
    initiativeId?: number;
}

export class CreateInitiativeCommand implements ICreateInitiativeCommand {
    onePInitiativeDTO?: OnePInitiativeDTO;

    constructor(data?: ICreateInitiativeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePInitiativeDTO = _data["onePInitiativeDTO"] ? OnePInitiativeDTO.fromJS(_data["onePInitiativeDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateInitiativeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePInitiativeDTO"] = this.onePInitiativeDTO ? this.onePInitiativeDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateInitiativeCommand {
    onePInitiativeDTO?: OnePInitiativeDTO;
}

export class CreateInitiativeCoordinatorCommand implements ICreateInitiativeCoordinatorCommand {
    createDTO?: OnePInitiativeCoordinatorCreateUpdateDTO;

    constructor(data?: ICreateInitiativeCoordinatorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createDTO = _data["createDTO"] ? OnePInitiativeCoordinatorCreateUpdateDTO.fromJS(_data["createDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateInitiativeCoordinatorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeCoordinatorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDTO"] = this.createDTO ? this.createDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateInitiativeCoordinatorCommand {
    createDTO?: OnePInitiativeCoordinatorCreateUpdateDTO;
}

export class CreateInitiativeEWRLinkCommand implements ICreateInitiativeEWRLinkCommand {
    linkDTO?: OnePInitiativeCreateLinkDTO;

    constructor(data?: ICreateInitiativeEWRLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkDTO = _data["linkDTO"] ? OnePInitiativeCreateLinkDTO.fromJS(_data["linkDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateInitiativeEWRLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeEWRLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkDTO"] = this.linkDTO ? this.linkDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateInitiativeEWRLinkCommand {
    linkDTO?: OnePInitiativeCreateLinkDTO;
}

export class CreateInitiativeEquipmentLinkCommand implements ICreateInitiativeEquipmentLinkCommand {
    initiativeId?: number;
    id?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;

    constructor(data?: ICreateInitiativeEquipmentLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.id = _data["id"];
            this.tagNumber = _data["tagNumber"];
            this.sourceSystem = _data["sourceSystem"];
        }
    }

    static fromJS(data: any): CreateInitiativeEquipmentLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeEquipmentLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["id"] = this.id;
        data["tagNumber"] = this.tagNumber;
        data["sourceSystem"] = this.sourceSystem;
        return data;
    }
}

export interface ICreateInitiativeEquipmentLinkCommand {
    initiativeId?: number;
    id?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;
}

export class CreateInitiativeFDMLinkCommand implements ICreateInitiativeFDMLinkCommand {
    linkDTO?: OnePInitiativeCreateLinkDTO;

    constructor(data?: ICreateInitiativeFDMLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkDTO = _data["linkDTO"] ? OnePInitiativeCreateLinkDTO.fromJS(_data["linkDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateInitiativeFDMLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeFDMLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkDTO"] = this.linkDTO ? this.linkDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateInitiativeFDMLinkCommand {
    linkDTO?: OnePInitiativeCreateLinkDTO;
}

export class CreateInitiativeNoteCommand implements ICreateInitiativeNoteCommand {
    initiaitveFk?: number;
    comment?: string | undefined;
    attachmentId?: string | undefined;

    constructor(data?: ICreateInitiativeNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiaitveFk = _data["initiaitveFk"];
            this.comment = _data["comment"];
            this.attachmentId = _data["attachmentId"];
        }
    }

    static fromJS(data: any): CreateInitiativeNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiaitveFk"] = this.initiaitveFk;
        data["comment"] = this.comment;
        data["attachmentId"] = this.attachmentId;
        return data;
    }
}

export interface ICreateInitiativeNoteCommand {
    initiaitveFk?: number;
    comment?: string | undefined;
    attachmentId?: string | undefined;
}

export class CreateInitiativeWorkOrderLinkCommand implements ICreateInitiativeWorkOrderLinkCommand {
    initiativeId?: number;
    workOrderNumberCode?: string | undefined;

    constructor(data?: ICreateInitiativeWorkOrderLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.workOrderNumberCode = _data["workOrderNumberCode"];
        }
    }

    static fromJS(data: any): CreateInitiativeWorkOrderLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInitiativeWorkOrderLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["workOrderNumberCode"] = this.workOrderNumberCode;
        return data;
    }
}

export interface ICreateInitiativeWorkOrderLinkCommand {
    initiativeId?: number;
    workOrderNumberCode?: string | undefined;
}

export class CreateMasterInitiativeLinkCommand implements ICreateMasterInitiativeLinkCommand {
    primaryInitiativePk?: number;
    secondaryInitiativePk?: number;

    constructor(data?: ICreateMasterInitiativeLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryInitiativePk = _data["primaryInitiativePk"];
            this.secondaryInitiativePk = _data["secondaryInitiativePk"];
        }
    }

    static fromJS(data: any): CreateMasterInitiativeLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMasterInitiativeLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryInitiativePk"] = this.primaryInitiativePk;
        data["secondaryInitiativePk"] = this.secondaryInitiativePk;
        return data;
    }
}

export interface ICreateMasterInitiativeLinkCommand {
    primaryInitiativePk?: number;
    secondaryInitiativePk?: number;
}

export class CreateMciProgramCommand implements ICreateMciProgramCommand {
    onePMciProgramDTO?: OnePMciProgramCreateUpdateDTO;

    constructor(data?: ICreateMciProgramCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePMciProgramDTO = _data["onePMciProgramDTO"] ? OnePMciProgramCreateUpdateDTO.fromJS(_data["onePMciProgramDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateMciProgramCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMciProgramCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePMciProgramDTO"] = this.onePMciProgramDTO ? this.onePMciProgramDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateMciProgramCommand {
    onePMciProgramDTO?: OnePMciProgramCreateUpdateDTO;
}

export class CreateMejCutLineAreaSettingsCommand implements ICreateMejCutLineAreaSettingsCommand {
    mejCutLineAreaSettingsDTO?: MejCutLineAreaSettingsDTO;

    constructor(data?: ICreateMejCutLineAreaSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mejCutLineAreaSettingsDTO = _data["mejCutLineAreaSettingsDTO"] ? MejCutLineAreaSettingsDTO.fromJS(_data["mejCutLineAreaSettingsDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateMejCutLineAreaSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMejCutLineAreaSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mejCutLineAreaSettingsDTO"] = this.mejCutLineAreaSettingsDTO ? this.mejCutLineAreaSettingsDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateMejCutLineAreaSettingsCommand {
    mejCutLineAreaSettingsDTO?: MejCutLineAreaSettingsDTO;
}

export class CreateMejCutLineSettingsCommand implements ICreateMejCutLineSettingsCommand {
    cutLineSettingsDTO?: MejCutLineSettingsDTO;

    constructor(data?: ICreateMejCutLineSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cutLineSettingsDTO = _data["cutLineSettingsDTO"] ? MejCutLineSettingsDTO.fromJS(_data["cutLineSettingsDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateMejCutLineSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMejCutLineSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cutLineSettingsDTO"] = this.cutLineSettingsDTO ? this.cutLineSettingsDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateMejCutLineSettingsCommand {
    cutLineSettingsDTO?: MejCutLineSettingsDTO;
}

export class CreateProjectCoordinatorCommand implements ICreateProjectCoordinatorCommand {
    projectCoordinatorCreateUpdateDTO?: OnePProjectCoordinatorCreateUpdateDTO;

    constructor(data?: ICreateProjectCoordinatorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectCoordinatorCreateUpdateDTO = _data["projectCoordinatorCreateUpdateDTO"] ? OnePProjectCoordinatorCreateUpdateDTO.fromJS(_data["projectCoordinatorCreateUpdateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProjectCoordinatorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectCoordinatorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectCoordinatorCreateUpdateDTO"] = this.projectCoordinatorCreateUpdateDTO ? this.projectCoordinatorCreateUpdateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateProjectCoordinatorCommand {
    projectCoordinatorCreateUpdateDTO?: OnePProjectCoordinatorCreateUpdateDTO;
}

export class CreateProjectGeneralSettingsCommand implements ICreateProjectGeneralSettingsCommand {
    key?: string | undefined;
    valueType?: ProjectGeneralSettingsValueType;
    value?: string | undefined;
    description?: string | undefined;
    modifiedOn?: Date;

    constructor(data?: ICreateProjectGeneralSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.valueType = _data["valueType"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProjectGeneralSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectGeneralSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["valueType"] = this.valueType;
        data["value"] = this.value;
        data["description"] = this.description;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateProjectGeneralSettingsCommand {
    key?: string | undefined;
    valueType?: ProjectGeneralSettingsValueType;
    value?: string | undefined;
    description?: string | undefined;
    modifiedOn?: Date;
}

export class CreateProjectTeamCommand implements ICreateProjectTeamCommand {
    onePProjectTeamCreateDTO?: OnePProjectTeamCreateDTO;

    constructor(data?: ICreateProjectTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePProjectTeamCreateDTO = _data["onePProjectTeamCreateDTO"] ? OnePProjectTeamCreateDTO.fromJS(_data["onePProjectTeamCreateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProjectTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePProjectTeamCreateDTO"] = this.onePProjectTeamCreateDTO ? this.onePProjectTeamCreateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateProjectTeamCommand {
    onePProjectTeamCreateDTO?: OnePProjectTeamCreateDTO;
}

export class DeleteInitiativeBALinkCommand implements IDeleteInitiativeBALinkCommand {
    initiativeId?: number;
    badActorId?: string;

    constructor(data?: IDeleteInitiativeBALinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.badActorId = _data["badActorId"];
        }
    }

    static fromJS(data: any): DeleteInitiativeBALinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInitiativeBALinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["badActorId"] = this.badActorId;
        return data;
    }
}

export interface IDeleteInitiativeBALinkCommand {
    initiativeId?: number;
    badActorId?: string;
}

export class DeleteInitiativeEWRLinkCommand implements IDeleteInitiativeEWRLinkCommand {
    initiativeId?: number;
    ewrId?: string;

    constructor(data?: IDeleteInitiativeEWRLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.ewrId = _data["ewrId"];
        }
    }

    static fromJS(data: any): DeleteInitiativeEWRLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInitiativeEWRLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["ewrId"] = this.ewrId;
        return data;
    }
}

export interface IDeleteInitiativeEWRLinkCommand {
    initiativeId?: number;
    ewrId?: string;
}

export class DeleteInitiativeEquipmentLinkCommand implements IDeleteInitiativeEquipmentLinkCommand {
    linkId?: number;

    constructor(data?: IDeleteInitiativeEquipmentLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkId = _data["linkId"];
        }
    }

    static fromJS(data: any): DeleteInitiativeEquipmentLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInitiativeEquipmentLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkId"] = this.linkId;
        return data;
    }
}

export interface IDeleteInitiativeEquipmentLinkCommand {
    linkId?: number;
}

export class DeleteInitiativeFDMLinkCommand implements IDeleteInitiativeFDMLinkCommand {
    initiativeId?: number;
    fdmId?: string;

    constructor(data?: IDeleteInitiativeFDMLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.fdmId = _data["fdmId"];
        }
    }

    static fromJS(data: any): DeleteInitiativeFDMLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInitiativeFDMLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["fdmId"] = this.fdmId;
        return data;
    }
}

export interface IDeleteInitiativeFDMLinkCommand {
    initiativeId?: number;
    fdmId?: string;
}

export class DeleteInitiativeWorkOrderLinkCommand implements IDeleteInitiativeWorkOrderLinkCommand {
    linkId?: number;

    constructor(data?: IDeleteInitiativeWorkOrderLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkId = _data["linkId"];
        }
    }

    static fromJS(data: any): DeleteInitiativeWorkOrderLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInitiativeWorkOrderLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkId"] = this.linkId;
        return data;
    }
}

export interface IDeleteInitiativeWorkOrderLinkCommand {
    linkId?: number;
}

export class DeleteMasterInitiativeLinkCommand implements IDeleteMasterInitiativeLinkCommand {
    masterlinkPk?: number;

    constructor(data?: IDeleteMasterInitiativeLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.masterlinkPk = _data["masterlinkPk"];
        }
    }

    static fromJS(data: any): DeleteMasterInitiativeLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMasterInitiativeLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterlinkPk"] = this.masterlinkPk;
        return data;
    }
}

export interface IDeleteMasterInitiativeLinkCommand {
    masterlinkPk?: number;
}

export class DimEquipmentDTO implements IDimEquipmentDTO {
    id?: string | undefined;
    e1Id?: string | undefined;
    tagNumber?: string | undefined;
    descriptionEn?: string | undefined;
    descriptionRu?: string | undefined;
    sourceSystem?: string | undefined;
    statusCode?: string | undefined;
    integrityCriticalityCode?: string | undefined;
    integrityCriticalityDescription?: string | undefined;
    equipmentCriticalityCode?: string | undefined;
    equipmentCriticalityDescription?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;
    systemGroupCode?: string | undefined;
    systemGroupDescription?: string | undefined;
    classCode?: string | undefined;
    classDescription?: string | undefined;
    subClassCode?: string | undefined;
    subClassDescription?: string | undefined;
    serialNumber?: string | undefined;
    capsPlant?: number | undefined;
    capsUnit?: number | undefined;
    capsInspector?: number | undefined;
    equipmentType?: number | undefined;
    businessUnit?: string | undefined;
    costObjectBusinessUnit?: string | undefined;
    description3?: string | undefined;
    remark2?: string | undefined;
    faacl7?: string | undefined;

    constructor(data?: IDimEquipmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.e1Id = _data["e1Id"];
            this.tagNumber = _data["tagNumber"];
            this.descriptionEn = _data["descriptionEn"];
            this.descriptionRu = _data["descriptionRu"];
            this.sourceSystem = _data["sourceSystem"];
            this.statusCode = _data["statusCode"];
            this.integrityCriticalityCode = _data["integrityCriticalityCode"];
            this.integrityCriticalityDescription = _data["integrityCriticalityDescription"];
            this.equipmentCriticalityCode = _data["equipmentCriticalityCode"];
            this.equipmentCriticalityDescription = _data["equipmentCriticalityDescription"];
            this.facilityCode = _data["facilityCode"];
            this.facilityDescription = _data["facilityDescription"];
            this.areaCode = _data["areaCode"];
            this.areaDescription = _data["areaDescription"];
            this.unitCode = _data["unitCode"];
            this.unitDescription = _data["unitDescription"];
            this.systemGroupCode = _data["systemGroupCode"];
            this.systemGroupDescription = _data["systemGroupDescription"];
            this.classCode = _data["classCode"];
            this.classDescription = _data["classDescription"];
            this.subClassCode = _data["subClassCode"];
            this.subClassDescription = _data["subClassDescription"];
            this.serialNumber = _data["serialNumber"];
            this.capsPlant = _data["capsPlant"];
            this.capsUnit = _data["capsUnit"];
            this.capsInspector = _data["capsInspector"];
            this.equipmentType = _data["equipmentType"];
            this.businessUnit = _data["businessUnit"];
            this.costObjectBusinessUnit = _data["costObjectBusinessUnit"];
            this.description3 = _data["description3"];
            this.remark2 = _data["remark2"];
            this.faacl7 = _data["faacl7"];
        }
    }

    static fromJS(data: any): DimEquipmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DimEquipmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["e1Id"] = this.e1Id;
        data["tagNumber"] = this.tagNumber;
        data["descriptionEn"] = this.descriptionEn;
        data["descriptionRu"] = this.descriptionRu;
        data["sourceSystem"] = this.sourceSystem;
        data["statusCode"] = this.statusCode;
        data["integrityCriticalityCode"] = this.integrityCriticalityCode;
        data["integrityCriticalityDescription"] = this.integrityCriticalityDescription;
        data["equipmentCriticalityCode"] = this.equipmentCriticalityCode;
        data["equipmentCriticalityDescription"] = this.equipmentCriticalityDescription;
        data["facilityCode"] = this.facilityCode;
        data["facilityDescription"] = this.facilityDescription;
        data["areaCode"] = this.areaCode;
        data["areaDescription"] = this.areaDescription;
        data["unitCode"] = this.unitCode;
        data["unitDescription"] = this.unitDescription;
        data["systemGroupCode"] = this.systemGroupCode;
        data["systemGroupDescription"] = this.systemGroupDescription;
        data["classCode"] = this.classCode;
        data["classDescription"] = this.classDescription;
        data["subClassCode"] = this.subClassCode;
        data["subClassDescription"] = this.subClassDescription;
        data["serialNumber"] = this.serialNumber;
        data["capsPlant"] = this.capsPlant;
        data["capsUnit"] = this.capsUnit;
        data["capsInspector"] = this.capsInspector;
        data["equipmentType"] = this.equipmentType;
        data["businessUnit"] = this.businessUnit;
        data["costObjectBusinessUnit"] = this.costObjectBusinessUnit;
        data["description3"] = this.description3;
        data["remark2"] = this.remark2;
        data["faacl7"] = this.faacl7;
        return data;
    }
}

export interface IDimEquipmentDTO {
    id?: string | undefined;
    e1Id?: string | undefined;
    tagNumber?: string | undefined;
    descriptionEn?: string | undefined;
    descriptionRu?: string | undefined;
    sourceSystem?: string | undefined;
    statusCode?: string | undefined;
    integrityCriticalityCode?: string | undefined;
    integrityCriticalityDescription?: string | undefined;
    equipmentCriticalityCode?: string | undefined;
    equipmentCriticalityDescription?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;
    systemGroupCode?: string | undefined;
    systemGroupDescription?: string | undefined;
    classCode?: string | undefined;
    classDescription?: string | undefined;
    subClassCode?: string | undefined;
    subClassDescription?: string | undefined;
    serialNumber?: string | undefined;
    capsPlant?: number | undefined;
    capsUnit?: number | undefined;
    capsInspector?: number | undefined;
    equipmentType?: number | undefined;
    businessUnit?: string | undefined;
    costObjectBusinessUnit?: string | undefined;
    description3?: string | undefined;
    remark2?: string | undefined;
    faacl7?: string | undefined;
}

export class ExtBadActorData implements IExtBadActorData {
    pk?: string;
    abc?: string | undefined;
    sourceState?: string | undefined;
    description?: string | undefined;
    drivingCriteria?: string | undefined;
    id?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    likelyConsequence?: string | undefined;
    likelyScenario?: string | undefined;
    riptUrl?: string | undefined;
    riskManCategory?: string | undefined;
    areaType?: string | undefined;
    sourceCreatedOn?: string | undefined;
    sourceLogicalName?: string | undefined;
    stage?: string | undefined;
    otpWorkType?: string | undefined;
    sourceStatus?: string | undefined;
    dpi?: string | undefined;
    hseRiskEfficiency?: string | undefined;
    initialInvestment?: string | undefined;
    ript?: string | undefined;
    riskManRiskScore?: string | undefined;
    ror?: string | undefined;
    initiativeLinks?: OnePInitiativeBALink[] | undefined;

    constructor(data?: IExtBadActorData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.abc = _data["abc"];
            this.sourceState = _data["sourceState"];
            this.description = _data["description"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.id = _data["id"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.likelyScenario = _data["likelyScenario"];
            this.riptUrl = _data["riptUrl"];
            this.riskManCategory = _data["riskManCategory"];
            this.areaType = _data["areaType"];
            this.sourceCreatedOn = _data["sourceCreatedOn"];
            this.sourceLogicalName = _data["sourceLogicalName"];
            this.stage = _data["stage"];
            this.otpWorkType = _data["otpWorkType"];
            this.sourceStatus = _data["sourceStatus"];
            this.dpi = _data["dpi"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.initialInvestment = _data["initialInvestment"];
            this.ript = _data["ript"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.ror = _data["ror"];
            if (Array.isArray(_data["initiativeLinks"])) {
                this.initiativeLinks = [] as any;
                for (let item of _data["initiativeLinks"])
                    this.initiativeLinks!.push(OnePInitiativeBALink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtBadActorData {
        data = typeof data === 'object' ? data : {};
        let result = new ExtBadActorData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["abc"] = this.abc;
        data["sourceState"] = this.sourceState;
        data["description"] = this.description;
        data["drivingCriteria"] = this.drivingCriteria;
        data["id"] = this.id;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["likelyConsequence"] = this.likelyConsequence;
        data["likelyScenario"] = this.likelyScenario;
        data["riptUrl"] = this.riptUrl;
        data["riskManCategory"] = this.riskManCategory;
        data["areaType"] = this.areaType;
        data["sourceCreatedOn"] = this.sourceCreatedOn;
        data["sourceLogicalName"] = this.sourceLogicalName;
        data["stage"] = this.stage;
        data["otpWorkType"] = this.otpWorkType;
        data["sourceStatus"] = this.sourceStatus;
        data["dpi"] = this.dpi;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["initialInvestment"] = this.initialInvestment;
        data["ript"] = this.ript;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["ror"] = this.ror;
        if (Array.isArray(this.initiativeLinks)) {
            data["initiativeLinks"] = [];
            for (let item of this.initiativeLinks)
                data["initiativeLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExtBadActorData {
    pk?: string;
    abc?: string | undefined;
    sourceState?: string | undefined;
    description?: string | undefined;
    drivingCriteria?: string | undefined;
    id?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    likelyConsequence?: string | undefined;
    likelyScenario?: string | undefined;
    riptUrl?: string | undefined;
    riskManCategory?: string | undefined;
    areaType?: string | undefined;
    sourceCreatedOn?: string | undefined;
    sourceLogicalName?: string | undefined;
    stage?: string | undefined;
    otpWorkType?: string | undefined;
    sourceStatus?: string | undefined;
    dpi?: string | undefined;
    hseRiskEfficiency?: string | undefined;
    initialInvestment?: string | undefined;
    ript?: string | undefined;
    riskManRiskScore?: string | undefined;
    ror?: string | undefined;
    initiativeLinks?: OnePInitiativeBALink[] | undefined;
}

export class ExtBadActorDataGridPagedResult implements IExtBadActorDataGridPagedResult {
    items!: ExtBadActorData[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IExtBadActorDataGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExtBadActorData.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): ExtBadActorDataGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExtBadActorDataGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IExtBadActorDataGridPagedResult {
    items: ExtBadActorData[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class ExtEwr implements IExtEwr {
    pk?: string;
    abc?: string | undefined;
    sourceState?: string | undefined;
    afeNumber?: string | undefined;
    budgetType?: string | undefined;
    ccAfe?: string | undefined;
    costCenter?: string | undefined;
    description?: string | undefined;
    dpi?: string | undefined;
    drivingCriteria?: string | undefined;
    endDate?: string | undefined;
    ewrJoblogId?: string | undefined;
    hseRiskEfficiency?: string | undefined;
    id?: string | undefined;
    initialInvestment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    likelyConsequence?: string | undefined;
    likelyScenario?: string | undefined;
    sourceUrl?: string | undefined;
    ript?: string | undefined;
    riptUrl?: string | undefined;
    riskManCategory?: string | undefined;
    riskManRiskScore?: string | undefined;
    ror?: string | undefined;
    area?: string | undefined;
    sourceCreatedOn?: string | undefined;
    sourceStatus?: string | undefined;
    stage?: string | undefined;
    status?: string | undefined;
    otpWorkType?: string | undefined;
    sourceId?: string | undefined;
    initiativeLinks?: OnePInitiativeEWRLink[] | undefined;

    constructor(data?: IExtEwr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.abc = _data["abc"];
            this.sourceState = _data["sourceState"];
            this.afeNumber = _data["afeNumber"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.costCenter = _data["costCenter"];
            this.description = _data["description"];
            this.dpi = _data["dpi"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.endDate = _data["endDate"];
            this.ewrJoblogId = _data["ewrJoblogId"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.id = _data["id"];
            this.initialInvestment = _data["initialInvestment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.likelyScenario = _data["likelyScenario"];
            this.sourceUrl = _data["sourceUrl"];
            this.ript = _data["ript"];
            this.riptUrl = _data["riptUrl"];
            this.riskManCategory = _data["riskManCategory"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.ror = _data["ror"];
            this.area = _data["area"];
            this.sourceCreatedOn = _data["sourceCreatedOn"];
            this.sourceStatus = _data["sourceStatus"];
            this.stage = _data["stage"];
            this.status = _data["status"];
            this.otpWorkType = _data["otpWorkType"];
            this.sourceId = _data["sourceId"];
            if (Array.isArray(_data["initiativeLinks"])) {
                this.initiativeLinks = [] as any;
                for (let item of _data["initiativeLinks"])
                    this.initiativeLinks!.push(OnePInitiativeEWRLink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtEwr {
        data = typeof data === 'object' ? data : {};
        let result = new ExtEwr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["abc"] = this.abc;
        data["sourceState"] = this.sourceState;
        data["afeNumber"] = this.afeNumber;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["costCenter"] = this.costCenter;
        data["description"] = this.description;
        data["dpi"] = this.dpi;
        data["drivingCriteria"] = this.drivingCriteria;
        data["endDate"] = this.endDate;
        data["ewrJoblogId"] = this.ewrJoblogId;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["id"] = this.id;
        data["initialInvestment"] = this.initialInvestment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["likelyConsequence"] = this.likelyConsequence;
        data["likelyScenario"] = this.likelyScenario;
        data["sourceUrl"] = this.sourceUrl;
        data["ript"] = this.ript;
        data["riptUrl"] = this.riptUrl;
        data["riskManCategory"] = this.riskManCategory;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["ror"] = this.ror;
        data["area"] = this.area;
        data["sourceCreatedOn"] = this.sourceCreatedOn;
        data["sourceStatus"] = this.sourceStatus;
        data["stage"] = this.stage;
        data["status"] = this.status;
        data["otpWorkType"] = this.otpWorkType;
        data["sourceId"] = this.sourceId;
        if (Array.isArray(this.initiativeLinks)) {
            data["initiativeLinks"] = [];
            for (let item of this.initiativeLinks)
                data["initiativeLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExtEwr {
    pk?: string;
    abc?: string | undefined;
    sourceState?: string | undefined;
    afeNumber?: string | undefined;
    budgetType?: string | undefined;
    ccAfe?: string | undefined;
    costCenter?: string | undefined;
    description?: string | undefined;
    dpi?: string | undefined;
    drivingCriteria?: string | undefined;
    endDate?: string | undefined;
    ewrJoblogId?: string | undefined;
    hseRiskEfficiency?: string | undefined;
    id?: string | undefined;
    initialInvestment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    likelyConsequence?: string | undefined;
    likelyScenario?: string | undefined;
    sourceUrl?: string | undefined;
    ript?: string | undefined;
    riptUrl?: string | undefined;
    riskManCategory?: string | undefined;
    riskManRiskScore?: string | undefined;
    ror?: string | undefined;
    area?: string | undefined;
    sourceCreatedOn?: string | undefined;
    sourceStatus?: string | undefined;
    stage?: string | undefined;
    status?: string | undefined;
    otpWorkType?: string | undefined;
    sourceId?: string | undefined;
    initiativeLinks?: OnePInitiativeEWRLink[] | undefined;
}

export class ExtEwrGridPagedResult implements IExtEwrGridPagedResult {
    items!: ExtEwr[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IExtEwrGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExtEwr.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): ExtEwrGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExtEwrGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IExtEwrGridPagedResult {
    items: ExtEwr[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class ExtFdm implements IExtFdm {
    pk?: string;
    sourceCreatedOn?: string | undefined;
    stage?: string | undefined;
    sourceState?: string | undefined;
    sourceStatus?: string | undefined;
    description?: string | undefined;
    abc?: string | undefined;
    drivingCriteria?: string | undefined;
    dpi?: string | undefined;
    hseRiskEfficiency?: string | undefined;
    initialInvestment?: string | undefined;
    likelyConsequence?: string | undefined;
    likelyScenario?: string | undefined;
    riskManCategory?: string | undefined;
    riskManRiskScore?: string | undefined;
    ror?: string | undefined;
    ript?: string | undefined;
    riptUrl?: string | undefined;
    id?: string | undefined;
    sourceLogicalName?: string | undefined;
    otpWorkType?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    areaType?: string | undefined;
    endDate?: string | undefined;
    initiativeLinks?: OnePInitiativeFDMLink[] | undefined;

    constructor(data?: IExtFdm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.sourceCreatedOn = _data["sourceCreatedOn"];
            this.stage = _data["stage"];
            this.sourceState = _data["sourceState"];
            this.sourceStatus = _data["sourceStatus"];
            this.description = _data["description"];
            this.abc = _data["abc"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.dpi = _data["dpi"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.initialInvestment = _data["initialInvestment"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.likelyScenario = _data["likelyScenario"];
            this.riskManCategory = _data["riskManCategory"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.ror = _data["ror"];
            this.ript = _data["ript"];
            this.riptUrl = _data["riptUrl"];
            this.id = _data["id"];
            this.sourceLogicalName = _data["sourceLogicalName"];
            this.otpWorkType = _data["otpWorkType"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.areaType = _data["areaType"];
            this.endDate = _data["endDate"];
            if (Array.isArray(_data["initiativeLinks"])) {
                this.initiativeLinks = [] as any;
                for (let item of _data["initiativeLinks"])
                    this.initiativeLinks!.push(OnePInitiativeFDMLink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtFdm {
        data = typeof data === 'object' ? data : {};
        let result = new ExtFdm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["sourceCreatedOn"] = this.sourceCreatedOn;
        data["stage"] = this.stage;
        data["sourceState"] = this.sourceState;
        data["sourceStatus"] = this.sourceStatus;
        data["description"] = this.description;
        data["abc"] = this.abc;
        data["drivingCriteria"] = this.drivingCriteria;
        data["dpi"] = this.dpi;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["initialInvestment"] = this.initialInvestment;
        data["likelyConsequence"] = this.likelyConsequence;
        data["likelyScenario"] = this.likelyScenario;
        data["riskManCategory"] = this.riskManCategory;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["ror"] = this.ror;
        data["ript"] = this.ript;
        data["riptUrl"] = this.riptUrl;
        data["id"] = this.id;
        data["sourceLogicalName"] = this.sourceLogicalName;
        data["otpWorkType"] = this.otpWorkType;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["areaType"] = this.areaType;
        data["endDate"] = this.endDate;
        if (Array.isArray(this.initiativeLinks)) {
            data["initiativeLinks"] = [];
            for (let item of this.initiativeLinks)
                data["initiativeLinks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExtFdm {
    pk?: string;
    sourceCreatedOn?: string | undefined;
    stage?: string | undefined;
    sourceState?: string | undefined;
    sourceStatus?: string | undefined;
    description?: string | undefined;
    abc?: string | undefined;
    drivingCriteria?: string | undefined;
    dpi?: string | undefined;
    hseRiskEfficiency?: string | undefined;
    initialInvestment?: string | undefined;
    likelyConsequence?: string | undefined;
    likelyScenario?: string | undefined;
    riskManCategory?: string | undefined;
    riskManRiskScore?: string | undefined;
    ror?: string | undefined;
    ript?: string | undefined;
    riptUrl?: string | undefined;
    id?: string | undefined;
    sourceLogicalName?: string | undefined;
    otpWorkType?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    areaType?: string | undefined;
    endDate?: string | undefined;
    initiativeLinks?: OnePInitiativeFDMLink[] | undefined;
}

export class ExtFdmGridPagedResult implements IExtFdmGridPagedResult {
    items!: ExtFdm[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IExtFdmGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExtFdm.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): ExtFdmGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExtFdmGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IExtFdmGridPagedResult {
    items: ExtFdm[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class ExtPswsDimPersonInfoSearchedResultDTO implements IExtPswsDimPersonInfoSearchedResultDTO {
    searchResult?: string | undefined;
    persons?: ExtPswsDimSearchedPersonInfoDTO[] | undefined;

    constructor(data?: IExtPswsDimPersonInfoSearchedResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchResult = _data["searchResult"];
            if (Array.isArray(_data["persons"])) {
                this.persons = [] as any;
                for (let item of _data["persons"])
                    this.persons!.push(ExtPswsDimSearchedPersonInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtPswsDimPersonInfoSearchedResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtPswsDimPersonInfoSearchedResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchResult"] = this.searchResult;
        if (Array.isArray(this.persons)) {
            data["persons"] = [];
            for (let item of this.persons)
                data["persons"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExtPswsDimPersonInfoSearchedResultDTO {
    searchResult?: string | undefined;
    persons?: ExtPswsDimSearchedPersonInfoDTO[] | undefined;
}

export class ExtPswsDimSearchedPersonInfoDTO implements IExtPswsDimSearchedPersonInfoDTO {
    userName?: string | undefined;
    ownEmail?: string | undefined;
    sharedEmail?: string | undefined;
    title?: string | undefined;
    phoneNumber?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;

    constructor(data?: IExtPswsDimSearchedPersonInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.ownEmail = _data["ownEmail"];
            this.sharedEmail = _data["sharedEmail"];
            this.title = _data["title"];
            this.phoneNumber = _data["phoneNumber"];
            this.backToBackName = _data["backToBackName"];
            this.backToBackEmail = _data["backToBackEmail"];
            this.supervisorName = _data["supervisorName"];
            this.supervisorEmail = _data["supervisorEmail"];
        }
    }

    static fromJS(data: any): ExtPswsDimSearchedPersonInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExtPswsDimSearchedPersonInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["ownEmail"] = this.ownEmail;
        data["sharedEmail"] = this.sharedEmail;
        data["title"] = this.title;
        data["phoneNumber"] = this.phoneNumber;
        data["backToBackName"] = this.backToBackName;
        data["backToBackEmail"] = this.backToBackEmail;
        data["supervisorName"] = this.supervisorName;
        data["supervisorEmail"] = this.supervisorEmail;
        return data;
    }
}

export interface IExtPswsDimSearchedPersonInfoDTO {
    userName?: string | undefined;
    ownEmail?: string | undefined;
    sharedEmail?: string | undefined;
    title?: string | undefined;
    phoneNumber?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
}

export class FilterRule implements IFilterRule {
    field?: string | undefined;
    op?: string | undefined;
    values?: string[] | undefined;

    constructor(data?: IFilterRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.op = _data["op"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterRule {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["op"] = this.op;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IFilterRule {
    field?: string | undefined;
    op?: string | undefined;
    values?: string[] | undefined;
}

export class GetExportForecastActualsQuery implements IGetExportForecastActualsQuery {
    grid?: GridQuery;
    columns?: OnePForecastExportColumnDTO[] | undefined;

    constructor(data?: IGetExportForecastActualsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grid = _data["grid"] ? GridQuery.fromJS(_data["grid"]) : undefined as any;
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(OnePForecastExportColumnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExportForecastActualsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetExportForecastActualsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grid"] = this.grid ? this.grid.toJSON() : undefined as any;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetExportForecastActualsQuery {
    grid?: GridQuery;
    columns?: OnePForecastExportColumnDTO[] | undefined;
}

export class GridQuery implements IGridQuery {
    search?: string | undefined;
    filters?: FilterRule[] | undefined;
    sort?: string[] | undefined;
    page?: number;
    pageSize?: number;

    constructor(data?: IGridQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["search"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterRule.fromJS(item));
            }
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(item);
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GridQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GridQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search"] = this.search;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGridQuery {
    search?: string | undefined;
    filters?: FilterRule[] | undefined;
    sort?: string[] | undefined;
    page?: number;
    pageSize?: number;
}

export enum InitiativeComplexity {
    Low = "Low",
    Medium = "Medium",
    High = "High",
    Critical = "Critical",
}

export enum InitiativeStage {
    Funnel = "Funnel",
    Review = "Review",
    Analysis = "Analysis",
    Backlog = "Backlog",
    PreExecution = "PreExecution",
    Execution = "Execution",
    Lookback = "Lookback",
    Complete = "Complete",
    Cancel = "Cancel",
}

export enum InitiativeType {
    MEJ = "MEJ",
    CAPEX = "CAPEX",
    NotAssigned = "NotAssigned",
}

export class MejCutLineAreaSettingsDTO implements IMejCutLineAreaSettingsDTO {
    pk?: number;
    area?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: MejCutLineSettingsType;
    year?: number | undefined;
    setByDefault?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;

    constructor(data?: IMejCutLineAreaSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.area = _data["area"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.year = _data["year"];
            this.setByDefault = _data["setByDefault"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MejCutLineAreaSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MejCutLineAreaSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["area"] = this.area;
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        data["year"] = this.year;
        data["setByDefault"] = this.setByDefault;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IMejCutLineAreaSettingsDTO {
    pk?: number;
    area?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: MejCutLineSettingsType;
    year?: number | undefined;
    setByDefault?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
}

export class MejCutLineDTO implements IMejCutLineDTO {
    initiativePk?: number;
    ript?: number;
    fyOutlook?: number;
    stage?: string | undefined;
    area?: string | undefined;
    orderIndex?: number;
    sumOfBudget?: number;
    isIn?: boolean;
    leftoverAtCut?: number | undefined;
    financeStatus?: string | undefined;
    budgetType?: string | undefined;
    stageEnum?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number;
    multiYear?: boolean;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number;
    revisedBudget?: number;
    revisedOutlook?: number;
    actualsYTD?: number;
    fy1?: number;
    fy2?: number;
    fy3?: number;
    projectTotalCost?: number;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    stageStatus?: string | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    teamName?: string | undefined;
    createdOn?: Date;
    complexity?: InitiativeComplexity;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;

    constructor(data?: IMejCutLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativePk = _data["initiativePk"];
            this.ript = _data["ript"];
            this.fyOutlook = _data["fyOutlook"];
            this.stage = _data["stage"];
            this.area = _data["area"];
            this.orderIndex = _data["orderIndex"];
            this.sumOfBudget = _data["sumOfBudget"];
            this.isIn = _data["isIn"];
            this.leftoverAtCut = _data["leftoverAtCut"];
            this.financeStatus = _data["financeStatus"];
            this.budgetType = _data["budgetType"];
            this.stageEnum = _data["stageEnum"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.ccAfe = _data["ccAfe"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.stageStatus = _data["stageStatus"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.teamName = _data["teamName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.complexity = _data["complexity"];
            this.coordinatorName = _data["coordinatorName"];
            this.coordinatorEmail = _data["coordinatorEmail"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
        }
    }

    static fromJS(data: any): MejCutLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MejCutLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativePk"] = this.initiativePk;
        data["ript"] = this.ript;
        data["fyOutlook"] = this.fyOutlook;
        data["stage"] = this.stage;
        data["area"] = this.area;
        data["orderIndex"] = this.orderIndex;
        data["sumOfBudget"] = this.sumOfBudget;
        data["isIn"] = this.isIn;
        data["leftoverAtCut"] = this.leftoverAtCut;
        data["financeStatus"] = this.financeStatus;
        data["budgetType"] = this.budgetType;
        data["stageEnum"] = this.stageEnum;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["ccAfe"] = this.ccAfe;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["revisedOutlook"] = this.revisedOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["stageStatus"] = this.stageStatus;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["teamName"] = this.teamName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["complexity"] = this.complexity;
        data["coordinatorName"] = this.coordinatorName;
        data["coordinatorEmail"] = this.coordinatorEmail;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        return data;
    }
}

export interface IMejCutLineDTO {
    initiativePk?: number;
    ript?: number;
    fyOutlook?: number;
    stage?: string | undefined;
    area?: string | undefined;
    orderIndex?: number;
    sumOfBudget?: number;
    isIn?: boolean;
    leftoverAtCut?: number | undefined;
    financeStatus?: string | undefined;
    budgetType?: string | undefined;
    stageEnum?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number;
    multiYear?: boolean;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number;
    revisedBudget?: number;
    revisedOutlook?: number;
    actualsYTD?: number;
    fy1?: number;
    fy2?: number;
    fy3?: number;
    projectTotalCost?: number;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    stageStatus?: string | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    teamName?: string | undefined;
    createdOn?: Date;
    complexity?: InitiativeComplexity;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
}

export class MejCutLineScenarioDTO implements IMejCutLineScenarioDTO {
    pk?: number;
    name?: string | undefined;
    comment?: string | undefined;
    budget?: number;
    inactiveStageCsv?: string | undefined;
    inactiveAreaCsv?: string | undefined;
    filterJson?: string | undefined;
    dataAsOfUtc?: Date;
    savedBy?: string | undefined;

    constructor(data?: IMejCutLineScenarioDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.budget = _data["budget"];
            this.inactiveStageCsv = _data["inactiveStageCsv"];
            this.inactiveAreaCsv = _data["inactiveAreaCsv"];
            this.filterJson = _data["filterJson"];
            this.dataAsOfUtc = _data["dataAsOfUtc"] ? new Date(_data["dataAsOfUtc"].toString()) : undefined as any;
            this.savedBy = _data["savedBy"];
        }
    }

    static fromJS(data: any): MejCutLineScenarioDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MejCutLineScenarioDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["budget"] = this.budget;
        data["inactiveStageCsv"] = this.inactiveStageCsv;
        data["inactiveAreaCsv"] = this.inactiveAreaCsv;
        data["filterJson"] = this.filterJson;
        data["dataAsOfUtc"] = this.dataAsOfUtc ? this.dataAsOfUtc.toISOString() : undefined as any;
        data["savedBy"] = this.savedBy;
        return data;
    }
}

export interface IMejCutLineScenarioDTO {
    pk?: number;
    name?: string | undefined;
    comment?: string | undefined;
    budget?: number;
    inactiveStageCsv?: string | undefined;
    inactiveAreaCsv?: string | undefined;
    filterJson?: string | undefined;
    dataAsOfUtc?: Date;
    savedBy?: string | undefined;
}

export class MejCutLineScenarioItemDTO implements IMejCutLineScenarioItemDTO {
    pk?: number;
    scenarioFk?: number;
    initiativeFk?: number;
    riptAtSave?: number;
    fyOutlookAtSave?: number;
    stageAtSave?: string | undefined;
    areaAtSave?: string | undefined;
    financeStatusAtSave?: string | undefined;
    budgetTypeAtSave?: string | undefined;
    orderIndex?: number;
    cumSum?: number;
    isIn?: boolean;
    leftoverAtCut?: number | undefined;
    stageEnum?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number;
    multiYear?: boolean;
    plannedStartDate?: Date;
    plannedEndDate?: Date;
    needByDate?: Date;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number;
    revisedBudget?: number;
    actualsYTD?: number;
    fy1?: number;
    fy2?: number;
    fy3?: number;
    projectTotalCost?: number;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    stageStatus?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;

    constructor(data?: IMejCutLineScenarioItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.scenarioFk = _data["scenarioFk"];
            this.initiativeFk = _data["initiativeFk"];
            this.riptAtSave = _data["riptAtSave"];
            this.fyOutlookAtSave = _data["fyOutlookAtSave"];
            this.stageAtSave = _data["stageAtSave"];
            this.areaAtSave = _data["areaAtSave"];
            this.financeStatusAtSave = _data["financeStatusAtSave"];
            this.budgetTypeAtSave = _data["budgetTypeAtSave"];
            this.orderIndex = _data["orderIndex"];
            this.cumSum = _data["cumSum"];
            this.isIn = _data["isIn"];
            this.leftoverAtCut = _data["leftoverAtCut"];
            this.stageEnum = _data["stageEnum"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.financeStatus = _data["financeStatus"];
            this.stageStatus = _data["stageStatus"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
        }
    }

    static fromJS(data: any): MejCutLineScenarioItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MejCutLineScenarioItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["scenarioFk"] = this.scenarioFk;
        data["initiativeFk"] = this.initiativeFk;
        data["riptAtSave"] = this.riptAtSave;
        data["fyOutlookAtSave"] = this.fyOutlookAtSave;
        data["stageAtSave"] = this.stageAtSave;
        data["areaAtSave"] = this.areaAtSave;
        data["financeStatusAtSave"] = this.financeStatusAtSave;
        data["budgetTypeAtSave"] = this.budgetTypeAtSave;
        data["orderIndex"] = this.orderIndex;
        data["cumSum"] = this.cumSum;
        data["isIn"] = this.isIn;
        data["leftoverAtCut"] = this.leftoverAtCut;
        data["stageEnum"] = this.stageEnum;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["financeStatus"] = this.financeStatus;
        data["stageStatus"] = this.stageStatus;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        return data;
    }
}

export interface IMejCutLineScenarioItemDTO {
    pk?: number;
    scenarioFk?: number;
    initiativeFk?: number;
    riptAtSave?: number;
    fyOutlookAtSave?: number;
    stageAtSave?: string | undefined;
    areaAtSave?: string | undefined;
    financeStatusAtSave?: string | undefined;
    budgetTypeAtSave?: string | undefined;
    orderIndex?: number;
    cumSum?: number;
    isIn?: boolean;
    leftoverAtCut?: number | undefined;
    stageEnum?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number;
    multiYear?: boolean;
    plannedStartDate?: Date;
    plannedEndDate?: Date;
    needByDate?: Date;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number;
    revisedBudget?: number;
    actualsYTD?: number;
    fy1?: number;
    fy2?: number;
    fy3?: number;
    projectTotalCost?: number;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    stageStatus?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
}

export class MejCutLineSettingsDTO implements IMejCutLineSettingsDTO {
    pk?: number;
    name?: string | undefined;
    value?: string | undefined;
    type?: MejCutLineSettingsType;
    year?: number | undefined;
    setByDefault?: boolean;

    constructor(data?: IMejCutLineSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.year = _data["year"];
            this.setByDefault = _data["setByDefault"];
        }
    }

    static fromJS(data: any): MejCutLineSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MejCutLineSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        data["year"] = this.year;
        data["setByDefault"] = this.setByDefault;
        return data;
    }
}

export interface IMejCutLineSettingsDTO {
    pk?: number;
    name?: string | undefined;
    value?: string | undefined;
    type?: MejCutLineSettingsType;
    year?: number | undefined;
    setByDefault?: boolean;
}

export enum MejCutLineSettingsType {
    Budget = "Budget",
    InactiveArea = "InactiveArea",
    InactiveStage = "InactiveStage",
    ExcludeFinanceStatus = "ExcludeFinanceStatus",
    ExcludeBudgetType = "ExcludeBudgetType",
    ExcludeStage = "ExcludeStage",
    ActiveProjectTeam = "ActiveProjectTeam",
}

export class OnePApprovalInitiativesReadDTO implements IOnePApprovalInitiativesReadDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    initiativeOwnerSharedEmail?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    year?: number | undefined;
    needByDate?: Date | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    comment?: string | undefined;
    afeNumber?: string | undefined;
    initiatorEmail?: string | undefined;

    constructor(data?: IOnePApprovalInitiativesReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.fyOutlook = _data["fyOutlook"];
            this.year = _data["year"];
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.comment = _data["comment"];
            this.afeNumber = _data["afeNumber"];
            this.initiatorEmail = _data["initiatorEmail"];
        }
    }

    static fromJS(data: any): OnePApprovalInitiativesReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePApprovalInitiativesReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["fyOutlook"] = this.fyOutlook;
        data["year"] = this.year;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["comment"] = this.comment;
        data["afeNumber"] = this.afeNumber;
        data["initiatorEmail"] = this.initiatorEmail;
        return data;
    }
}

export interface IOnePApprovalInitiativesReadDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    initiativeOwnerSharedEmail?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    year?: number | undefined;
    needByDate?: Date | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    comment?: string | undefined;
    afeNumber?: string | undefined;
    initiatorEmail?: string | undefined;
}

export class OnePApprovalInitiativesReadDTOGridPagedResult implements IOnePApprovalInitiativesReadDTOGridPagedResult {
    items!: OnePApprovalInitiativesReadDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePApprovalInitiativesReadDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePApprovalInitiativesReadDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePApprovalInitiativesReadDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePApprovalInitiativesReadDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePApprovalInitiativesReadDTOGridPagedResult {
    items: OnePApprovalInitiativesReadDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePAreaOwner implements IOnePAreaOwner {
    pk?: number;
    areaNameEn!: string;
    areaNameKz?: string | undefined;
    areaNameRu?: string | undefined;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;
    budget?: number;

    constructor(data?: IOnePAreaOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.areaNameEn = _data["areaNameEn"];
            this.areaNameKz = _data["areaNameKz"];
            this.areaNameRu = _data["areaNameRu"];
            this.areaOwner = _data["areaOwner"];
            this.areaOwnerCC = _data["areaOwnerCC"];
            this.coreTeam = _data["coreTeam"];
            this.coreTeamCC = _data["coreTeamCC"];
            this.portfolioLeadershipTeam = _data["portfolioLeadershipTeam"];
            this.portfolioLeadershipTeamCC = _data["portfolioLeadershipTeamCC"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.isDeleted = _data["isDeleted"];
            this.budget = _data["budget"];
        }
    }

    static fromJS(data: any): OnePAreaOwner {
        data = typeof data === 'object' ? data : {};
        let result = new OnePAreaOwner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["areaNameEn"] = this.areaNameEn;
        data["areaNameKz"] = this.areaNameKz;
        data["areaNameRu"] = this.areaNameRu;
        data["areaOwner"] = this.areaOwner;
        data["areaOwnerCC"] = this.areaOwnerCC;
        data["coreTeam"] = this.coreTeam;
        data["coreTeamCC"] = this.coreTeamCC;
        data["portfolioLeadershipTeam"] = this.portfolioLeadershipTeam;
        data["portfolioLeadershipTeamCC"] = this.portfolioLeadershipTeamCC;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["isDeleted"] = this.isDeleted;
        data["budget"] = this.budget;
        return data;
    }
}

export interface IOnePAreaOwner {
    pk?: number;
    areaNameEn: string;
    areaNameKz?: string | undefined;
    areaNameRu?: string | undefined;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;
    budget?: number;
}

export class OnePAreaOwnerCreateDTO implements IOnePAreaOwnerCreateDTO {
    areaNameEn?: string | undefined;
    areaNameKz?: string | undefined;
    areaNameRu?: string | undefined;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    budget?: number;

    constructor(data?: IOnePAreaOwnerCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaNameEn = _data["areaNameEn"];
            this.areaNameKz = _data["areaNameKz"];
            this.areaNameRu = _data["areaNameRu"];
            this.areaOwner = _data["areaOwner"];
            this.areaOwnerCC = _data["areaOwnerCC"];
            this.coreTeam = _data["coreTeam"];
            this.coreTeamCC = _data["coreTeamCC"];
            this.portfolioLeadershipTeam = _data["portfolioLeadershipTeam"];
            this.portfolioLeadershipTeamCC = _data["portfolioLeadershipTeamCC"];
            this.budget = _data["budget"];
        }
    }

    static fromJS(data: any): OnePAreaOwnerCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePAreaOwnerCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaNameEn"] = this.areaNameEn;
        data["areaNameKz"] = this.areaNameKz;
        data["areaNameRu"] = this.areaNameRu;
        data["areaOwner"] = this.areaOwner;
        data["areaOwnerCC"] = this.areaOwnerCC;
        data["coreTeam"] = this.coreTeam;
        data["coreTeamCC"] = this.coreTeamCC;
        data["portfolioLeadershipTeam"] = this.portfolioLeadershipTeam;
        data["portfolioLeadershipTeamCC"] = this.portfolioLeadershipTeamCC;
        data["budget"] = this.budget;
        return data;
    }
}

export interface IOnePAreaOwnerCreateDTO {
    areaNameEn?: string | undefined;
    areaNameKz?: string | undefined;
    areaNameRu?: string | undefined;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    budget?: number;
}

export class OnePAreaOwnerUpdateDTO implements IOnePAreaOwnerUpdateDTO {
    areaNameEn?: string | undefined;
    areaNameKz?: string | undefined;
    areaNameRu?: string | undefined;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    budget?: number;

    constructor(data?: IOnePAreaOwnerUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaNameEn = _data["areaNameEn"];
            this.areaNameKz = _data["areaNameKz"];
            this.areaNameRu = _data["areaNameRu"];
            this.areaOwner = _data["areaOwner"];
            this.areaOwnerCC = _data["areaOwnerCC"];
            this.coreTeam = _data["coreTeam"];
            this.coreTeamCC = _data["coreTeamCC"];
            this.portfolioLeadershipTeam = _data["portfolioLeadershipTeam"];
            this.portfolioLeadershipTeamCC = _data["portfolioLeadershipTeamCC"];
            this.budget = _data["budget"];
        }
    }

    static fromJS(data: any): OnePAreaOwnerUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePAreaOwnerUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaNameEn"] = this.areaNameEn;
        data["areaNameKz"] = this.areaNameKz;
        data["areaNameRu"] = this.areaNameRu;
        data["areaOwner"] = this.areaOwner;
        data["areaOwnerCC"] = this.areaOwnerCC;
        data["coreTeam"] = this.coreTeam;
        data["coreTeamCC"] = this.coreTeamCC;
        data["portfolioLeadershipTeam"] = this.portfolioLeadershipTeam;
        data["portfolioLeadershipTeamCC"] = this.portfolioLeadershipTeamCC;
        data["budget"] = this.budget;
        return data;
    }
}

export interface IOnePAreaOwnerUpdateDTO {
    areaNameEn?: string | undefined;
    areaNameKz?: string | undefined;
    areaNameRu?: string | undefined;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    budget?: number;
}

export class OnePAttachmentFileDTO implements IOnePAttachmentFileDTO {
    id?: string;
    breakInOutId?: number | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
    uploadedAt?: Date;
    uploadedByEmail?: string | undefined;

    constructor(data?: IOnePAttachmentFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.breakInOutId = _data["breakInOutId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeBytes = _data["sizeBytes"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : undefined as any;
            this.uploadedByEmail = _data["uploadedByEmail"];
        }
    }

    static fromJS(data: any): OnePAttachmentFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePAttachmentFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["breakInOutId"] = this.breakInOutId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeBytes"] = this.sizeBytes;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : undefined as any;
        data["uploadedByEmail"] = this.uploadedByEmail;
        return data;
    }
}

export interface IOnePAttachmentFileDTO {
    id?: string;
    breakInOutId?: number | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
    uploadedAt?: Date;
    uploadedByEmail?: string | undefined;
}

export class OnePBALinkedEquipmentViewRowDTO implements IOnePBALinkedEquipmentViewRowDTO {
    pk?: string;
    assetNumber?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;
    facility?: string | undefined;
    area?: string | undefined;
    unit?: string | undefined;
    equipmentClass?: string | undefined;
    equipmentSubclass?: string | undefined;
    equipmentStatus?: string | undefined;
    integrityCriticality?: string | undefined;
    femdmFacility?: string | undefined;
    femdmArea?: string | undefined;
    femdmUnit?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;

    constructor(data?: IOnePBALinkedEquipmentViewRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.assetNumber = _data["assetNumber"];
            this.tagNumber = _data["tagNumber"];
            this.sourceSystem = _data["sourceSystem"];
            this.facility = _data["facility"];
            this.area = _data["area"];
            this.unit = _data["unit"];
            this.equipmentClass = _data["equipmentClass"];
            this.equipmentSubclass = _data["equipmentSubclass"];
            this.equipmentStatus = _data["equipmentStatus"];
            this.integrityCriticality = _data["integrityCriticality"];
            this.femdmFacility = _data["femdmFacility"];
            this.femdmArea = _data["femdmArea"];
            this.femdmUnit = _data["femdmUnit"];
            this.facilityCode = _data["facilityCode"];
            this.facilityDescription = _data["facilityDescription"];
            this.areaCode = _data["areaCode"];
            this.areaDescription = _data["areaDescription"];
            this.unitCode = _data["unitCode"];
            this.unitDescription = _data["unitDescription"];
        }
    }

    static fromJS(data: any): OnePBALinkedEquipmentViewRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePBALinkedEquipmentViewRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["assetNumber"] = this.assetNumber;
        data["tagNumber"] = this.tagNumber;
        data["sourceSystem"] = this.sourceSystem;
        data["facility"] = this.facility;
        data["area"] = this.area;
        data["unit"] = this.unit;
        data["equipmentClass"] = this.equipmentClass;
        data["equipmentSubclass"] = this.equipmentSubclass;
        data["equipmentStatus"] = this.equipmentStatus;
        data["integrityCriticality"] = this.integrityCriticality;
        data["femdmFacility"] = this.femdmFacility;
        data["femdmArea"] = this.femdmArea;
        data["femdmUnit"] = this.femdmUnit;
        data["facilityCode"] = this.facilityCode;
        data["facilityDescription"] = this.facilityDescription;
        data["areaCode"] = this.areaCode;
        data["areaDescription"] = this.areaDescription;
        data["unitCode"] = this.unitCode;
        data["unitDescription"] = this.unitDescription;
        return data;
    }
}

export interface IOnePBALinkedEquipmentViewRowDTO {
    pk?: string;
    assetNumber?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;
    facility?: string | undefined;
    area?: string | undefined;
    unit?: string | undefined;
    equipmentClass?: string | undefined;
    equipmentSubclass?: string | undefined;
    equipmentStatus?: string | undefined;
    integrityCriticality?: string | undefined;
    femdmFacility?: string | undefined;
    femdmArea?: string | undefined;
    femdmUnit?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;
}

export class OnePBALinkedEquipmentViewRowDTOGridPagedResult implements IOnePBALinkedEquipmentViewRowDTOGridPagedResult {
    items!: OnePBALinkedEquipmentViewRowDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePBALinkedEquipmentViewRowDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePBALinkedEquipmentViewRowDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePBALinkedEquipmentViewRowDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePBALinkedEquipmentViewRowDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePBALinkedEquipmentViewRowDTOGridPagedResult {
    items: OnePBALinkedEquipmentViewRowDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePBreakInOutCreateDTO implements IOnePBreakInOutCreateDTO {
    initiativeFk?: number;
    forecastCostTotalChangeSetId?: number;
    justification?: string | undefined;
    amount?: number;
    revisedOutlook?: number;
    currentFyGrandTotal?: number;
    lastFyGrandTotal?: number;

    constructor(data?: IOnePBreakInOutCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeFk = _data["initiativeFk"];
            this.forecastCostTotalChangeSetId = _data["forecastCostTotalChangeSetId"];
            this.justification = _data["justification"];
            this.amount = _data["amount"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.currentFyGrandTotal = _data["currentFyGrandTotal"];
            this.lastFyGrandTotal = _data["lastFyGrandTotal"];
        }
    }

    static fromJS(data: any): OnePBreakInOutCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePBreakInOutCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeFk"] = this.initiativeFk;
        data["forecastCostTotalChangeSetId"] = this.forecastCostTotalChangeSetId;
        data["justification"] = this.justification;
        data["amount"] = this.amount;
        data["revisedOutlook"] = this.revisedOutlook;
        data["currentFyGrandTotal"] = this.currentFyGrandTotal;
        data["lastFyGrandTotal"] = this.lastFyGrandTotal;
        return data;
    }
}

export interface IOnePBreakInOutCreateDTO {
    initiativeFk?: number;
    forecastCostTotalChangeSetId?: number;
    justification?: string | undefined;
    amount?: number;
    revisedOutlook?: number;
    currentFyGrandTotal?: number;
    lastFyGrandTotal?: number;
}

export class OnePBreakInOutReadDTO implements IOnePBreakInOutReadDTO {
    pk?: number;
    initiativeFk?: number;
    area?: string | undefined;
    description?: string | undefined;
    justification?: string | undefined;
    originalOutlook?: number;
    revisedOutlook?: number;
    delta?: number;
    initiativeOwner?: string | undefined;
    ript?: number | undefined;
    status?: string | undefined;
    statusComment?: string | undefined;
    decision?: string | undefined;
    decisionComment?: string | undefined;
    createdOn?: Date;
    projectYear?: number | undefined;
    initiatorEmail?: string | undefined;
    currentFyGrandTotal?: number;
    lastFyGrandTotal?: number;

    constructor(data?: IOnePBreakInOutReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.area = _data["area"];
            this.description = _data["description"];
            this.justification = _data["justification"];
            this.originalOutlook = _data["originalOutlook"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.delta = _data["delta"];
            this.initiativeOwner = _data["initiativeOwner"];
            this.ript = _data["ript"];
            this.status = _data["status"];
            this.statusComment = _data["statusComment"];
            this.decision = _data["decision"];
            this.decisionComment = _data["decisionComment"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.projectYear = _data["projectYear"];
            this.initiatorEmail = _data["initiatorEmail"];
            this.currentFyGrandTotal = _data["currentFyGrandTotal"];
            this.lastFyGrandTotal = _data["lastFyGrandTotal"];
        }
    }

    static fromJS(data: any): OnePBreakInOutReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePBreakInOutReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["area"] = this.area;
        data["description"] = this.description;
        data["justification"] = this.justification;
        data["originalOutlook"] = this.originalOutlook;
        data["revisedOutlook"] = this.revisedOutlook;
        data["delta"] = this.delta;
        data["initiativeOwner"] = this.initiativeOwner;
        data["ript"] = this.ript;
        data["status"] = this.status;
        data["statusComment"] = this.statusComment;
        data["decision"] = this.decision;
        data["decisionComment"] = this.decisionComment;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["projectYear"] = this.projectYear;
        data["initiatorEmail"] = this.initiatorEmail;
        data["currentFyGrandTotal"] = this.currentFyGrandTotal;
        data["lastFyGrandTotal"] = this.lastFyGrandTotal;
        return data;
    }
}

export interface IOnePBreakInOutReadDTO {
    pk?: number;
    initiativeFk?: number;
    area?: string | undefined;
    description?: string | undefined;
    justification?: string | undefined;
    originalOutlook?: number;
    revisedOutlook?: number;
    delta?: number;
    initiativeOwner?: string | undefined;
    ript?: number | undefined;
    status?: string | undefined;
    statusComment?: string | undefined;
    decision?: string | undefined;
    decisionComment?: string | undefined;
    createdOn?: Date;
    projectYear?: number | undefined;
    initiatorEmail?: string | undefined;
    currentFyGrandTotal?: number;
    lastFyGrandTotal?: number;
}

export class OnePBreakInOutReadDTOGridPagedResult implements IOnePBreakInOutReadDTOGridPagedResult {
    items!: OnePBreakInOutReadDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePBreakInOutReadDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePBreakInOutReadDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePBreakInOutReadDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePBreakInOutReadDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePBreakInOutReadDTOGridPagedResult {
    items: OnePBreakInOutReadDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePFDMLinkedEquipmentViewRowDTO implements IOnePFDMLinkedEquipmentViewRowDTO {
    pk?: string;
    assetNumber?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;
    facility?: string | undefined;
    area?: string | undefined;
    unit?: string | undefined;
    equipmentClass?: string | undefined;
    equipmentSubclass?: string | undefined;
    equipmentStatus?: string | undefined;
    integrityCriticality?: string | undefined;
    femdmFacility?: string | undefined;
    femdmArea?: string | undefined;
    femdmUnit?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;

    constructor(data?: IOnePFDMLinkedEquipmentViewRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.assetNumber = _data["assetNumber"];
            this.tagNumber = _data["tagNumber"];
            this.sourceSystem = _data["sourceSystem"];
            this.facility = _data["facility"];
            this.area = _data["area"];
            this.unit = _data["unit"];
            this.equipmentClass = _data["equipmentClass"];
            this.equipmentSubclass = _data["equipmentSubclass"];
            this.equipmentStatus = _data["equipmentStatus"];
            this.integrityCriticality = _data["integrityCriticality"];
            this.femdmFacility = _data["femdmFacility"];
            this.femdmArea = _data["femdmArea"];
            this.femdmUnit = _data["femdmUnit"];
            this.facilityCode = _data["facilityCode"];
            this.facilityDescription = _data["facilityDescription"];
            this.areaCode = _data["areaCode"];
            this.areaDescription = _data["areaDescription"];
            this.unitCode = _data["unitCode"];
            this.unitDescription = _data["unitDescription"];
        }
    }

    static fromJS(data: any): OnePFDMLinkedEquipmentViewRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePFDMLinkedEquipmentViewRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["assetNumber"] = this.assetNumber;
        data["tagNumber"] = this.tagNumber;
        data["sourceSystem"] = this.sourceSystem;
        data["facility"] = this.facility;
        data["area"] = this.area;
        data["unit"] = this.unit;
        data["equipmentClass"] = this.equipmentClass;
        data["equipmentSubclass"] = this.equipmentSubclass;
        data["equipmentStatus"] = this.equipmentStatus;
        data["integrityCriticality"] = this.integrityCriticality;
        data["femdmFacility"] = this.femdmFacility;
        data["femdmArea"] = this.femdmArea;
        data["femdmUnit"] = this.femdmUnit;
        data["facilityCode"] = this.facilityCode;
        data["facilityDescription"] = this.facilityDescription;
        data["areaCode"] = this.areaCode;
        data["areaDescription"] = this.areaDescription;
        data["unitCode"] = this.unitCode;
        data["unitDescription"] = this.unitDescription;
        return data;
    }
}

export interface IOnePFDMLinkedEquipmentViewRowDTO {
    pk?: string;
    assetNumber?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;
    facility?: string | undefined;
    area?: string | undefined;
    unit?: string | undefined;
    equipmentClass?: string | undefined;
    equipmentSubclass?: string | undefined;
    equipmentStatus?: string | undefined;
    integrityCriticality?: string | undefined;
    femdmFacility?: string | undefined;
    femdmArea?: string | undefined;
    femdmUnit?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;
}

export class OnePFDMLinkedEquipmentViewRowDTOGridPagedResult implements IOnePFDMLinkedEquipmentViewRowDTOGridPagedResult {
    items!: OnePFDMLinkedEquipmentViewRowDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePFDMLinkedEquipmentViewRowDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePFDMLinkedEquipmentViewRowDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePFDMLinkedEquipmentViewRowDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePFDMLinkedEquipmentViewRowDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePFDMLinkedEquipmentViewRowDTOGridPagedResult {
    items: OnePFDMLinkedEquipmentViewRowDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePFinanceStatusCreateUpdateDTO implements IOnePFinanceStatusCreateUpdateDTO {
    pk?: number;
    statusNameEn?: string | undefined;
    statusNameKz?: string | undefined;
    statusNameRu?: string | undefined;

    constructor(data?: IOnePFinanceStatusCreateUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.statusNameEn = _data["statusNameEn"];
            this.statusNameKz = _data["statusNameKz"];
            this.statusNameRu = _data["statusNameRu"];
        }
    }

    static fromJS(data: any): OnePFinanceStatusCreateUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePFinanceStatusCreateUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["statusNameEn"] = this.statusNameEn;
        data["statusNameKz"] = this.statusNameKz;
        data["statusNameRu"] = this.statusNameRu;
        return data;
    }
}

export interface IOnePFinanceStatusCreateUpdateDTO {
    pk?: number;
    statusNameEn?: string | undefined;
    statusNameKz?: string | undefined;
    statusNameRu?: string | undefined;
}

export class OnePFinanceStatusReadDTO implements IOnePFinanceStatusReadDTO {
    pk?: number;
    statusNameEn?: string | undefined;
    statusNameKz?: string | undefined;
    statusNameRu?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IOnePFinanceStatusReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.statusNameEn = _data["statusNameEn"];
            this.statusNameKz = _data["statusNameKz"];
            this.statusNameRu = _data["statusNameRu"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OnePFinanceStatusReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePFinanceStatusReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["statusNameEn"] = this.statusNameEn;
        data["statusNameKz"] = this.statusNameKz;
        data["statusNameRu"] = this.statusNameRu;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IOnePFinanceStatusReadDTO {
    pk?: number;
    statusNameEn?: string | undefined;
    statusNameKz?: string | undefined;
    statusNameRu?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;
}

export class OnePForecastCostTotals implements IOnePForecastCostTotals {
    pk?: number;
    initiativeFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    onePInitiative?: OnePInitiative;

    constructor(data?: IOnePForecastCostTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.category = _data["category"];
            this.amount = _data["amount"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePForecastCostTotals {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastCostTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["year"] = this.year;
        data["month"] = this.month;
        data["category"] = this.category;
        data["amount"] = this.amount;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePForecastCostTotals {
    pk?: number;
    initiativeFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    onePInitiative?: OnePInitiative;
}

export class OnePForecastCostTotalsChangeLineDTO implements IOnePForecastCostTotalsChangeLineDTO {
    columnName?: string | undefined;
    year?: number;
    beforeAmount?: number;
    afterAmount?: number;
    deltaAmount?: number;

    constructor(data?: IOnePForecastCostTotalsChangeLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.year = _data["year"];
            this.beforeAmount = _data["beforeAmount"];
            this.afterAmount = _data["afterAmount"];
            this.deltaAmount = _data["deltaAmount"];
        }
    }

    static fromJS(data: any): OnePForecastCostTotalsChangeLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastCostTotalsChangeLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["year"] = this.year;
        data["beforeAmount"] = this.beforeAmount;
        data["afterAmount"] = this.afterAmount;
        data["deltaAmount"] = this.deltaAmount;
        return data;
    }
}

export interface IOnePForecastCostTotalsChangeLineDTO {
    columnName?: string | undefined;
    year?: number;
    beforeAmount?: number;
    afterAmount?: number;
    deltaAmount?: number;
}

export class OnePForecastCostTotalsChangeSetDTO implements IOnePForecastCostTotalsChangeSetDTO {
    changeSetId?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    breakInOutFk?: number | undefined;
    lineDTOs?: OnePForecastCostTotalsChangeLineDTO[] | undefined;

    constructor(data?: IOnePForecastCostTotalsChangeSetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeSetId = _data["changeSetId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.breakInOutFk = _data["breakInOutFk"];
            if (Array.isArray(_data["lineDTOs"])) {
                this.lineDTOs = [] as any;
                for (let item of _data["lineDTOs"])
                    this.lineDTOs!.push(OnePForecastCostTotalsChangeLineDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OnePForecastCostTotalsChangeSetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastCostTotalsChangeSetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeSetId"] = this.changeSetId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["breakInOutFk"] = this.breakInOutFk;
        if (Array.isArray(this.lineDTOs)) {
            data["lineDTOs"] = [];
            for (let item of this.lineDTOs)
                data["lineDTOs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnePForecastCostTotalsChangeSetDTO {
    changeSetId?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    breakInOutFk?: number | undefined;
    lineDTOs?: OnePForecastCostTotalsChangeLineDTO[] | undefined;
}

export class OnePForecastEditState implements IOnePForecastEditState {
    pk?: number;
    year?: number;
    month?: number;
    isOpen?: boolean;
    openedAt?: Date;
    closedAt?: Date | undefined;

    constructor(data?: IOnePForecastEditState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.isOpen = _data["isOpen"];
            this.openedAt = _data["openedAt"] ? new Date(_data["openedAt"].toString()) : undefined as any;
            this.closedAt = _data["closedAt"] ? new Date(_data["closedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OnePForecastEditState {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastEditState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["year"] = this.year;
        data["month"] = this.month;
        data["isOpen"] = this.isOpen;
        data["openedAt"] = this.openedAt ? this.openedAt.toISOString() : undefined as any;
        data["closedAt"] = this.closedAt ? this.closedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IOnePForecastEditState {
    pk?: number;
    year?: number;
    month?: number;
    isOpen?: boolean;
    openedAt?: Date;
    closedAt?: Date | undefined;
}

export class OnePForecastExportColumnDTO implements IOnePForecastExportColumnDTO {
    field?: string | undefined;
    title?: string | undefined;
    parentHeader?: string | undefined;

    constructor(data?: IOnePForecastExportColumnDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.title = _data["title"];
            this.parentHeader = _data["parentHeader"];
        }
    }

    static fromJS(data: any): OnePForecastExportColumnDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastExportColumnDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["title"] = this.title;
        data["parentHeader"] = this.parentHeader;
        return data;
    }
}

export interface IOnePForecastExportColumnDTO {
    field?: string | undefined;
    title?: string | undefined;
    parentHeader?: string | undefined;
}

export class OnePForecastInitiativeWithBreakInOutDTO implements IOnePForecastInitiativeWithBreakInOutDTO {
    pk?: number;
    initiativeFk?: number;
    forecastRevisionFk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    stageStatus?: string | undefined;
    revisedOutlook?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    projectOwnerEmail?: string | undefined;
    approvedBudget?: number | undefined;
    afeAmountStartDate?: string | undefined;
    afeAmountEndDate?: string | undefined;
    afeAmount?: number | undefined;
    forecastCostTotals?: OnePProjectCostTotalsDTO;
    initiativeFactCostTotals?: OnePProjectCostTotalsDTO;
    deltaCostTotals?: OnePProjectCostTotalsDTO;

    constructor(data?: IOnePForecastInitiativeWithBreakInOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.forecastRevisionFk = _data["forecastRevisionFk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.financeStatus = _data["financeStatus"];
            this.stageStatus = _data["stageStatus"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.approvedBudget = _data["approvedBudget"];
            this.afeAmountStartDate = _data["afeAmountStartDate"];
            this.afeAmountEndDate = _data["afeAmountEndDate"];
            this.afeAmount = _data["afeAmount"];
            this.forecastCostTotals = _data["forecastCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["forecastCostTotals"]) : undefined as any;
            this.initiativeFactCostTotals = _data["initiativeFactCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["initiativeFactCostTotals"]) : undefined as any;
            this.deltaCostTotals = _data["deltaCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["deltaCostTotals"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePForecastInitiativeWithBreakInOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastInitiativeWithBreakInOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["forecastRevisionFk"] = this.forecastRevisionFk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["financeStatus"] = this.financeStatus;
        data["stageStatus"] = this.stageStatus;
        data["revisedOutlook"] = this.revisedOutlook;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["approvedBudget"] = this.approvedBudget;
        data["afeAmountStartDate"] = this.afeAmountStartDate;
        data["afeAmountEndDate"] = this.afeAmountEndDate;
        data["afeAmount"] = this.afeAmount;
        data["forecastCostTotals"] = this.forecastCostTotals ? this.forecastCostTotals.toJSON() : undefined as any;
        data["initiativeFactCostTotals"] = this.initiativeFactCostTotals ? this.initiativeFactCostTotals.toJSON() : undefined as any;
        data["deltaCostTotals"] = this.deltaCostTotals ? this.deltaCostTotals.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePForecastInitiativeWithBreakInOutDTO {
    pk?: number;
    initiativeFk?: number;
    forecastRevisionFk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    stageStatus?: string | undefined;
    revisedOutlook?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    projectOwnerEmail?: string | undefined;
    approvedBudget?: number | undefined;
    afeAmountStartDate?: string | undefined;
    afeAmountEndDate?: string | undefined;
    afeAmount?: number | undefined;
    forecastCostTotals?: OnePProjectCostTotalsDTO;
    initiativeFactCostTotals?: OnePProjectCostTotalsDTO;
    deltaCostTotals?: OnePProjectCostTotalsDTO;
}

export class OnePForecastInitiativeWithBreakInOutDTOGridPagedResult implements IOnePForecastInitiativeWithBreakInOutDTOGridPagedResult {
    items!: OnePForecastInitiativeWithBreakInOutDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePForecastInitiativeWithBreakInOutDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePForecastInitiativeWithBreakInOutDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePForecastInitiativeWithBreakInOutDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastInitiativeWithBreakInOutDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePForecastInitiativeWithBreakInOutDTOGridPagedResult {
    items: OnePForecastInitiativeWithBreakInOutDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePForecastRevision implements IOnePForecastRevision {
    pk?: number;
    initiativeFk?: number;
    sourceEditStateId?: number;
    year?: number;
    month?: number;
    revisionName?: string | undefined;
    revisionNumber?: number;
    closedAt?: Date;
    frCostTotals?: OnePForecastRevisionCostTotals[] | undefined;
    initiativeFactCostTotals?: OnePInitiativeFactCostTotals[] | undefined;
    initiativeSnapshot?: OnePForecastRevisionInitiativeSnapshot;

    constructor(data?: IOnePForecastRevision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.sourceEditStateId = _data["sourceEditStateId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.revisionName = _data["revisionName"];
            this.revisionNumber = _data["revisionNumber"];
            this.closedAt = _data["closedAt"] ? new Date(_data["closedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["frCostTotals"])) {
                this.frCostTotals = [] as any;
                for (let item of _data["frCostTotals"])
                    this.frCostTotals!.push(OnePForecastRevisionCostTotals.fromJS(item));
            }
            if (Array.isArray(_data["initiativeFactCostTotals"])) {
                this.initiativeFactCostTotals = [] as any;
                for (let item of _data["initiativeFactCostTotals"])
                    this.initiativeFactCostTotals!.push(OnePInitiativeFactCostTotals.fromJS(item));
            }
            this.initiativeSnapshot = _data["initiativeSnapshot"] ? OnePForecastRevisionInitiativeSnapshot.fromJS(_data["initiativeSnapshot"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePForecastRevision {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastRevision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["sourceEditStateId"] = this.sourceEditStateId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["revisionName"] = this.revisionName;
        data["revisionNumber"] = this.revisionNumber;
        data["closedAt"] = this.closedAt ? this.closedAt.toISOString() : undefined as any;
        if (Array.isArray(this.frCostTotals)) {
            data["frCostTotals"] = [];
            for (let item of this.frCostTotals)
                data["frCostTotals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.initiativeFactCostTotals)) {
            data["initiativeFactCostTotals"] = [];
            for (let item of this.initiativeFactCostTotals)
                data["initiativeFactCostTotals"].push(item ? item.toJSON() : undefined as any);
        }
        data["initiativeSnapshot"] = this.initiativeSnapshot ? this.initiativeSnapshot.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePForecastRevision {
    pk?: number;
    initiativeFk?: number;
    sourceEditStateId?: number;
    year?: number;
    month?: number;
    revisionName?: string | undefined;
    revisionNumber?: number;
    closedAt?: Date;
    frCostTotals?: OnePForecastRevisionCostTotals[] | undefined;
    initiativeFactCostTotals?: OnePInitiativeFactCostTotals[] | undefined;
    initiativeSnapshot?: OnePForecastRevisionInitiativeSnapshot;
}

export class OnePForecastRevisionCostTotals implements IOnePForecastRevisionCostTotals {
    pk?: number;
    onePForecastRevisionFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    onePForecastRevision?: OnePForecastRevision;

    constructor(data?: IOnePForecastRevisionCostTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.onePForecastRevisionFk = _data["onePForecastRevisionFk"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.category = _data["category"];
            this.amount = _data["amount"];
            this.onePForecastRevision = _data["onePForecastRevision"] ? OnePForecastRevision.fromJS(_data["onePForecastRevision"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePForecastRevisionCostTotals {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastRevisionCostTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["onePForecastRevisionFk"] = this.onePForecastRevisionFk;
        data["year"] = this.year;
        data["month"] = this.month;
        data["category"] = this.category;
        data["amount"] = this.amount;
        data["onePForecastRevision"] = this.onePForecastRevision ? this.onePForecastRevision.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePForecastRevisionCostTotals {
    pk?: number;
    onePForecastRevisionFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    onePForecastRevision?: OnePForecastRevision;
}

export class OnePForecastRevisionDTO implements IOnePForecastRevisionDTO {
    pk?: number;
    initiativeFk?: number;
    sourceEditStateId?: number;
    year?: number;
    month?: number;
    revisionName?: string | undefined;
    closedAt?: Date;

    constructor(data?: IOnePForecastRevisionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.sourceEditStateId = _data["sourceEditStateId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.revisionName = _data["revisionName"];
            this.closedAt = _data["closedAt"] ? new Date(_data["closedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OnePForecastRevisionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastRevisionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["sourceEditStateId"] = this.sourceEditStateId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["revisionName"] = this.revisionName;
        data["closedAt"] = this.closedAt ? this.closedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IOnePForecastRevisionDTO {
    pk?: number;
    initiativeFk?: number;
    sourceEditStateId?: number;
    year?: number;
    month?: number;
    revisionName?: string | undefined;
    closedAt?: Date;
}

export class OnePForecastRevisionDTOGridPagedResult implements IOnePForecastRevisionDTOGridPagedResult {
    items!: OnePForecastRevisionDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePForecastRevisionDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePForecastRevisionDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePForecastRevisionDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastRevisionDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePForecastRevisionDTOGridPagedResult {
    items: OnePForecastRevisionDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePForecastRevisionInitiativeSnapshot implements IOnePForecastRevisionInitiativeSnapshot {
    pk?: number;
    initiativeFk?: number;
    forecastRevisionFk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    complexity?: InitiativeComplexity;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    stageStatus?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    powerAppsPortfolioId?: string | undefined;
    createdOn?: Date;
    capturedAt?: Date;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    afeAmountStartDate?: string | undefined;
    afeAmountEndDate?: string | undefined;
    afeAmount?: number | undefined;
    approvedBudget?: number | undefined;
    initiative?: OnePInitiative;
    forecastRevision?: OnePForecastRevision;

    constructor(data?: IOnePForecastRevisionInitiativeSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.forecastRevisionFk = _data["forecastRevisionFk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.complexity = _data["complexity"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.stageStatus = _data["stageStatus"];
            this.financeStatus = _data["financeStatus"];
            this.createdBy = _data["createdBy"];
            this.powerAppsPortfolioId = _data["powerAppsPortfolioId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.capturedAt = _data["capturedAt"] ? new Date(_data["capturedAt"].toString()) : undefined as any;
            this.isCarriedOver = _data["isCarriedOver"];
            this.carriedOverFromInitiativeId = _data["carriedOverFromInitiativeId"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
            this.afeAmountStartDate = _data["afeAmountStartDate"];
            this.afeAmountEndDate = _data["afeAmountEndDate"];
            this.afeAmount = _data["afeAmount"];
            this.approvedBudget = _data["approvedBudget"];
            this.initiative = _data["initiative"] ? OnePInitiative.fromJS(_data["initiative"]) : undefined as any;
            this.forecastRevision = _data["forecastRevision"] ? OnePForecastRevision.fromJS(_data["forecastRevision"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePForecastRevisionInitiativeSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new OnePForecastRevisionInitiativeSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["forecastRevisionFk"] = this.forecastRevisionFk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["complexity"] = this.complexity;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["revisedOutlook"] = this.revisedOutlook;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["stageStatus"] = this.stageStatus;
        data["financeStatus"] = this.financeStatus;
        data["createdBy"] = this.createdBy;
        data["powerAppsPortfolioId"] = this.powerAppsPortfolioId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["capturedAt"] = this.capturedAt ? this.capturedAt.toISOString() : undefined as any;
        data["isCarriedOver"] = this.isCarriedOver;
        data["carriedOverFromInitiativeId"] = this.carriedOverFromInitiativeId;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        data["afeAmountStartDate"] = this.afeAmountStartDate;
        data["afeAmountEndDate"] = this.afeAmountEndDate;
        data["afeAmount"] = this.afeAmount;
        data["approvedBudget"] = this.approvedBudget;
        data["initiative"] = this.initiative ? this.initiative.toJSON() : undefined as any;
        data["forecastRevision"] = this.forecastRevision ? this.forecastRevision.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePForecastRevisionInitiativeSnapshot {
    pk?: number;
    initiativeFk?: number;
    forecastRevisionFk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    complexity?: InitiativeComplexity;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    stageStatus?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    powerAppsPortfolioId?: string | undefined;
    createdOn?: Date;
    capturedAt?: Date;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    afeAmountStartDate?: string | undefined;
    afeAmountEndDate?: string | undefined;
    afeAmount?: number | undefined;
    approvedBudget?: number | undefined;
    initiative?: OnePInitiative;
    forecastRevision?: OnePForecastRevision;
}

export class OnePInitiative implements IOnePInitiative {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    complexity?: InitiativeComplexity;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    stageStatus?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    powerAppsPortfolioId?: string | undefined;
    createdOn?: Date;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    onePStageHistories?: OnePStageHistory[] | undefined;
    onePInitiativeCostTotals?: OnePInitiativeCostTotals[] | undefined;
    onePForecastCostTotals?: OnePForecastCostTotals[] | undefined;
    onePProjectTeamDetails?: OnePProjectTeamDetail;
    onePProjectGovernanceContacts?: OnePProjectGovernanceContacts;
    initiativeBALinks?: OnePInitiativeBALink[] | undefined;
    initiativeEWRLinks?: OnePInitiativeEWRLink[] | undefined;
    initiativeFDMLinks?: OnePInitiativeFDMLink[] | undefined;
    initiativeEquipmentLinks?: OnePInitiativeEquipmentLink[] | undefined;
    initiativeWorkOrderLinks?: OnePInitiativeWorkOrderLink[] | undefined;
    revisionInitiativeSnapshot?: OnePForecastRevisionInitiativeSnapshot[] | undefined;
    carriedOverFromInitiative?: OnePInitiative;
    carriedOverChildren?: OnePInitiative[] | undefined;
    notes?: OnePInitiativeNote[] | undefined;
    onePInitiativeCoordinator?: OnePInitiativeCoordinator;

    constructor(data?: IOnePInitiative) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.complexity = _data["complexity"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.stageStatus = _data["stageStatus"];
            this.financeStatus = _data["financeStatus"];
            this.createdBy = _data["createdBy"];
            this.powerAppsPortfolioId = _data["powerAppsPortfolioId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.isCarriedOver = _data["isCarriedOver"];
            this.carriedOverFromInitiativeId = _data["carriedOverFromInitiativeId"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
            if (Array.isArray(_data["onePStageHistories"])) {
                this.onePStageHistories = [] as any;
                for (let item of _data["onePStageHistories"])
                    this.onePStageHistories!.push(OnePStageHistory.fromJS(item));
            }
            if (Array.isArray(_data["onePInitiativeCostTotals"])) {
                this.onePInitiativeCostTotals = [] as any;
                for (let item of _data["onePInitiativeCostTotals"])
                    this.onePInitiativeCostTotals!.push(OnePInitiativeCostTotals.fromJS(item));
            }
            if (Array.isArray(_data["onePForecastCostTotals"])) {
                this.onePForecastCostTotals = [] as any;
                for (let item of _data["onePForecastCostTotals"])
                    this.onePForecastCostTotals!.push(OnePForecastCostTotals.fromJS(item));
            }
            this.onePProjectTeamDetails = _data["onePProjectTeamDetails"] ? OnePProjectTeamDetail.fromJS(_data["onePProjectTeamDetails"]) : undefined as any;
            this.onePProjectGovernanceContacts = _data["onePProjectGovernanceContacts"] ? OnePProjectGovernanceContacts.fromJS(_data["onePProjectGovernanceContacts"]) : undefined as any;
            if (Array.isArray(_data["initiativeBALinks"])) {
                this.initiativeBALinks = [] as any;
                for (let item of _data["initiativeBALinks"])
                    this.initiativeBALinks!.push(OnePInitiativeBALink.fromJS(item));
            }
            if (Array.isArray(_data["initiativeEWRLinks"])) {
                this.initiativeEWRLinks = [] as any;
                for (let item of _data["initiativeEWRLinks"])
                    this.initiativeEWRLinks!.push(OnePInitiativeEWRLink.fromJS(item));
            }
            if (Array.isArray(_data["initiativeFDMLinks"])) {
                this.initiativeFDMLinks = [] as any;
                for (let item of _data["initiativeFDMLinks"])
                    this.initiativeFDMLinks!.push(OnePInitiativeFDMLink.fromJS(item));
            }
            if (Array.isArray(_data["initiativeEquipmentLinks"])) {
                this.initiativeEquipmentLinks = [] as any;
                for (let item of _data["initiativeEquipmentLinks"])
                    this.initiativeEquipmentLinks!.push(OnePInitiativeEquipmentLink.fromJS(item));
            }
            if (Array.isArray(_data["initiativeWorkOrderLinks"])) {
                this.initiativeWorkOrderLinks = [] as any;
                for (let item of _data["initiativeWorkOrderLinks"])
                    this.initiativeWorkOrderLinks!.push(OnePInitiativeWorkOrderLink.fromJS(item));
            }
            if (Array.isArray(_data["revisionInitiativeSnapshot"])) {
                this.revisionInitiativeSnapshot = [] as any;
                for (let item of _data["revisionInitiativeSnapshot"])
                    this.revisionInitiativeSnapshot!.push(OnePForecastRevisionInitiativeSnapshot.fromJS(item));
            }
            this.carriedOverFromInitiative = _data["carriedOverFromInitiative"] ? OnePInitiative.fromJS(_data["carriedOverFromInitiative"]) : undefined as any;
            if (Array.isArray(_data["carriedOverChildren"])) {
                this.carriedOverChildren = [] as any;
                for (let item of _data["carriedOverChildren"])
                    this.carriedOverChildren!.push(OnePInitiative.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(OnePInitiativeNote.fromJS(item));
            }
            this.onePInitiativeCoordinator = _data["onePInitiativeCoordinator"] ? OnePInitiativeCoordinator.fromJS(_data["onePInitiativeCoordinator"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiative {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiative();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["complexity"] = this.complexity;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["revisedOutlook"] = this.revisedOutlook;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["stageStatus"] = this.stageStatus;
        data["financeStatus"] = this.financeStatus;
        data["createdBy"] = this.createdBy;
        data["powerAppsPortfolioId"] = this.powerAppsPortfolioId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["isCarriedOver"] = this.isCarriedOver;
        data["carriedOverFromInitiativeId"] = this.carriedOverFromInitiativeId;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        if (Array.isArray(this.onePStageHistories)) {
            data["onePStageHistories"] = [];
            for (let item of this.onePStageHistories)
                data["onePStageHistories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.onePInitiativeCostTotals)) {
            data["onePInitiativeCostTotals"] = [];
            for (let item of this.onePInitiativeCostTotals)
                data["onePInitiativeCostTotals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.onePForecastCostTotals)) {
            data["onePForecastCostTotals"] = [];
            for (let item of this.onePForecastCostTotals)
                data["onePForecastCostTotals"].push(item ? item.toJSON() : undefined as any);
        }
        data["onePProjectTeamDetails"] = this.onePProjectTeamDetails ? this.onePProjectTeamDetails.toJSON() : undefined as any;
        data["onePProjectGovernanceContacts"] = this.onePProjectGovernanceContacts ? this.onePProjectGovernanceContacts.toJSON() : undefined as any;
        if (Array.isArray(this.initiativeBALinks)) {
            data["initiativeBALinks"] = [];
            for (let item of this.initiativeBALinks)
                data["initiativeBALinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.initiativeEWRLinks)) {
            data["initiativeEWRLinks"] = [];
            for (let item of this.initiativeEWRLinks)
                data["initiativeEWRLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.initiativeFDMLinks)) {
            data["initiativeFDMLinks"] = [];
            for (let item of this.initiativeFDMLinks)
                data["initiativeFDMLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.initiativeEquipmentLinks)) {
            data["initiativeEquipmentLinks"] = [];
            for (let item of this.initiativeEquipmentLinks)
                data["initiativeEquipmentLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.initiativeWorkOrderLinks)) {
            data["initiativeWorkOrderLinks"] = [];
            for (let item of this.initiativeWorkOrderLinks)
                data["initiativeWorkOrderLinks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.revisionInitiativeSnapshot)) {
            data["revisionInitiativeSnapshot"] = [];
            for (let item of this.revisionInitiativeSnapshot)
                data["revisionInitiativeSnapshot"].push(item ? item.toJSON() : undefined as any);
        }
        data["carriedOverFromInitiative"] = this.carriedOverFromInitiative ? this.carriedOverFromInitiative.toJSON() : undefined as any;
        if (Array.isArray(this.carriedOverChildren)) {
            data["carriedOverChildren"] = [];
            for (let item of this.carriedOverChildren)
                data["carriedOverChildren"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        data["onePInitiativeCoordinator"] = this.onePInitiativeCoordinator ? this.onePInitiativeCoordinator.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiative {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    complexity?: InitiativeComplexity;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    stageStatus?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    powerAppsPortfolioId?: string | undefined;
    createdOn?: Date;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    onePStageHistories?: OnePStageHistory[] | undefined;
    onePInitiativeCostTotals?: OnePInitiativeCostTotals[] | undefined;
    onePForecastCostTotals?: OnePForecastCostTotals[] | undefined;
    onePProjectTeamDetails?: OnePProjectTeamDetail;
    onePProjectGovernanceContacts?: OnePProjectGovernanceContacts;
    initiativeBALinks?: OnePInitiativeBALink[] | undefined;
    initiativeEWRLinks?: OnePInitiativeEWRLink[] | undefined;
    initiativeFDMLinks?: OnePInitiativeFDMLink[] | undefined;
    initiativeEquipmentLinks?: OnePInitiativeEquipmentLink[] | undefined;
    initiativeWorkOrderLinks?: OnePInitiativeWorkOrderLink[] | undefined;
    revisionInitiativeSnapshot?: OnePForecastRevisionInitiativeSnapshot[] | undefined;
    carriedOverFromInitiative?: OnePInitiative;
    carriedOverChildren?: OnePInitiative[] | undefined;
    notes?: OnePInitiativeNote[] | undefined;
    onePInitiativeCoordinator?: OnePInitiativeCoordinator;
}

export class OnePInitiativeActualCostCodeDictionary implements IOnePInitiativeActualCostCodeDictionary {
    pk?: number;
    name?: string | undefined;
    code?: string | undefined;
    parent?: string | undefined;

    constructor(data?: IOnePInitiativeActualCostCodeDictionary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.parent = _data["parent"];
        }
    }

    static fromJS(data: any): OnePInitiativeActualCostCodeDictionary {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeActualCostCodeDictionary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["name"] = this.name;
        data["code"] = this.code;
        data["parent"] = this.parent;
        return data;
    }
}

export interface IOnePInitiativeActualCostCodeDictionary {
    pk?: number;
    name?: string | undefined;
    code?: string | undefined;
    parent?: string | undefined;
}

export class OnePInitiativeActualCostCodeDictionaryDTO implements IOnePInitiativeActualCostCodeDictionaryDTO {
    pk?: number;
    name?: string | undefined;
    code?: string | undefined;
    parent?: string | undefined;

    constructor(data?: IOnePInitiativeActualCostCodeDictionaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.parent = _data["parent"];
        }
    }

    static fromJS(data: any): OnePInitiativeActualCostCodeDictionaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeActualCostCodeDictionaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["name"] = this.name;
        data["code"] = this.code;
        data["parent"] = this.parent;
        return data;
    }
}

export interface IOnePInitiativeActualCostCodeDictionaryDTO {
    pk?: number;
    name?: string | undefined;
    code?: string | undefined;
    parent?: string | undefined;
}

export class OnePInitiativeBALink implements IOnePInitiativeBALink {
    initiativeId?: number;
    onePInitiative?: OnePInitiative;
    badActorId?: string;
    extBadActorData?: ExtBadActorData;
    linkedAt?: Date;
    linkedBy?: string | undefined;

    constructor(data?: IOnePInitiativeBALink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
            this.badActorId = _data["badActorId"];
            this.extBadActorData = _data["extBadActorData"] ? ExtBadActorData.fromJS(_data["extBadActorData"]) : undefined as any;
            this.linkedAt = _data["linkedAt"] ? new Date(_data["linkedAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
        }
    }

    static fromJS(data: any): OnePInitiativeBALink {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeBALink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        data["badActorId"] = this.badActorId;
        data["extBadActorData"] = this.extBadActorData ? this.extBadActorData.toJSON() : undefined as any;
        data["linkedAt"] = this.linkedAt ? this.linkedAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        return data;
    }
}

export interface IOnePInitiativeBALink {
    initiativeId?: number;
    onePInitiative?: OnePInitiative;
    badActorId?: string;
    extBadActorData?: ExtBadActorData;
    linkedAt?: Date;
    linkedBy?: string | undefined;
}

export class OnePInitiativeBALinkItemDTO implements IOnePInitiativeBALinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    badActorData?: ExtBadActorData;

    constructor(data?: IOnePInitiativeBALinkItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linketAt = _data["linketAt"] ? new Date(_data["linketAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
            this.badActorData = _data["badActorData"] ? ExtBadActorData.fromJS(_data["badActorData"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeBALinkItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeBALinkItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linketAt"] = this.linketAt ? this.linketAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        data["badActorData"] = this.badActorData ? this.badActorData.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeBALinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    badActorData?: ExtBadActorData;
}

export class OnePInitiativeComplexityDTO implements IOnePInitiativeComplexityDTO {
    complexityName?: string | undefined;
    complexityValue?: number;

    constructor(data?: IOnePInitiativeComplexityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.complexityName = _data["complexityName"];
            this.complexityValue = _data["complexityValue"];
        }
    }

    static fromJS(data: any): OnePInitiativeComplexityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeComplexityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["complexityName"] = this.complexityName;
        data["complexityValue"] = this.complexityValue;
        return data;
    }
}

export interface IOnePInitiativeComplexityDTO {
    complexityName?: string | undefined;
    complexityValue?: number;
}

export class OnePInitiativeCoordinator implements IOnePInitiativeCoordinator {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    initiativeFk?: number;
    onePInitiative?: OnePInitiative;

    constructor(data?: IOnePInitiativeCoordinator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.coordinatorName = _data["coordinatorName"];
            this.coordinatorEmail = _data["coordinatorEmail"];
            this.backToBackName = _data["backToBackName"];
            this.backToBackEmail = _data["backToBackEmail"];
            this.supervisorName = _data["supervisorName"];
            this.supervisorEmail = _data["supervisorEmail"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.initiativeFk = _data["initiativeFk"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeCoordinator {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeCoordinator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["coordinatorName"] = this.coordinatorName;
        data["coordinatorEmail"] = this.coordinatorEmail;
        data["backToBackName"] = this.backToBackName;
        data["backToBackEmail"] = this.backToBackEmail;
        data["supervisorName"] = this.supervisorName;
        data["supervisorEmail"] = this.supervisorEmail;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["initiativeFk"] = this.initiativeFk;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeCoordinator {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
    initiativeFk?: number;
    onePInitiative?: OnePInitiative;
}

export class OnePInitiativeCoordinatorCreateUpdateDTO implements IOnePInitiativeCoordinatorCreateUpdateDTO {
    pk?: number;
    initiativeFk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;

    constructor(data?: IOnePInitiativeCoordinatorCreateUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.coordinatorName = _data["coordinatorName"];
            this.coordinatorEmail = _data["coordinatorEmail"];
            this.backToBackName = _data["backToBackName"];
            this.backToBackEmail = _data["backToBackEmail"];
            this.supervisorName = _data["supervisorName"];
            this.supervisorEmail = _data["supervisorEmail"];
        }
    }

    static fromJS(data: any): OnePInitiativeCoordinatorCreateUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeCoordinatorCreateUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["coordinatorName"] = this.coordinatorName;
        data["coordinatorEmail"] = this.coordinatorEmail;
        data["backToBackName"] = this.backToBackName;
        data["backToBackEmail"] = this.backToBackEmail;
        data["supervisorName"] = this.supervisorName;
        data["supervisorEmail"] = this.supervisorEmail;
        return data;
    }
}

export interface IOnePInitiativeCoordinatorCreateUpdateDTO {
    pk?: number;
    initiativeFk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
}

export class OnePInitiativeCoordinatorReadDTO implements IOnePInitiativeCoordinatorReadDTO {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;

    constructor(data?: IOnePInitiativeCoordinatorReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.coordinatorName = _data["coordinatorName"];
            this.coordinatorEmail = _data["coordinatorEmail"];
            this.backToBackName = _data["backToBackName"];
            this.backToBackEmail = _data["backToBackEmail"];
            this.supervisorName = _data["supervisorName"];
            this.supervisorEmail = _data["supervisorEmail"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeCoordinatorReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeCoordinatorReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["coordinatorName"] = this.coordinatorName;
        data["coordinatorEmail"] = this.coordinatorEmail;
        data["backToBackName"] = this.backToBackName;
        data["backToBackEmail"] = this.backToBackEmail;
        data["supervisorName"] = this.supervisorName;
        data["supervisorEmail"] = this.supervisorEmail;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeCoordinatorReadDTO {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
}

export class OnePInitiativeCostTotals implements IOnePInitiativeCostTotals {
    pk?: number;
    initiativeFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    hasActualsAmount?: boolean;
    isActualsAmountEditedByUser?: boolean;
    onePInitiative?: OnePInitiative;

    constructor(data?: IOnePInitiativeCostTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.category = _data["category"];
            this.amount = _data["amount"];
            this.hasActualsAmount = _data["hasActualsAmount"];
            this.isActualsAmountEditedByUser = _data["isActualsAmountEditedByUser"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeCostTotals {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeCostTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["year"] = this.year;
        data["month"] = this.month;
        data["category"] = this.category;
        data["amount"] = this.amount;
        data["hasActualsAmount"] = this.hasActualsAmount;
        data["isActualsAmountEditedByUser"] = this.isActualsAmountEditedByUser;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeCostTotals {
    pk?: number;
    initiativeFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    hasActualsAmount?: boolean;
    isActualsAmountEditedByUser?: boolean;
    onePInitiative?: OnePInitiative;
}

export class OnePInitiativeCreateLinkDTO implements IOnePInitiativeCreateLinkDTO {
    initiativeId?: number;
    reportId?: string;

    constructor(data?: IOnePInitiativeCreateLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): OnePInitiativeCreateLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeCreateLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IOnePInitiativeCreateLinkDTO {
    initiativeId?: number;
    reportId?: string;
}

export class OnePInitiativeDTO implements IOnePInitiativeDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    complexity?: InitiativeComplexity;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    stageStatus?: string | undefined;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    currentFyGrandTotal?: number;
    lastFyGrandTotal?: number;
    onePProjectTeamDetails?: OnePProjectTeamDetailDTO;
    onePProjectGovernanceContacts?: OnePProjectGovernanceContactsDTO;
    onePInitiativeCoordinators?: OnePInitiativeCoordinatorReadDTO;

    constructor(data?: IOnePInitiativeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.complexity = _data["complexity"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.financeStatus = _data["financeStatus"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.stageStatus = _data["stageStatus"];
            this.isCarriedOver = _data["isCarriedOver"];
            this.carriedOverFromInitiativeId = _data["carriedOverFromInitiativeId"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
            this.currentFyGrandTotal = _data["currentFyGrandTotal"];
            this.lastFyGrandTotal = _data["lastFyGrandTotal"];
            this.onePProjectTeamDetails = _data["onePProjectTeamDetails"] ? OnePProjectTeamDetailDTO.fromJS(_data["onePProjectTeamDetails"]) : undefined as any;
            this.onePProjectGovernanceContacts = _data["onePProjectGovernanceContacts"] ? OnePProjectGovernanceContactsDTO.fromJS(_data["onePProjectGovernanceContacts"]) : undefined as any;
            this.onePInitiativeCoordinators = _data["onePInitiativeCoordinators"] ? OnePInitiativeCoordinatorReadDTO.fromJS(_data["onePInitiativeCoordinators"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["complexity"] = this.complexity;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["revisedOutlook"] = this.revisedOutlook;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["financeStatus"] = this.financeStatus;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["stageStatus"] = this.stageStatus;
        data["isCarriedOver"] = this.isCarriedOver;
        data["carriedOverFromInitiativeId"] = this.carriedOverFromInitiativeId;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        data["currentFyGrandTotal"] = this.currentFyGrandTotal;
        data["lastFyGrandTotal"] = this.lastFyGrandTotal;
        data["onePProjectTeamDetails"] = this.onePProjectTeamDetails ? this.onePProjectTeamDetails.toJSON() : undefined as any;
        data["onePProjectGovernanceContacts"] = this.onePProjectGovernanceContacts ? this.onePProjectGovernanceContacts.toJSON() : undefined as any;
        data["onePInitiativeCoordinators"] = this.onePInitiativeCoordinators ? this.onePInitiativeCoordinators.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    complexity?: InitiativeComplexity;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    stageStatus?: string | undefined;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    currentFyGrandTotal?: number;
    lastFyGrandTotal?: number;
    onePProjectTeamDetails?: OnePProjectTeamDetailDTO;
    onePProjectGovernanceContacts?: OnePProjectGovernanceContactsDTO;
    onePInitiativeCoordinators?: OnePInitiativeCoordinatorReadDTO;
}

export class OnePInitiativeDTOGridPagedResult implements IOnePInitiativeDTOGridPagedResult {
    items!: OnePInitiativeDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePInitiativeDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePInitiativeDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePInitiativeDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePInitiativeDTOGridPagedResult {
    items: OnePInitiativeDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePInitiativeEWRLink implements IOnePInitiativeEWRLink {
    initiativeId?: number;
    onePInitiative?: OnePInitiative;
    ewrId?: string;
    extEwr?: ExtEwr;
    linkedAt?: Date;
    linkedBy?: string | undefined;

    constructor(data?: IOnePInitiativeEWRLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
            this.ewrId = _data["ewrId"];
            this.extEwr = _data["extEwr"] ? ExtEwr.fromJS(_data["extEwr"]) : undefined as any;
            this.linkedAt = _data["linkedAt"] ? new Date(_data["linkedAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
        }
    }

    static fromJS(data: any): OnePInitiativeEWRLink {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeEWRLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        data["ewrId"] = this.ewrId;
        data["extEwr"] = this.extEwr ? this.extEwr.toJSON() : undefined as any;
        data["linkedAt"] = this.linkedAt ? this.linkedAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        return data;
    }
}

export interface IOnePInitiativeEWRLink {
    initiativeId?: number;
    onePInitiative?: OnePInitiative;
    ewrId?: string;
    extEwr?: ExtEwr;
    linkedAt?: Date;
    linkedBy?: string | undefined;
}

export class OnePInitiativeEWRLinkItemDTO implements IOnePInitiativeEWRLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    ewr?: ExtEwr;

    constructor(data?: IOnePInitiativeEWRLinkItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linketAt = _data["linketAt"] ? new Date(_data["linketAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
            this.ewr = _data["ewr"] ? ExtEwr.fromJS(_data["ewr"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeEWRLinkItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeEWRLinkItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linketAt"] = this.linketAt ? this.linketAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        data["ewr"] = this.ewr ? this.ewr.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeEWRLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    ewr?: ExtEwr;
}

export class OnePInitiativeEquipmentLink implements IOnePInitiativeEquipmentLink {
    pk?: number;
    initiativeId?: number;
    id?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;
    linkedAt?: Date;
    linkedBy?: string | undefined;
    onePInitiative?: OnePInitiative;
    onePFdmDimEquipment?: OnePInitiativeFdmDimEquipment;

    constructor(data?: IOnePInitiativeEquipmentLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeId = _data["initiativeId"];
            this.id = _data["id"];
            this.tagNumber = _data["tagNumber"];
            this.sourceSystem = _data["sourceSystem"];
            this.linkedAt = _data["linkedAt"] ? new Date(_data["linkedAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
            this.onePFdmDimEquipment = _data["onePFdmDimEquipment"] ? OnePInitiativeFdmDimEquipment.fromJS(_data["onePFdmDimEquipment"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeEquipmentLink {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeEquipmentLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeId"] = this.initiativeId;
        data["id"] = this.id;
        data["tagNumber"] = this.tagNumber;
        data["sourceSystem"] = this.sourceSystem;
        data["linkedAt"] = this.linkedAt ? this.linkedAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        data["onePFdmDimEquipment"] = this.onePFdmDimEquipment ? this.onePFdmDimEquipment.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeEquipmentLink {
    pk?: number;
    initiativeId?: number;
    id?: string | undefined;
    tagNumber?: string | undefined;
    sourceSystem?: string | undefined;
    linkedAt?: Date;
    linkedBy?: string | undefined;
    onePInitiative?: OnePInitiative;
    onePFdmDimEquipment?: OnePInitiativeFdmDimEquipment;
}

export class OnePInitiativeEquipmentLinkItemDTO implements IOnePInitiativeEquipmentLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    equipment?: OnePInitiativeFdmDimEquipment;

    constructor(data?: IOnePInitiativeEquipmentLinkItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linketAt = _data["linketAt"] ? new Date(_data["linketAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
            this.equipment = _data["equipment"] ? OnePInitiativeFdmDimEquipment.fromJS(_data["equipment"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeEquipmentLinkItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeEquipmentLinkItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linketAt"] = this.linketAt ? this.linketAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        data["equipment"] = this.equipment ? this.equipment.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeEquipmentLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    equipment?: OnePInitiativeFdmDimEquipment;
}

export class OnePInitiativeFDMLink implements IOnePInitiativeFDMLink {
    initiativeId?: number;
    onePInitiative?: OnePInitiative;
    fdmId?: string;
    extFdm?: ExtFdm;
    linkedAt?: Date;
    linkedBy?: string | undefined;

    constructor(data?: IOnePInitiativeFDMLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
            this.fdmId = _data["fdmId"];
            this.extFdm = _data["extFdm"] ? ExtFdm.fromJS(_data["extFdm"]) : undefined as any;
            this.linkedAt = _data["linkedAt"] ? new Date(_data["linkedAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
        }
    }

    static fromJS(data: any): OnePInitiativeFDMLink {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFDMLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        data["fdmId"] = this.fdmId;
        data["extFdm"] = this.extFdm ? this.extFdm.toJSON() : undefined as any;
        data["linkedAt"] = this.linkedAt ? this.linkedAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        return data;
    }
}

export interface IOnePInitiativeFDMLink {
    initiativeId?: number;
    onePInitiative?: OnePInitiative;
    fdmId?: string;
    extFdm?: ExtFdm;
    linkedAt?: Date;
    linkedBy?: string | undefined;
}

export class OnePInitiativeFDMLinkItemDTO implements IOnePInitiativeFDMLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    fdm?: ExtFdm;

    constructor(data?: IOnePInitiativeFDMLinkItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linketAt = _data["linketAt"] ? new Date(_data["linketAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
            this.fdm = _data["fdm"] ? ExtFdm.fromJS(_data["fdm"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeFDMLinkItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFDMLinkItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linketAt"] = this.linketAt ? this.linketAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        data["fdm"] = this.fdm ? this.fdm.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeFDMLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    fdm?: ExtFdm;
}

export class OnePInitiativeFactCostTotals implements IOnePInitiativeFactCostTotals {
    pk?: number;
    forecastRevisionFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    revision?: OnePForecastRevision;

    constructor(data?: IOnePInitiativeFactCostTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.forecastRevisionFk = _data["forecastRevisionFk"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.category = _data["category"];
            this.amount = _data["amount"];
            this.revision = _data["revision"] ? OnePForecastRevision.fromJS(_data["revision"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeFactCostTotals {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFactCostTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["forecastRevisionFk"] = this.forecastRevisionFk;
        data["year"] = this.year;
        data["month"] = this.month;
        data["category"] = this.category;
        data["amount"] = this.amount;
        data["revision"] = this.revision ? this.revision.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeFactCostTotals {
    pk?: number;
    forecastRevisionFk?: number;
    year?: number;
    month?: number;
    category?: ProjectCostTotalCategory;
    amount?: number;
    revision?: OnePForecastRevision;
}

export class OnePInitiativeFactWithForecastPlanDTO implements IOnePInitiativeFactWithForecastPlanDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    stageStatus?: string | undefined;
    revisedOutlook?: number | undefined;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    projectOwnerEmail?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    breakInOutJustification?: string | undefined;
    afeAmount?: number | undefined;
    approvedBudget?: number | undefined;
    initiativeFactCostTotals?: OnePProjectCostTotalsDTO;
    forecastRevisionCostTotals?: OnePProjectCostTotalsDTO;
    deltaCostTotals?: OnePProjectCostTotalsDTO;

    constructor(data?: IOnePInitiativeFactWithForecastPlanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.financeStatus = _data["financeStatus"];
            this.stageStatus = _data["stageStatus"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.isCarriedOver = _data["isCarriedOver"];
            this.carriedOverFromInitiativeId = _data["carriedOverFromInitiativeId"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
            this.breakInOutJustification = _data["breakInOutJustification"];
            this.afeAmount = _data["afeAmount"];
            this.approvedBudget = _data["approvedBudget"];
            this.initiativeFactCostTotals = _data["initiativeFactCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["initiativeFactCostTotals"]) : undefined as any;
            this.forecastRevisionCostTotals = _data["forecastRevisionCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["forecastRevisionCostTotals"]) : undefined as any;
            this.deltaCostTotals = _data["deltaCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["deltaCostTotals"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeFactWithForecastPlanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFactWithForecastPlanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["financeStatus"] = this.financeStatus;
        data["stageStatus"] = this.stageStatus;
        data["revisedOutlook"] = this.revisedOutlook;
        data["isCarriedOver"] = this.isCarriedOver;
        data["carriedOverFromInitiativeId"] = this.carriedOverFromInitiativeId;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        data["breakInOutJustification"] = this.breakInOutJustification;
        data["afeAmount"] = this.afeAmount;
        data["approvedBudget"] = this.approvedBudget;
        data["initiativeFactCostTotals"] = this.initiativeFactCostTotals ? this.initiativeFactCostTotals.toJSON() : undefined as any;
        data["forecastRevisionCostTotals"] = this.forecastRevisionCostTotals ? this.forecastRevisionCostTotals.toJSON() : undefined as any;
        data["deltaCostTotals"] = this.deltaCostTotals ? this.deltaCostTotals.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeFactWithForecastPlanDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    stageStatus?: string | undefined;
    revisedOutlook?: number | undefined;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    projectOwnerEmail?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    breakInOutJustification?: string | undefined;
    afeAmount?: number | undefined;
    approvedBudget?: number | undefined;
    initiativeFactCostTotals?: OnePProjectCostTotalsDTO;
    forecastRevisionCostTotals?: OnePProjectCostTotalsDTO;
    deltaCostTotals?: OnePProjectCostTotalsDTO;
}

export class OnePInitiativeFactWithForecastPlanDTOGridPagedResult implements IOnePInitiativeFactWithForecastPlanDTOGridPagedResult {
    items!: OnePInitiativeFactWithForecastPlanDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePInitiativeFactWithForecastPlanDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePInitiativeFactWithForecastPlanDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePInitiativeFactWithForecastPlanDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFactWithForecastPlanDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePInitiativeFactWithForecastPlanDTOGridPagedResult {
    items: OnePInitiativeFactWithForecastPlanDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePInitiativeFdmDimEquipment implements IOnePInitiativeFdmDimEquipment {
    linkFk?: number;
    initiativeFk?: number;
    id?: string | undefined;
    e1Id?: string | undefined;
    tagNumber?: string | undefined;
    descriptionEn?: string | undefined;
    descriptionRu?: string | undefined;
    sourceSystem?: string | undefined;
    statusCode?: string | undefined;
    integrityCriticalityCode?: string | undefined;
    integrityCriticalityDescription?: string | undefined;
    equipmentCriticalityCode?: string | undefined;
    equipmentCriticalityDescription?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;
    systemGroupCode?: string | undefined;
    systemGroupDescription?: string | undefined;
    classCode?: string | undefined;
    classDescription?: string | undefined;
    subClassCode?: string | undefined;
    subClassDescription?: string | undefined;
    serialNumber?: string | undefined;
    capsPlant?: number | undefined;
    capsUnit?: number | undefined;
    capsInspector?: number | undefined;
    equipmentType?: number | undefined;
    businessUnit?: string | undefined;
    costObjectBusinessUnit?: string | undefined;
    description3?: string | undefined;
    remark2?: string | undefined;
    faacl7?: string | undefined;
    initiativeLink?: OnePInitiativeEquipmentLink;

    constructor(data?: IOnePInitiativeFdmDimEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkFk = _data["linkFk"];
            this.initiativeFk = _data["initiativeFk"];
            this.id = _data["id"];
            this.e1Id = _data["e1Id"];
            this.tagNumber = _data["tagNumber"];
            this.descriptionEn = _data["descriptionEn"];
            this.descriptionRu = _data["descriptionRu"];
            this.sourceSystem = _data["sourceSystem"];
            this.statusCode = _data["statusCode"];
            this.integrityCriticalityCode = _data["integrityCriticalityCode"];
            this.integrityCriticalityDescription = _data["integrityCriticalityDescription"];
            this.equipmentCriticalityCode = _data["equipmentCriticalityCode"];
            this.equipmentCriticalityDescription = _data["equipmentCriticalityDescription"];
            this.facilityCode = _data["facilityCode"];
            this.facilityDescription = _data["facilityDescription"];
            this.areaCode = _data["areaCode"];
            this.areaDescription = _data["areaDescription"];
            this.unitCode = _data["unitCode"];
            this.unitDescription = _data["unitDescription"];
            this.systemGroupCode = _data["systemGroupCode"];
            this.systemGroupDescription = _data["systemGroupDescription"];
            this.classCode = _data["classCode"];
            this.classDescription = _data["classDescription"];
            this.subClassCode = _data["subClassCode"];
            this.subClassDescription = _data["subClassDescription"];
            this.serialNumber = _data["serialNumber"];
            this.capsPlant = _data["capsPlant"];
            this.capsUnit = _data["capsUnit"];
            this.capsInspector = _data["capsInspector"];
            this.equipmentType = _data["equipmentType"];
            this.businessUnit = _data["businessUnit"];
            this.costObjectBusinessUnit = _data["costObjectBusinessUnit"];
            this.description3 = _data["description3"];
            this.remark2 = _data["remark2"];
            this.faacl7 = _data["faacl7"];
            this.initiativeLink = _data["initiativeLink"] ? OnePInitiativeEquipmentLink.fromJS(_data["initiativeLink"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeFdmDimEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFdmDimEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkFk"] = this.linkFk;
        data["initiativeFk"] = this.initiativeFk;
        data["id"] = this.id;
        data["e1Id"] = this.e1Id;
        data["tagNumber"] = this.tagNumber;
        data["descriptionEn"] = this.descriptionEn;
        data["descriptionRu"] = this.descriptionRu;
        data["sourceSystem"] = this.sourceSystem;
        data["statusCode"] = this.statusCode;
        data["integrityCriticalityCode"] = this.integrityCriticalityCode;
        data["integrityCriticalityDescription"] = this.integrityCriticalityDescription;
        data["equipmentCriticalityCode"] = this.equipmentCriticalityCode;
        data["equipmentCriticalityDescription"] = this.equipmentCriticalityDescription;
        data["facilityCode"] = this.facilityCode;
        data["facilityDescription"] = this.facilityDescription;
        data["areaCode"] = this.areaCode;
        data["areaDescription"] = this.areaDescription;
        data["unitCode"] = this.unitCode;
        data["unitDescription"] = this.unitDescription;
        data["systemGroupCode"] = this.systemGroupCode;
        data["systemGroupDescription"] = this.systemGroupDescription;
        data["classCode"] = this.classCode;
        data["classDescription"] = this.classDescription;
        data["subClassCode"] = this.subClassCode;
        data["subClassDescription"] = this.subClassDescription;
        data["serialNumber"] = this.serialNumber;
        data["capsPlant"] = this.capsPlant;
        data["capsUnit"] = this.capsUnit;
        data["capsInspector"] = this.capsInspector;
        data["equipmentType"] = this.equipmentType;
        data["businessUnit"] = this.businessUnit;
        data["costObjectBusinessUnit"] = this.costObjectBusinessUnit;
        data["description3"] = this.description3;
        data["remark2"] = this.remark2;
        data["faacl7"] = this.faacl7;
        data["initiativeLink"] = this.initiativeLink ? this.initiativeLink.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeFdmDimEquipment {
    linkFk?: number;
    initiativeFk?: number;
    id?: string | undefined;
    e1Id?: string | undefined;
    tagNumber?: string | undefined;
    descriptionEn?: string | undefined;
    descriptionRu?: string | undefined;
    sourceSystem?: string | undefined;
    statusCode?: string | undefined;
    integrityCriticalityCode?: string | undefined;
    integrityCriticalityDescription?: string | undefined;
    equipmentCriticalityCode?: string | undefined;
    equipmentCriticalityDescription?: string | undefined;
    facilityCode?: string | undefined;
    facilityDescription?: string | undefined;
    areaCode?: string | undefined;
    areaDescription?: string | undefined;
    unitCode?: string | undefined;
    unitDescription?: string | undefined;
    systemGroupCode?: string | undefined;
    systemGroupDescription?: string | undefined;
    classCode?: string | undefined;
    classDescription?: string | undefined;
    subClassCode?: string | undefined;
    subClassDescription?: string | undefined;
    serialNumber?: string | undefined;
    capsPlant?: number | undefined;
    capsUnit?: number | undefined;
    capsInspector?: number | undefined;
    equipmentType?: number | undefined;
    businessUnit?: string | undefined;
    costObjectBusinessUnit?: string | undefined;
    description3?: string | undefined;
    remark2?: string | undefined;
    faacl7?: string | undefined;
    initiativeLink?: OnePInitiativeEquipmentLink;
}

export class OnePInitiativeFdmDimEquipmentGridPagedResult implements IOnePInitiativeFdmDimEquipmentGridPagedResult {
    items!: OnePInitiativeFdmDimEquipment[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePInitiativeFdmDimEquipmentGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePInitiativeFdmDimEquipment.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePInitiativeFdmDimEquipmentGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFdmDimEquipmentGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePInitiativeFdmDimEquipmentGridPagedResult {
    items: OnePInitiativeFdmDimEquipment[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePInitiativeFdmWorkOrder implements IOnePInitiativeFdmWorkOrder {
    linkFk?: number;
    woNumberCode?: string | undefined;
    creationDate?: string | undefined;
    woType?: string | undefined;
    woPriority?: string | undefined;
    plannedCompletionDate?: string | undefined;
    actualCompletionDate?: string | undefined;
    workOrderStatusCode?: string | undefined;
    problemDescription?: string | undefined;
    woClassification?: string | undefined;
    equipmentId?: string | undefined;
    equipmentNumber?: string | undefined;
    categoryCode?: string | undefined;
    statusComment?: string | undefined;
    woDescription?: string | undefined;
    locationCode?: string | undefined;
    woDocumentType?: string | undefined;
    assignmentRoleCode?: string | undefined;
    systemGroupCode?: string | undefined;
    leadCraft?: string | undefined;
    branch?: string | undefined;
    actualLaborAmount?: string | undefined;
    actualOtherWorkAmount?: string | undefined;
    actualMaterialAmount?: string | undefined;
    lpoCostJde?: string | undefined;
    plannedStartDate?: string | undefined;
    estimatedEndDate?: string | undefined;
    workOrderStatusName?: string | undefined;
    woTypeSched?: string | undefined;
    woTypeSchedName?: string | undefined;
    locationName?: string | undefined;
    systemGroupName?: string | undefined;
    woDocumentTypeName?: string | undefined;
    leadCraftName?: string | undefined;
    woFirstStatusDate?: Date | undefined;
    woLastStatusDate?: Date | undefined;
    initiativeLink?: OnePInitiativeWorkOrderLink;

    constructor(data?: IOnePInitiativeFdmWorkOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkFk = _data["linkFk"];
            this.woNumberCode = _data["woNumberCode"];
            this.creationDate = _data["creationDate"];
            this.woType = _data["woType"];
            this.woPriority = _data["woPriority"];
            this.plannedCompletionDate = _data["plannedCompletionDate"];
            this.actualCompletionDate = _data["actualCompletionDate"];
            this.workOrderStatusCode = _data["workOrderStatusCode"];
            this.problemDescription = _data["problemDescription"];
            this.woClassification = _data["woClassification"];
            this.equipmentId = _data["equipmentId"];
            this.equipmentNumber = _data["equipmentNumber"];
            this.categoryCode = _data["categoryCode"];
            this.statusComment = _data["statusComment"];
            this.woDescription = _data["woDescription"];
            this.locationCode = _data["locationCode"];
            this.woDocumentType = _data["woDocumentType"];
            this.assignmentRoleCode = _data["assignmentRoleCode"];
            this.systemGroupCode = _data["systemGroupCode"];
            this.leadCraft = _data["leadCraft"];
            this.branch = _data["branch"];
            this.actualLaborAmount = _data["actualLaborAmount"];
            this.actualOtherWorkAmount = _data["actualOtherWorkAmount"];
            this.actualMaterialAmount = _data["actualMaterialAmount"];
            this.lpoCostJde = _data["lpoCostJde"];
            this.plannedStartDate = _data["plannedStartDate"];
            this.estimatedEndDate = _data["estimatedEndDate"];
            this.workOrderStatusName = _data["workOrderStatusName"];
            this.woTypeSched = _data["woTypeSched"];
            this.woTypeSchedName = _data["woTypeSchedName"];
            this.locationName = _data["locationName"];
            this.systemGroupName = _data["systemGroupName"];
            this.woDocumentTypeName = _data["woDocumentTypeName"];
            this.leadCraftName = _data["leadCraftName"];
            this.woFirstStatusDate = _data["woFirstStatusDate"] ? new Date(_data["woFirstStatusDate"].toString()) : undefined as any;
            this.woLastStatusDate = _data["woLastStatusDate"] ? new Date(_data["woLastStatusDate"].toString()) : undefined as any;
            this.initiativeLink = _data["initiativeLink"] ? OnePInitiativeWorkOrderLink.fromJS(_data["initiativeLink"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeFdmWorkOrder {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeFdmWorkOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkFk"] = this.linkFk;
        data["woNumberCode"] = this.woNumberCode;
        data["creationDate"] = this.creationDate;
        data["woType"] = this.woType;
        data["woPriority"] = this.woPriority;
        data["plannedCompletionDate"] = this.plannedCompletionDate;
        data["actualCompletionDate"] = this.actualCompletionDate;
        data["workOrderStatusCode"] = this.workOrderStatusCode;
        data["problemDescription"] = this.problemDescription;
        data["woClassification"] = this.woClassification;
        data["equipmentId"] = this.equipmentId;
        data["equipmentNumber"] = this.equipmentNumber;
        data["categoryCode"] = this.categoryCode;
        data["statusComment"] = this.statusComment;
        data["woDescription"] = this.woDescription;
        data["locationCode"] = this.locationCode;
        data["woDocumentType"] = this.woDocumentType;
        data["assignmentRoleCode"] = this.assignmentRoleCode;
        data["systemGroupCode"] = this.systemGroupCode;
        data["leadCraft"] = this.leadCraft;
        data["branch"] = this.branch;
        data["actualLaborAmount"] = this.actualLaborAmount;
        data["actualOtherWorkAmount"] = this.actualOtherWorkAmount;
        data["actualMaterialAmount"] = this.actualMaterialAmount;
        data["lpoCostJde"] = this.lpoCostJde;
        data["plannedStartDate"] = this.plannedStartDate;
        data["estimatedEndDate"] = this.estimatedEndDate;
        data["workOrderStatusName"] = this.workOrderStatusName;
        data["woTypeSched"] = this.woTypeSched;
        data["woTypeSchedName"] = this.woTypeSchedName;
        data["locationName"] = this.locationName;
        data["systemGroupName"] = this.systemGroupName;
        data["woDocumentTypeName"] = this.woDocumentTypeName;
        data["leadCraftName"] = this.leadCraftName;
        data["woFirstStatusDate"] = this.woFirstStatusDate ? this.woFirstStatusDate.toISOString() : undefined as any;
        data["woLastStatusDate"] = this.woLastStatusDate ? this.woLastStatusDate.toISOString() : undefined as any;
        data["initiativeLink"] = this.initiativeLink ? this.initiativeLink.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeFdmWorkOrder {
    linkFk?: number;
    woNumberCode?: string | undefined;
    creationDate?: string | undefined;
    woType?: string | undefined;
    woPriority?: string | undefined;
    plannedCompletionDate?: string | undefined;
    actualCompletionDate?: string | undefined;
    workOrderStatusCode?: string | undefined;
    problemDescription?: string | undefined;
    woClassification?: string | undefined;
    equipmentId?: string | undefined;
    equipmentNumber?: string | undefined;
    categoryCode?: string | undefined;
    statusComment?: string | undefined;
    woDescription?: string | undefined;
    locationCode?: string | undefined;
    woDocumentType?: string | undefined;
    assignmentRoleCode?: string | undefined;
    systemGroupCode?: string | undefined;
    leadCraft?: string | undefined;
    branch?: string | undefined;
    actualLaborAmount?: string | undefined;
    actualOtherWorkAmount?: string | undefined;
    actualMaterialAmount?: string | undefined;
    lpoCostJde?: string | undefined;
    plannedStartDate?: string | undefined;
    estimatedEndDate?: string | undefined;
    workOrderStatusName?: string | undefined;
    woTypeSched?: string | undefined;
    woTypeSchedName?: string | undefined;
    locationName?: string | undefined;
    systemGroupName?: string | undefined;
    woDocumentTypeName?: string | undefined;
    leadCraftName?: string | undefined;
    woFirstStatusDate?: Date | undefined;
    woLastStatusDate?: Date | undefined;
    initiativeLink?: OnePInitiativeWorkOrderLink;
}

export class OnePInitiativeLinkListDTO implements IOnePInitiativeLinkListDTO {
    initiativeId?: number;
    badActors?: OnePInitiativeBALinkItemDTO[] | undefined;
    ewrs?: OnePInitiativeEWRLinkItemDTO[] | undefined;
    fdms?: OnePInitiativeFDMLinkItemDTO[] | undefined;
    equipments?: OnePInitiativeEquipmentLinkItemDTO[] | undefined;
    workOrders?: OnePInitiativeWorkOrderLinkItemDTO[] | undefined;

    constructor(data?: IOnePInitiativeLinkListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            if (Array.isArray(_data["badActors"])) {
                this.badActors = [] as any;
                for (let item of _data["badActors"])
                    this.badActors!.push(OnePInitiativeBALinkItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["ewrs"])) {
                this.ewrs = [] as any;
                for (let item of _data["ewrs"])
                    this.ewrs!.push(OnePInitiativeEWRLinkItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["fdms"])) {
                this.fdms = [] as any;
                for (let item of _data["fdms"])
                    this.fdms!.push(OnePInitiativeFDMLinkItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["equipments"])) {
                this.equipments = [] as any;
                for (let item of _data["equipments"])
                    this.equipments!.push(OnePInitiativeEquipmentLinkItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["workOrders"])) {
                this.workOrders = [] as any;
                for (let item of _data["workOrders"])
                    this.workOrders!.push(OnePInitiativeWorkOrderLinkItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OnePInitiativeLinkListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeLinkListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        if (Array.isArray(this.badActors)) {
            data["badActors"] = [];
            for (let item of this.badActors)
                data["badActors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ewrs)) {
            data["ewrs"] = [];
            for (let item of this.ewrs)
                data["ewrs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.fdms)) {
            data["fdms"] = [];
            for (let item of this.fdms)
                data["fdms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.equipments)) {
            data["equipments"] = [];
            for (let item of this.equipments)
                data["equipments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workOrders)) {
            data["workOrders"] = [];
            for (let item of this.workOrders)
                data["workOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOnePInitiativeLinkListDTO {
    initiativeId?: number;
    badActors?: OnePInitiativeBALinkItemDTO[] | undefined;
    ewrs?: OnePInitiativeEWRLinkItemDTO[] | undefined;
    fdms?: OnePInitiativeFDMLinkItemDTO[] | undefined;
    equipments?: OnePInitiativeEquipmentLinkItemDTO[] | undefined;
    workOrders?: OnePInitiativeWorkOrderLinkItemDTO[] | undefined;
}

export class OnePInitiativeNote implements IOnePInitiativeNote {
    pk?: number;
    initiativeFk?: number;
    comment?: string | undefined;
    attachmentFileFk?: string | undefined;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdAt?: Date;
    modifiedBy?: string | undefined;
    modifiedAt?: Date | undefined;
    rowVersion?: string | undefined;
    onePInitiative?: OnePInitiative;

    constructor(data?: IOnePInitiativeNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.comment = _data["comment"];
            this.attachmentFileFk = _data["attachmentFileFk"];
            this.isDeleted = _data["isDeleted"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.rowVersion = _data["rowVersion"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeNote {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["comment"] = this.comment;
        data["attachmentFileFk"] = this.attachmentFileFk;
        data["isDeleted"] = this.isDeleted;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["rowVersion"] = this.rowVersion;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeNote {
    pk?: number;
    initiativeFk?: number;
    comment?: string | undefined;
    attachmentFileFk?: string | undefined;
    isDeleted?: boolean;
    createdBy?: string | undefined;
    createdAt?: Date;
    modifiedBy?: string | undefined;
    modifiedAt?: Date | undefined;
    rowVersion?: string | undefined;
    onePInitiative?: OnePInitiative;
}

export class OnePInitiativeNoteDTO implements IOnePInitiativeNoteDTO {
    pk?: number;
    initiativeFk?: number;
    comment?: string | undefined;
    attachmentFileFk?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    modifiedBy?: string | undefined;
    modifiedAt?: Date | undefined;

    constructor(data?: IOnePInitiativeNoteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.comment = _data["comment"];
            this.attachmentFileFk = _data["attachmentFileFk"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeNoteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeNoteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["comment"] = this.comment;
        data["attachmentFileFk"] = this.attachmentFileFk;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeNoteDTO {
    pk?: number;
    initiativeFk?: number;
    comment?: string | undefined;
    attachmentFileFk?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    modifiedBy?: string | undefined;
    modifiedAt?: Date | undefined;
}

export class OnePInitiativeScopesByEmailDTO implements IOnePInitiativeScopesByEmailDTO {
    scopes?: string[] | undefined;

    constructor(data?: IOnePInitiativeScopesByEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
        }
    }

    static fromJS(data: any): OnePInitiativeScopesByEmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeScopesByEmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        return data;
    }
}

export interface IOnePInitiativeScopesByEmailDTO {
    scopes?: string[] | undefined;
}

export class OnePInitiativeStageUpdateDTO implements IOnePInitiativeStageUpdateDTO {
    initiativePk?: number;
    stage?: InitiativeStage;
    stageHistoryComment?: string | undefined;
    attachmentFileFk?: string | undefined;

    constructor(data?: IOnePInitiativeStageUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativePk = _data["initiativePk"];
            this.stage = _data["stage"];
            this.stageHistoryComment = _data["stageHistoryComment"];
            this.attachmentFileFk = _data["attachmentFileFk"];
        }
    }

    static fromJS(data: any): OnePInitiativeStageUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeStageUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativePk"] = this.initiativePk;
        data["stage"] = this.stage;
        data["stageHistoryComment"] = this.stageHistoryComment;
        data["attachmentFileFk"] = this.attachmentFileFk;
        return data;
    }
}

export interface IOnePInitiativeStageUpdateDTO {
    initiativePk?: number;
    stage?: InitiativeStage;
    stageHistoryComment?: string | undefined;
    attachmentFileFk?: string | undefined;
}

export class OnePInitiativeWithBreakInOutDTO implements IOnePInitiativeWithBreakInOutDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    stageStatus?: string | undefined;
    revisedOutlook?: number | undefined;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    breakInOutJustification?: string | undefined;
    afeAmount?: number | undefined;
    afeStartDate?: string | undefined;
    afeEndDate?: string | undefined;
    projectOwnerEmail?: string | undefined;
    approvedBudget?: number | undefined;
    initiativeCostTotals?: OnePProjectCostTotalsDTO;
    forecastCostTotals?: OnePProjectCostTotalsDTO;
    hasActualsAmount?: boolean;
    initiativeActualCostTotalsFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
    initiativeActualCostTotalsEditedFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;

    constructor(data?: IOnePInitiativeWithBreakInOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.afeComment = _data["afeComment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.costController = _data["costController"];
            this.financeStatus = _data["financeStatus"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.stageStatus = _data["stageStatus"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.isCarriedOver = _data["isCarriedOver"];
            this.carriedOverFromInitiativeId = _data["carriedOverFromInitiativeId"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
            this.breakInOutJustification = _data["breakInOutJustification"];
            this.afeAmount = _data["afeAmount"];
            this.afeStartDate = _data["afeStartDate"];
            this.afeEndDate = _data["afeEndDate"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.approvedBudget = _data["approvedBudget"];
            this.initiativeCostTotals = _data["initiativeCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["initiativeCostTotals"]) : undefined as any;
            this.forecastCostTotals = _data["forecastCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["forecastCostTotals"]) : undefined as any;
            this.hasActualsAmount = _data["hasActualsAmount"];
            this.initiativeActualCostTotalsFlags = _data["initiativeActualCostTotalsFlags"] ? OnePPInitiativeActualCostTotalsFlagsDTO.fromJS(_data["initiativeActualCostTotalsFlags"]) : undefined as any;
            this.initiativeActualCostTotalsEditedFlags = _data["initiativeActualCostTotalsEditedFlags"] ? OnePPInitiativeActualCostTotalsFlagsDTO.fromJS(_data["initiativeActualCostTotalsEditedFlags"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeWithBreakInOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeWithBreakInOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["afeComment"] = this.afeComment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["costController"] = this.costController;
        data["financeStatus"] = this.financeStatus;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["stageStatus"] = this.stageStatus;
        data["revisedOutlook"] = this.revisedOutlook;
        data["isCarriedOver"] = this.isCarriedOver;
        data["carriedOverFromInitiativeId"] = this.carriedOverFromInitiativeId;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        data["breakInOutJustification"] = this.breakInOutJustification;
        data["afeAmount"] = this.afeAmount;
        data["afeStartDate"] = this.afeStartDate;
        data["afeEndDate"] = this.afeEndDate;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["approvedBudget"] = this.approvedBudget;
        data["initiativeCostTotals"] = this.initiativeCostTotals ? this.initiativeCostTotals.toJSON() : undefined as any;
        data["forecastCostTotals"] = this.forecastCostTotals ? this.forecastCostTotals.toJSON() : undefined as any;
        data["hasActualsAmount"] = this.hasActualsAmount;
        data["initiativeActualCostTotalsFlags"] = this.initiativeActualCostTotalsFlags ? this.initiativeActualCostTotalsFlags.toJSON() : undefined as any;
        data["initiativeActualCostTotalsEditedFlags"] = this.initiativeActualCostTotalsEditedFlags ? this.initiativeActualCostTotalsEditedFlags.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeWithBreakInOutDTO {
    pk?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    afeComment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    costController?: string | undefined;
    financeStatus?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    stageStatus?: string | undefined;
    revisedOutlook?: number | undefined;
    isCarriedOver?: boolean;
    carriedOverFromInitiativeId?: number | undefined;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    breakInOutJustification?: string | undefined;
    afeAmount?: number | undefined;
    afeStartDate?: string | undefined;
    afeEndDate?: string | undefined;
    projectOwnerEmail?: string | undefined;
    approvedBudget?: number | undefined;
    initiativeCostTotals?: OnePProjectCostTotalsDTO;
    forecastCostTotals?: OnePProjectCostTotalsDTO;
    hasActualsAmount?: boolean;
    initiativeActualCostTotalsFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
    initiativeActualCostTotalsEditedFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
}

export class OnePInitiativeWithBreakInOutDTOGridPagedResult implements IOnePInitiativeWithBreakInOutDTOGridPagedResult {
    items!: OnePInitiativeWithBreakInOutDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePInitiativeWithBreakInOutDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePInitiativeWithBreakInOutDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePInitiativeWithBreakInOutDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeWithBreakInOutDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePInitiativeWithBreakInOutDTOGridPagedResult {
    items: OnePInitiativeWithBreakInOutDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePInitiativeWorkOrderLink implements IOnePInitiativeWorkOrderLink {
    pk?: number;
    initiativeId?: number;
    workOrderId?: string | undefined;
    linkedAt?: Date;
    linkedBy?: string | undefined;
    onePInitiative?: OnePInitiative;
    onePInitiativeFdmWorkOrder?: OnePInitiativeFdmWorkOrder;

    constructor(data?: IOnePInitiativeWorkOrderLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeId = _data["initiativeId"];
            this.workOrderId = _data["workOrderId"];
            this.linkedAt = _data["linkedAt"] ? new Date(_data["linkedAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
            this.onePInitiativeFdmWorkOrder = _data["onePInitiativeFdmWorkOrder"] ? OnePInitiativeFdmWorkOrder.fromJS(_data["onePInitiativeFdmWorkOrder"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeWorkOrderLink {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeWorkOrderLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeId"] = this.initiativeId;
        data["workOrderId"] = this.workOrderId;
        data["linkedAt"] = this.linkedAt ? this.linkedAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        data["onePInitiativeFdmWorkOrder"] = this.onePInitiativeFdmWorkOrder ? this.onePInitiativeFdmWorkOrder.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeWorkOrderLink {
    pk?: number;
    initiativeId?: number;
    workOrderId?: string | undefined;
    linkedAt?: Date;
    linkedBy?: string | undefined;
    onePInitiative?: OnePInitiative;
    onePInitiativeFdmWorkOrder?: OnePInitiativeFdmWorkOrder;
}

export class OnePInitiativeWorkOrderLinkItemDTO implements IOnePInitiativeWorkOrderLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    workOrder?: OnePInitiativeFdmWorkOrder;

    constructor(data?: IOnePInitiativeWorkOrderLinkItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linketAt = _data["linketAt"] ? new Date(_data["linketAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
            this.workOrder = _data["workOrder"] ? OnePInitiativeFdmWorkOrder.fromJS(_data["workOrder"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativeWorkOrderLinkItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativeWorkOrderLinkItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linketAt"] = this.linketAt ? this.linketAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        data["workOrder"] = this.workOrder ? this.workOrder.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativeWorkOrderLinkItemDTO {
    linketAt?: Date;
    linkedBy?: string | undefined;
    workOrder?: OnePInitiativeFdmWorkOrder;
}

export class OnePInitiativesAttachmentFileDTO implements IOnePInitiativesAttachmentFileDTO {
    id?: string;
    initiativeId?: number;
    breakInOutId?: number | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
    uploadedAt?: Date;
    uploadedByEmail?: string | undefined;

    constructor(data?: IOnePInitiativesAttachmentFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.initiativeId = _data["initiativeId"];
            this.breakInOutId = _data["breakInOutId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeBytes = _data["sizeBytes"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : undefined as any;
            this.uploadedByEmail = _data["uploadedByEmail"];
        }
    }

    static fromJS(data: any): OnePInitiativesAttachmentFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativesAttachmentFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["initiativeId"] = this.initiativeId;
        data["breakInOutId"] = this.breakInOutId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeBytes"] = this.sizeBytes;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : undefined as any;
        data["uploadedByEmail"] = this.uploadedByEmail;
        return data;
    }
}

export interface IOnePInitiativesAttachmentFileDTO {
    id?: string;
    initiativeId?: number;
    breakInOutId?: number | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
    uploadedAt?: Date;
    uploadedByEmail?: string | undefined;
}

export class OnePInitiativesCostTotalsDTO implements IOnePInitiativesCostTotalsDTO {
    initiativeId?: number;
    totals?: OnePProjectCostTotalsDTO;

    constructor(data?: IOnePInitiativesCostTotalsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.totals = _data["totals"] ? OnePProjectCostTotalsDTO.fromJS(_data["totals"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativesCostTotalsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativesCostTotalsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativesCostTotalsDTO {
    initiativeId?: number;
    totals?: OnePProjectCostTotalsDTO;
}

export class OnePInitiativesCostTotalsWithFlagsDTO implements IOnePInitiativesCostTotalsWithFlagsDTO {
    initiativeId?: number;
    totals?: OnePProjectCostTotalsDTO;
    flags?: OnePPInitiativeActualCostTotalsFlagsDTO;
    editedFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;

    constructor(data?: IOnePInitiativesCostTotalsWithFlagsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.totals = _data["totals"] ? OnePProjectCostTotalsDTO.fromJS(_data["totals"]) : undefined as any;
            this.flags = _data["flags"] ? OnePPInitiativeActualCostTotalsFlagsDTO.fromJS(_data["flags"]) : undefined as any;
            this.editedFlags = _data["editedFlags"] ? OnePPInitiativeActualCostTotalsFlagsDTO.fromJS(_data["editedFlags"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePInitiativesCostTotalsWithFlagsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativesCostTotalsWithFlagsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        data["flags"] = this.flags ? this.flags.toJSON() : undefined as any;
        data["editedFlags"] = this.editedFlags ? this.editedFlags.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePInitiativesCostTotalsWithFlagsDTO {
    initiativeId?: number;
    totals?: OnePProjectCostTotalsDTO;
    flags?: OnePPInitiativeActualCostTotalsFlagsDTO;
    editedFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
}

export class OnePInitiativesLinksGridDTO implements IOnePInitiativesLinksGridDTO {
    initiativeId?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    ript?: number | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    reportType?: string | undefined;
    reportFk?: string | undefined;
    itemId?: string | undefined;
    reportId?: string | undefined;
    linketAt?: Date;
    linkedBy?: string | undefined;

    constructor(data?: IOnePInitiativesLinksGridDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.mciProgram = _data["mciProgram"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.ript = _data["ript"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.reportType = _data["reportType"];
            this.reportFk = _data["reportFk"];
            this.itemId = _data["itemId"];
            this.reportId = _data["reportId"];
            this.linketAt = _data["linketAt"] ? new Date(_data["linketAt"].toString()) : undefined as any;
            this.linkedBy = _data["linkedBy"];
        }
    }

    static fromJS(data: any): OnePInitiativesLinksGridDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativesLinksGridDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["mciProgram"] = this.mciProgram;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["revisedOutlook"] = this.revisedOutlook;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["ript"] = this.ript;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["reportType"] = this.reportType;
        data["reportFk"] = this.reportFk;
        data["itemId"] = this.itemId;
        data["reportId"] = this.reportId;
        data["linketAt"] = this.linketAt ? this.linketAt.toISOString() : undefined as any;
        data["linkedBy"] = this.linkedBy;
        return data;
    }
}

export interface IOnePInitiativesLinksGridDTO {
    initiativeId?: number;
    stage?: InitiativeStage;
    initiativeType?: InitiativeType;
    taType?: TaType;
    budgetType?: BudgetType;
    ccAfe?: CcAfe;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    mciProgram?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    ript?: number | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    reportType?: string | undefined;
    reportFk?: string | undefined;
    itemId?: string | undefined;
    reportId?: string | undefined;
    linketAt?: Date;
    linkedBy?: string | undefined;
}

export class OnePInitiativesLinksGridDTOGridPagedResult implements IOnePInitiativesLinksGridDTOGridPagedResult {
    items!: OnePInitiativesLinksGridDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePInitiativesLinksGridDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePInitiativesLinksGridDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePInitiativesLinksGridDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativesLinksGridDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePInitiativesLinksGridDTOGridPagedResult {
    items: OnePInitiativesLinksGridDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePInitiativesWithApprovedBudgetDTO implements IOnePInitiativesWithApprovedBudgetDTO {
    initiativeId?: number;
    approvedBudget?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;

    constructor(data?: IOnePInitiativesWithApprovedBudgetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.approvedBudget = _data["approvedBudget"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
        }
    }

    static fromJS(data: any): OnePInitiativesWithApprovedBudgetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePInitiativesWithApprovedBudgetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["approvedBudget"] = this.approvedBudget;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        return data;
    }
}

export interface IOnePInitiativesWithApprovedBudgetDTO {
    initiativeId?: number;
    approvedBudget?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
}

export class OnePMasterInitiativeLink implements IOnePMasterInitiativeLink {
    pk?: number;
    primaryInitiativePk?: number;
    primaryInitiative?: OnePInitiative;
    secondaryInitiativePk?: number;
    secondaryInitiative?: OnePInitiative;
    canonicalInitiativePk1?: number;
    canonicalInitiativePk2?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;

    constructor(data?: IOnePMasterInitiativeLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.primaryInitiativePk = _data["primaryInitiativePk"];
            this.primaryInitiative = _data["primaryInitiative"] ? OnePInitiative.fromJS(_data["primaryInitiative"]) : undefined as any;
            this.secondaryInitiativePk = _data["secondaryInitiativePk"];
            this.secondaryInitiative = _data["secondaryInitiative"] ? OnePInitiative.fromJS(_data["secondaryInitiative"]) : undefined as any;
            this.canonicalInitiativePk1 = _data["canonicalInitiativePk1"];
            this.canonicalInitiativePk2 = _data["canonicalInitiativePk2"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): OnePMasterInitiativeLink {
        data = typeof data === 'object' ? data : {};
        let result = new OnePMasterInitiativeLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["primaryInitiativePk"] = this.primaryInitiativePk;
        data["primaryInitiative"] = this.primaryInitiative ? this.primaryInitiative.toJSON() : undefined as any;
        data["secondaryInitiativePk"] = this.secondaryInitiativePk;
        data["secondaryInitiative"] = this.secondaryInitiative ? this.secondaryInitiative.toJSON() : undefined as any;
        data["canonicalInitiativePk1"] = this.canonicalInitiativePk1;
        data["canonicalInitiativePk2"] = this.canonicalInitiativePk2;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IOnePMasterInitiativeLink {
    pk?: number;
    primaryInitiativePk?: number;
    primaryInitiative?: OnePInitiative;
    secondaryInitiativePk?: number;
    secondaryInitiative?: OnePInitiative;
    canonicalInitiativePk1?: number;
    canonicalInitiativePk2?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
}

export class OnePMasterInitiativeLinksDTO implements IOnePMasterInitiativeLinksDTO {
    pk?: number;
    primaryInitiativePk?: number;
    secondaryInitiativePk?: number;

    constructor(data?: IOnePMasterInitiativeLinksDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.primaryInitiativePk = _data["primaryInitiativePk"];
            this.secondaryInitiativePk = _data["secondaryInitiativePk"];
        }
    }

    static fromJS(data: any): OnePMasterInitiativeLinksDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePMasterInitiativeLinksDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["primaryInitiativePk"] = this.primaryInitiativePk;
        data["secondaryInitiativePk"] = this.secondaryInitiativePk;
        return data;
    }
}

export interface IOnePMasterInitiativeLinksDTO {
    pk?: number;
    primaryInitiativePk?: number;
    secondaryInitiativePk?: number;
}

export class OnePMasterLinkedProjectsDTO implements IOnePMasterLinkedProjectsDTO {
    pk?: number;
    stage?: string | undefined;
    initiativeType?: string | undefined;
    taType?: string | undefined;
    budgetType?: string | undefined;
    ccAfe?: string | undefined;
    mciProgram?: string | undefined;
    financeStatus?: string | undefined;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    stageStatus?: string | undefined;
    createdBy?: string | undefined;
    powerAppsPortfolioId?: string | undefined;
    createdOn?: Date;
    costController?: string | undefined;
    afeComment?: string | undefined;
    carriedOverFromInitiativeId?: number | undefined;
    isCarriedOver?: boolean;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    approvedBudget?: number | undefined;
    afeAmount?: number | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    linkRole?: string | undefined;
    mainParentPk?: number | undefined;
    primaryInitiativePk?: number | undefined;
    secondaryInitiativePk?: number | undefined;
    linkTablePk?: number | undefined;
    forecastCostTotals?: OnePProjectCostTotalsDTO;
    initiativeCostTotals?: OnePProjectCostTotalsDTO;
    initiativeCostTotalsActualsFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;

    constructor(data?: IOnePMasterLinkedProjectsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.stage = _data["stage"];
            this.initiativeType = _data["initiativeType"];
            this.taType = _data["taType"];
            this.budgetType = _data["budgetType"];
            this.ccAfe = _data["ccAfe"];
            this.mciProgram = _data["mciProgram"];
            this.financeStatus = _data["financeStatus"];
            this.id = _data["id"];
            this.description = _data["description"];
            this.areaType = _data["areaType"];
            this.year = _data["year"];
            this.multiYear = _data["multiYear"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.afeNumber = _data["afeNumber"];
            this.originalBudget = _data["originalBudget"];
            this.revisedBudget = _data["revisedBudget"];
            this.revisedOutlook = _data["revisedOutlook"];
            this.fyOutlook = _data["fyOutlook"];
            this.actualsYTD = _data["actualsYTD"];
            this.fy1 = _data["fy1"];
            this.fy2 = _data["fy2"];
            this.fy3 = _data["fy3"];
            this.projectTotalCost = _data["projectTotalCost"];
            this.opportunityDescription = _data["opportunityDescription"];
            this.potentialSolution = _data["potentialSolution"];
            this.riskOrAlternative = _data["riskOrAlternative"];
            this.riptUrl = _data["riptUrl"];
            this.abc = _data["abc"];
            this.ript = _data["ript"];
            this.drivingCriteria = _data["drivingCriteria"];
            this.riskManRiskScore = _data["riskManRiskScore"];
            this.riskManCategory = _data["riskManCategory"];
            this.ror = _data["ror"];
            this.dpi = _data["dpi"];
            this.initialInvestment = _data["initialInvestment"];
            this.hseRiskEfficiency = _data["hseRiskEfficiency"];
            this.likelyScenario = _data["likelyScenario"];
            this.likelyConsequence = _data["likelyConsequence"];
            this.isCanceled = _data["isCanceled"];
            this.comment = _data["comment"];
            this.initiativeOwnerSharedEmail = _data["initiativeOwnerSharedEmail"];
            this.stageStatus = _data["stageStatus"];
            this.createdBy = _data["createdBy"];
            this.powerAppsPortfolioId = _data["powerAppsPortfolioId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.costController = _data["costController"];
            this.afeComment = _data["afeComment"];
            this.carriedOverFromInitiativeId = _data["carriedOverFromInitiativeId"];
            this.isCarriedOver = _data["isCarriedOver"];
            this.isServiceRequest = _data["isServiceRequest"];
            this.projectProgress = _data["projectProgress"];
            this.areaPriority = _data["areaPriority"];
            this.tcoPriority = _data["tcoPriority"];
            this.approvedBudget = _data["approvedBudget"];
            this.afeAmount = _data["afeAmount"];
            this.isForecastUpdated = _data["isForecastUpdated"];
            this.isForReview = _data["isForReview"];
            this.initiatorEmail = _data["initiatorEmail"];
            this.linkRole = _data["linkRole"];
            this.mainParentPk = _data["mainParentPk"];
            this.primaryInitiativePk = _data["primaryInitiativePk"];
            this.secondaryInitiativePk = _data["secondaryInitiativePk"];
            this.linkTablePk = _data["linkTablePk"];
            this.forecastCostTotals = _data["forecastCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["forecastCostTotals"]) : undefined as any;
            this.initiativeCostTotals = _data["initiativeCostTotals"] ? OnePProjectCostTotalsDTO.fromJS(_data["initiativeCostTotals"]) : undefined as any;
            this.initiativeCostTotalsActualsFlags = _data["initiativeCostTotalsActualsFlags"] ? OnePPInitiativeActualCostTotalsFlagsDTO.fromJS(_data["initiativeCostTotalsActualsFlags"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePMasterLinkedProjectsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePMasterLinkedProjectsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["stage"] = this.stage;
        data["initiativeType"] = this.initiativeType;
        data["taType"] = this.taType;
        data["budgetType"] = this.budgetType;
        data["ccAfe"] = this.ccAfe;
        data["mciProgram"] = this.mciProgram;
        data["financeStatus"] = this.financeStatus;
        data["id"] = this.id;
        data["description"] = this.description;
        data["areaType"] = this.areaType;
        data["year"] = this.year;
        data["multiYear"] = this.multiYear;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["afeNumber"] = this.afeNumber;
        data["originalBudget"] = this.originalBudget;
        data["revisedBudget"] = this.revisedBudget;
        data["revisedOutlook"] = this.revisedOutlook;
        data["fyOutlook"] = this.fyOutlook;
        data["actualsYTD"] = this.actualsYTD;
        data["fy1"] = this.fy1;
        data["fy2"] = this.fy2;
        data["fy3"] = this.fy3;
        data["projectTotalCost"] = this.projectTotalCost;
        data["opportunityDescription"] = this.opportunityDescription;
        data["potentialSolution"] = this.potentialSolution;
        data["riskOrAlternative"] = this.riskOrAlternative;
        data["riptUrl"] = this.riptUrl;
        data["abc"] = this.abc;
        data["ript"] = this.ript;
        data["drivingCriteria"] = this.drivingCriteria;
        data["riskManRiskScore"] = this.riskManRiskScore;
        data["riskManCategory"] = this.riskManCategory;
        data["ror"] = this.ror;
        data["dpi"] = this.dpi;
        data["initialInvestment"] = this.initialInvestment;
        data["hseRiskEfficiency"] = this.hseRiskEfficiency;
        data["likelyScenario"] = this.likelyScenario;
        data["likelyConsequence"] = this.likelyConsequence;
        data["isCanceled"] = this.isCanceled;
        data["comment"] = this.comment;
        data["initiativeOwnerSharedEmail"] = this.initiativeOwnerSharedEmail;
        data["stageStatus"] = this.stageStatus;
        data["createdBy"] = this.createdBy;
        data["powerAppsPortfolioId"] = this.powerAppsPortfolioId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["costController"] = this.costController;
        data["afeComment"] = this.afeComment;
        data["carriedOverFromInitiativeId"] = this.carriedOverFromInitiativeId;
        data["isCarriedOver"] = this.isCarriedOver;
        data["isServiceRequest"] = this.isServiceRequest;
        data["projectProgress"] = this.projectProgress;
        data["areaPriority"] = this.areaPriority;
        data["tcoPriority"] = this.tcoPriority;
        data["approvedBudget"] = this.approvedBudget;
        data["afeAmount"] = this.afeAmount;
        data["isForecastUpdated"] = this.isForecastUpdated;
        data["isForReview"] = this.isForReview;
        data["initiatorEmail"] = this.initiatorEmail;
        data["linkRole"] = this.linkRole;
        data["mainParentPk"] = this.mainParentPk;
        data["primaryInitiativePk"] = this.primaryInitiativePk;
        data["secondaryInitiativePk"] = this.secondaryInitiativePk;
        data["linkTablePk"] = this.linkTablePk;
        data["forecastCostTotals"] = this.forecastCostTotals ? this.forecastCostTotals.toJSON() : undefined as any;
        data["initiativeCostTotals"] = this.initiativeCostTotals ? this.initiativeCostTotals.toJSON() : undefined as any;
        data["initiativeCostTotalsActualsFlags"] = this.initiativeCostTotalsActualsFlags ? this.initiativeCostTotalsActualsFlags.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePMasterLinkedProjectsDTO {
    pk?: number;
    stage?: string | undefined;
    initiativeType?: string | undefined;
    taType?: string | undefined;
    budgetType?: string | undefined;
    ccAfe?: string | undefined;
    mciProgram?: string | undefined;
    financeStatus?: string | undefined;
    id?: string | undefined;
    description?: string | undefined;
    areaType?: string | undefined;
    year?: number | undefined;
    multiYear?: boolean | undefined;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    needByDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    afeNumber?: string | undefined;
    originalBudget?: number | undefined;
    revisedBudget?: number | undefined;
    revisedOutlook?: number | undefined;
    fyOutlook?: number | undefined;
    actualsYTD?: number | undefined;
    fy1?: number | undefined;
    fy2?: number | undefined;
    fy3?: number | undefined;
    projectTotalCost?: number | undefined;
    opportunityDescription?: string | undefined;
    potentialSolution?: string | undefined;
    riskOrAlternative?: string | undefined;
    riptUrl?: string | undefined;
    abc?: string | undefined;
    ript?: number | undefined;
    drivingCriteria?: string | undefined;
    riskManRiskScore?: number | undefined;
    riskManCategory?: string | undefined;
    ror?: number | undefined;
    dpi?: number | undefined;
    initialInvestment?: number | undefined;
    hseRiskEfficiency?: number | undefined;
    likelyScenario?: string | undefined;
    likelyConsequence?: string | undefined;
    isCanceled?: boolean | undefined;
    comment?: string | undefined;
    initiativeOwnerSharedEmail?: string | undefined;
    stageStatus?: string | undefined;
    createdBy?: string | undefined;
    powerAppsPortfolioId?: string | undefined;
    createdOn?: Date;
    costController?: string | undefined;
    afeComment?: string | undefined;
    carriedOverFromInitiativeId?: number | undefined;
    isCarriedOver?: boolean;
    isServiceRequest?: boolean;
    projectProgress?: number;
    areaPriority?: string | undefined;
    tcoPriority?: string | undefined;
    approvedBudget?: number | undefined;
    afeAmount?: number | undefined;
    isForecastUpdated?: boolean;
    isForReview?: boolean;
    initiatorEmail?: string | undefined;
    linkRole?: string | undefined;
    mainParentPk?: number | undefined;
    primaryInitiativePk?: number | undefined;
    secondaryInitiativePk?: number | undefined;
    linkTablePk?: number | undefined;
    forecastCostTotals?: OnePProjectCostTotalsDTO;
    initiativeCostTotals?: OnePProjectCostTotalsDTO;
    initiativeCostTotalsActualsFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
}

export class OnePMasterLinkedProjectsDTOGridPagedResult implements IOnePMasterLinkedProjectsDTOGridPagedResult {
    items!: OnePMasterLinkedProjectsDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IOnePMasterLinkedProjectsDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OnePMasterLinkedProjectsDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): OnePMasterLinkedProjectsDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnePMasterLinkedProjectsDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IOnePMasterLinkedProjectsDTOGridPagedResult {
    items: OnePMasterLinkedProjectsDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class OnePMciProgramCreateUpdateDTO implements IOnePMciProgramCreateUpdateDTO {
    pk?: number;
    programNameEn?: string | undefined;
    programNameKz?: string | undefined;
    programNameRu?: string | undefined;

    constructor(data?: IOnePMciProgramCreateUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.programNameEn = _data["programNameEn"];
            this.programNameKz = _data["programNameKz"];
            this.programNameRu = _data["programNameRu"];
        }
    }

    static fromJS(data: any): OnePMciProgramCreateUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePMciProgramCreateUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["programNameEn"] = this.programNameEn;
        data["programNameKz"] = this.programNameKz;
        data["programNameRu"] = this.programNameRu;
        return data;
    }
}

export interface IOnePMciProgramCreateUpdateDTO {
    pk?: number;
    programNameEn?: string | undefined;
    programNameKz?: string | undefined;
    programNameRu?: string | undefined;
}

export class OnePMciProgramReadDTO implements IOnePMciProgramReadDTO {
    pk?: number;
    programNameEn?: string | undefined;
    programNameKz?: string | undefined;
    programNameRu?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IOnePMciProgramReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.programNameEn = _data["programNameEn"];
            this.programNameKz = _data["programNameKz"];
            this.programNameRu = _data["programNameRu"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OnePMciProgramReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePMciProgramReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["programNameEn"] = this.programNameEn;
        data["programNameKz"] = this.programNameKz;
        data["programNameRu"] = this.programNameRu;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IOnePMciProgramReadDTO {
    pk?: number;
    programNameEn?: string | undefined;
    programNameKz?: string | undefined;
    programNameRu?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;
}

export class OnePNotificationScheduleSettingDTO implements IOnePNotificationScheduleSettingDTO {
    pk?: number;
    scheduledAtUtc?: Date;
    isEnabled?: boolean;
    order?: number;

    constructor(data?: IOnePNotificationScheduleSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.scheduledAtUtc = _data["scheduledAtUtc"] ? new Date(_data["scheduledAtUtc"].toString()) : undefined as any;
            this.isEnabled = _data["isEnabled"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): OnePNotificationScheduleSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePNotificationScheduleSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["scheduledAtUtc"] = this.scheduledAtUtc ? this.scheduledAtUtc.toISOString() : undefined as any;
        data["isEnabled"] = this.isEnabled;
        data["order"] = this.order;
        return data;
    }
}

export interface IOnePNotificationScheduleSettingDTO {
    pk?: number;
    scheduledAtUtc?: Date;
    isEnabled?: boolean;
    order?: number;
}

export class OnePNotificationSettingDTO implements IOnePNotificationSettingDTO {
    pk?: number;
    notificationCode?: string | undefined;
    name?: string | undefined;
    isEnabled?: boolean;
    initialDelayMinutes?: number | undefined;
    repeatIntervalMinutes?: number | undefined;

    constructor(data?: IOnePNotificationSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.notificationCode = _data["notificationCode"];
            this.name = _data["name"];
            this.isEnabled = _data["isEnabled"];
            this.initialDelayMinutes = _data["initialDelayMinutes"];
            this.repeatIntervalMinutes = _data["repeatIntervalMinutes"];
        }
    }

    static fromJS(data: any): OnePNotificationSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePNotificationSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["notificationCode"] = this.notificationCode;
        data["name"] = this.name;
        data["isEnabled"] = this.isEnabled;
        data["initialDelayMinutes"] = this.initialDelayMinutes;
        data["repeatIntervalMinutes"] = this.repeatIntervalMinutes;
        return data;
    }
}

export interface IOnePNotificationSettingDTO {
    pk?: number;
    notificationCode?: string | undefined;
    name?: string | undefined;
    isEnabled?: boolean;
    initialDelayMinutes?: number | undefined;
    repeatIntervalMinutes?: number | undefined;
}

export class OnePPInitiativeActualCostTotalsFlagsDTO implements IOnePPInitiativeActualCostTotalsFlagsDTO {
    janMaterial?: boolean;
    febMaterial?: boolean;
    marMaterial?: boolean;
    aprMaterial?: boolean;
    mayMaterial?: boolean;
    junMaterial?: boolean;
    julMaterial?: boolean;
    augMaterial?: boolean;
    sepMaterial?: boolean;
    octMaterial?: boolean;
    novMaterial?: boolean;
    decMaterial?: boolean;
    janService?: boolean;
    febService?: boolean;
    marService?: boolean;
    aprService?: boolean;
    mayService?: boolean;
    junService?: boolean;
    julService?: boolean;
    augService?: boolean;
    sepService?: boolean;
    octService?: boolean;
    novService?: boolean;
    decService?: boolean;
    janOther?: boolean;
    febOther?: boolean;
    marOther?: boolean;
    aprOther?: boolean;
    mayOther?: boolean;
    junOther?: boolean;
    julOther?: boolean;
    augOther?: boolean;
    sepOther?: boolean;
    octOther?: boolean;
    novOther?: boolean;
    decOther?: boolean;

    constructor(data?: IOnePPInitiativeActualCostTotalsFlagsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.janMaterial = _data["janMaterial"];
            this.febMaterial = _data["febMaterial"];
            this.marMaterial = _data["marMaterial"];
            this.aprMaterial = _data["aprMaterial"];
            this.mayMaterial = _data["mayMaterial"];
            this.junMaterial = _data["junMaterial"];
            this.julMaterial = _data["julMaterial"];
            this.augMaterial = _data["augMaterial"];
            this.sepMaterial = _data["sepMaterial"];
            this.octMaterial = _data["octMaterial"];
            this.novMaterial = _data["novMaterial"];
            this.decMaterial = _data["decMaterial"];
            this.janService = _data["janService"];
            this.febService = _data["febService"];
            this.marService = _data["marService"];
            this.aprService = _data["aprService"];
            this.mayService = _data["mayService"];
            this.junService = _data["junService"];
            this.julService = _data["julService"];
            this.augService = _data["augService"];
            this.sepService = _data["sepService"];
            this.octService = _data["octService"];
            this.novService = _data["novService"];
            this.decService = _data["decService"];
            this.janOther = _data["janOther"];
            this.febOther = _data["febOther"];
            this.marOther = _data["marOther"];
            this.aprOther = _data["aprOther"];
            this.mayOther = _data["mayOther"];
            this.junOther = _data["junOther"];
            this.julOther = _data["julOther"];
            this.augOther = _data["augOther"];
            this.sepOther = _data["sepOther"];
            this.octOther = _data["octOther"];
            this.novOther = _data["novOther"];
            this.decOther = _data["decOther"];
        }
    }

    static fromJS(data: any): OnePPInitiativeActualCostTotalsFlagsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePPInitiativeActualCostTotalsFlagsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["janMaterial"] = this.janMaterial;
        data["febMaterial"] = this.febMaterial;
        data["marMaterial"] = this.marMaterial;
        data["aprMaterial"] = this.aprMaterial;
        data["mayMaterial"] = this.mayMaterial;
        data["junMaterial"] = this.junMaterial;
        data["julMaterial"] = this.julMaterial;
        data["augMaterial"] = this.augMaterial;
        data["sepMaterial"] = this.sepMaterial;
        data["octMaterial"] = this.octMaterial;
        data["novMaterial"] = this.novMaterial;
        data["decMaterial"] = this.decMaterial;
        data["janService"] = this.janService;
        data["febService"] = this.febService;
        data["marService"] = this.marService;
        data["aprService"] = this.aprService;
        data["mayService"] = this.mayService;
        data["junService"] = this.junService;
        data["julService"] = this.julService;
        data["augService"] = this.augService;
        data["sepService"] = this.sepService;
        data["octService"] = this.octService;
        data["novService"] = this.novService;
        data["decService"] = this.decService;
        data["janOther"] = this.janOther;
        data["febOther"] = this.febOther;
        data["marOther"] = this.marOther;
        data["aprOther"] = this.aprOther;
        data["mayOther"] = this.mayOther;
        data["junOther"] = this.junOther;
        data["julOther"] = this.julOther;
        data["augOther"] = this.augOther;
        data["sepOther"] = this.sepOther;
        data["octOther"] = this.octOther;
        data["novOther"] = this.novOther;
        data["decOther"] = this.decOther;
        return data;
    }
}

export interface IOnePPInitiativeActualCostTotalsFlagsDTO {
    janMaterial?: boolean;
    febMaterial?: boolean;
    marMaterial?: boolean;
    aprMaterial?: boolean;
    mayMaterial?: boolean;
    junMaterial?: boolean;
    julMaterial?: boolean;
    augMaterial?: boolean;
    sepMaterial?: boolean;
    octMaterial?: boolean;
    novMaterial?: boolean;
    decMaterial?: boolean;
    janService?: boolean;
    febService?: boolean;
    marService?: boolean;
    aprService?: boolean;
    mayService?: boolean;
    junService?: boolean;
    julService?: boolean;
    augService?: boolean;
    sepService?: boolean;
    octService?: boolean;
    novService?: boolean;
    decService?: boolean;
    janOther?: boolean;
    febOther?: boolean;
    marOther?: boolean;
    aprOther?: boolean;
    mayOther?: boolean;
    junOther?: boolean;
    julOther?: boolean;
    augOther?: boolean;
    sepOther?: boolean;
    octOther?: boolean;
    novOther?: boolean;
    decOther?: boolean;
}

export class OnePProjectAuditHistoryItemDTO implements IOnePProjectAuditHistoryItemDTO {
    changedOn!: Date;
    eventName!: string | undefined;
    area!: string | undefined;
    changedBy?: string | undefined;
    userAgent?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    changedColumns?: string | undefined;
    changeType?: string | undefined;
    comment?: string | undefined;
    sourceTable?: string | undefined;
    sourcePrimaryKey?: string | undefined;
    oldValueDisplay?: string | undefined;
    newValueDisplay?: string | undefined;
    changedColumnsDisplay?: string | undefined;

    constructor(data?: IOnePProjectAuditHistoryItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changedOn = _data["changedOn"] ? new Date(_data["changedOn"].toString()) : undefined as any;
            this.eventName = _data["eventName"];
            this.area = _data["area"];
            this.changedBy = _data["changedBy"];
            this.userAgent = _data["userAgent"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.changedColumns = _data["changedColumns"];
            this.changeType = _data["changeType"];
            this.comment = _data["comment"];
            this.sourceTable = _data["sourceTable"];
            this.sourcePrimaryKey = _data["sourcePrimaryKey"];
            this.oldValueDisplay = _data["oldValueDisplay"];
            this.newValueDisplay = _data["newValueDisplay"];
            this.changedColumnsDisplay = _data["changedColumnsDisplay"];
        }
    }

    static fromJS(data: any): OnePProjectAuditHistoryItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectAuditHistoryItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changedOn"] = this.changedOn ? this.changedOn.toISOString() : undefined as any;
        data["eventName"] = this.eventName;
        data["area"] = this.area;
        data["changedBy"] = this.changedBy;
        data["userAgent"] = this.userAgent;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["changedColumns"] = this.changedColumns;
        data["changeType"] = this.changeType;
        data["comment"] = this.comment;
        data["sourceTable"] = this.sourceTable;
        data["sourcePrimaryKey"] = this.sourcePrimaryKey;
        data["oldValueDisplay"] = this.oldValueDisplay;
        data["newValueDisplay"] = this.newValueDisplay;
        data["changedColumnsDisplay"] = this.changedColumnsDisplay;
        return data;
    }
}

export interface IOnePProjectAuditHistoryItemDTO {
    changedOn: Date;
    eventName: string | undefined;
    area: string | undefined;
    changedBy?: string | undefined;
    userAgent?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    changedColumns?: string | undefined;
    changeType?: string | undefined;
    comment?: string | undefined;
    sourceTable?: string | undefined;
    sourcePrimaryKey?: string | undefined;
    oldValueDisplay?: string | undefined;
    newValueDisplay?: string | undefined;
    changedColumnsDisplay?: string | undefined;
}

export class OnePProjectCoordinatorCreateUpdateDTO implements IOnePProjectCoordinatorCreateUpdateDTO {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;

    constructor(data?: IOnePProjectCoordinatorCreateUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.coordinatorName = _data["coordinatorName"];
            this.coordinatorEmail = _data["coordinatorEmail"];
            this.backToBackName = _data["backToBackName"];
            this.backToBackEmail = _data["backToBackEmail"];
            this.supervisorName = _data["supervisorName"];
            this.supervisorEmail = _data["supervisorEmail"];
        }
    }

    static fromJS(data: any): OnePProjectCoordinatorCreateUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectCoordinatorCreateUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["coordinatorName"] = this.coordinatorName;
        data["coordinatorEmail"] = this.coordinatorEmail;
        data["backToBackName"] = this.backToBackName;
        data["backToBackEmail"] = this.backToBackEmail;
        data["supervisorName"] = this.supervisorName;
        data["supervisorEmail"] = this.supervisorEmail;
        return data;
    }
}

export interface IOnePProjectCoordinatorCreateUpdateDTO {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
}

export class OnePProjectCoordinatorReadDTO implements IOnePProjectCoordinatorReadDTO {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;

    constructor(data?: IOnePProjectCoordinatorReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.coordinatorName = _data["coordinatorName"];
            this.coordinatorEmail = _data["coordinatorEmail"];
            this.backToBackName = _data["backToBackName"];
            this.backToBackEmail = _data["backToBackEmail"];
            this.supervisorName = _data["supervisorName"];
            this.supervisorEmail = _data["supervisorEmail"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OnePProjectCoordinatorReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectCoordinatorReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["coordinatorName"] = this.coordinatorName;
        data["coordinatorEmail"] = this.coordinatorEmail;
        data["backToBackName"] = this.backToBackName;
        data["backToBackEmail"] = this.backToBackEmail;
        data["supervisorName"] = this.supervisorName;
        data["supervisorEmail"] = this.supervisorEmail;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IOnePProjectCoordinatorReadDTO {
    pk?: number;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    backToBackName?: string | undefined;
    backToBackEmail?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date | undefined;
}

export class OnePProjectCostTotalsDTO implements IOnePProjectCostTotalsDTO {
    janMaterial?: number | undefined;
    febMaterial?: number | undefined;
    marMaterial?: number | undefined;
    aprMaterial?: number | undefined;
    mayMaterial?: number | undefined;
    junMaterial?: number | undefined;
    julMaterial?: number | undefined;
    augMaterial?: number | undefined;
    sepMaterial?: number | undefined;
    octMaterial?: number | undefined;
    novMaterial?: number | undefined;
    decMaterial?: number | undefined;
    janService?: number | undefined;
    febService?: number | undefined;
    marService?: number | undefined;
    aprService?: number | undefined;
    mayService?: number | undefined;
    junService?: number | undefined;
    julService?: number | undefined;
    augService?: number | undefined;
    sepService?: number | undefined;
    octService?: number | undefined;
    novService?: number | undefined;
    decService?: number | undefined;
    janOther?: number | undefined;
    febOther?: number | undefined;
    marOther?: number | undefined;
    aprOther?: number | undefined;
    mayOther?: number | undefined;
    junOther?: number | undefined;
    julOther?: number | undefined;
    augOther?: number | undefined;
    sepOther?: number | undefined;
    octOther?: number | undefined;
    novOther?: number | undefined;
    decOther?: number | undefined;

    constructor(data?: IOnePProjectCostTotalsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.janMaterial = _data["janMaterial"];
            this.febMaterial = _data["febMaterial"];
            this.marMaterial = _data["marMaterial"];
            this.aprMaterial = _data["aprMaterial"];
            this.mayMaterial = _data["mayMaterial"];
            this.junMaterial = _data["junMaterial"];
            this.julMaterial = _data["julMaterial"];
            this.augMaterial = _data["augMaterial"];
            this.sepMaterial = _data["sepMaterial"];
            this.octMaterial = _data["octMaterial"];
            this.novMaterial = _data["novMaterial"];
            this.decMaterial = _data["decMaterial"];
            this.janService = _data["janService"];
            this.febService = _data["febService"];
            this.marService = _data["marService"];
            this.aprService = _data["aprService"];
            this.mayService = _data["mayService"];
            this.junService = _data["junService"];
            this.julService = _data["julService"];
            this.augService = _data["augService"];
            this.sepService = _data["sepService"];
            this.octService = _data["octService"];
            this.novService = _data["novService"];
            this.decService = _data["decService"];
            this.janOther = _data["janOther"];
            this.febOther = _data["febOther"];
            this.marOther = _data["marOther"];
            this.aprOther = _data["aprOther"];
            this.mayOther = _data["mayOther"];
            this.junOther = _data["junOther"];
            this.julOther = _data["julOther"];
            this.augOther = _data["augOther"];
            this.sepOther = _data["sepOther"];
            this.octOther = _data["octOther"];
            this.novOther = _data["novOther"];
            this.decOther = _data["decOther"];
        }
    }

    static fromJS(data: any): OnePProjectCostTotalsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectCostTotalsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["janMaterial"] = this.janMaterial;
        data["febMaterial"] = this.febMaterial;
        data["marMaterial"] = this.marMaterial;
        data["aprMaterial"] = this.aprMaterial;
        data["mayMaterial"] = this.mayMaterial;
        data["junMaterial"] = this.junMaterial;
        data["julMaterial"] = this.julMaterial;
        data["augMaterial"] = this.augMaterial;
        data["sepMaterial"] = this.sepMaterial;
        data["octMaterial"] = this.octMaterial;
        data["novMaterial"] = this.novMaterial;
        data["decMaterial"] = this.decMaterial;
        data["janService"] = this.janService;
        data["febService"] = this.febService;
        data["marService"] = this.marService;
        data["aprService"] = this.aprService;
        data["mayService"] = this.mayService;
        data["junService"] = this.junService;
        data["julService"] = this.julService;
        data["augService"] = this.augService;
        data["sepService"] = this.sepService;
        data["octService"] = this.octService;
        data["novService"] = this.novService;
        data["decService"] = this.decService;
        data["janOther"] = this.janOther;
        data["febOther"] = this.febOther;
        data["marOther"] = this.marOther;
        data["aprOther"] = this.aprOther;
        data["mayOther"] = this.mayOther;
        data["junOther"] = this.junOther;
        data["julOther"] = this.julOther;
        data["augOther"] = this.augOther;
        data["sepOther"] = this.sepOther;
        data["octOther"] = this.octOther;
        data["novOther"] = this.novOther;
        data["decOther"] = this.decOther;
        return data;
    }
}

export interface IOnePProjectCostTotalsDTO {
    janMaterial?: number | undefined;
    febMaterial?: number | undefined;
    marMaterial?: number | undefined;
    aprMaterial?: number | undefined;
    mayMaterial?: number | undefined;
    junMaterial?: number | undefined;
    julMaterial?: number | undefined;
    augMaterial?: number | undefined;
    sepMaterial?: number | undefined;
    octMaterial?: number | undefined;
    novMaterial?: number | undefined;
    decMaterial?: number | undefined;
    janService?: number | undefined;
    febService?: number | undefined;
    marService?: number | undefined;
    aprService?: number | undefined;
    mayService?: number | undefined;
    junService?: number | undefined;
    julService?: number | undefined;
    augService?: number | undefined;
    sepService?: number | undefined;
    octService?: number | undefined;
    novService?: number | undefined;
    decService?: number | undefined;
    janOther?: number | undefined;
    febOther?: number | undefined;
    marOther?: number | undefined;
    aprOther?: number | undefined;
    mayOther?: number | undefined;
    junOther?: number | undefined;
    julOther?: number | undefined;
    augOther?: number | undefined;
    sepOther?: number | undefined;
    octOther?: number | undefined;
    novOther?: number | undefined;
    decOther?: number | undefined;
}

export class OnePProjectCostTotalsOutlookDTO implements IOnePProjectCostTotalsOutlookDTO {
    initiativeId?: number;
    janOutlook?: number | undefined;
    febOutlook?: number | undefined;
    marOutlook?: number | undefined;
    aprOutlook?: number | undefined;
    mayOutlook?: number | undefined;
    junOutlook?: number | undefined;
    julOutlook?: number | undefined;
    augOutlook?: number | undefined;
    sepOutlook?: number | undefined;
    octOutlook?: number | undefined;
    novOutlook?: number | undefined;
    decOutlook?: number | undefined;

    constructor(data?: IOnePProjectCostTotalsOutlookDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.janOutlook = _data["janOutlook"];
            this.febOutlook = _data["febOutlook"];
            this.marOutlook = _data["marOutlook"];
            this.aprOutlook = _data["aprOutlook"];
            this.mayOutlook = _data["mayOutlook"];
            this.junOutlook = _data["junOutlook"];
            this.julOutlook = _data["julOutlook"];
            this.augOutlook = _data["augOutlook"];
            this.sepOutlook = _data["sepOutlook"];
            this.octOutlook = _data["octOutlook"];
            this.novOutlook = _data["novOutlook"];
            this.decOutlook = _data["decOutlook"];
        }
    }

    static fromJS(data: any): OnePProjectCostTotalsOutlookDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectCostTotalsOutlookDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["janOutlook"] = this.janOutlook;
        data["febOutlook"] = this.febOutlook;
        data["marOutlook"] = this.marOutlook;
        data["aprOutlook"] = this.aprOutlook;
        data["mayOutlook"] = this.mayOutlook;
        data["junOutlook"] = this.junOutlook;
        data["julOutlook"] = this.julOutlook;
        data["augOutlook"] = this.augOutlook;
        data["sepOutlook"] = this.sepOutlook;
        data["octOutlook"] = this.octOutlook;
        data["novOutlook"] = this.novOutlook;
        data["decOutlook"] = this.decOutlook;
        return data;
    }
}

export interface IOnePProjectCostTotalsOutlookDTO {
    initiativeId?: number;
    janOutlook?: number | undefined;
    febOutlook?: number | undefined;
    marOutlook?: number | undefined;
    aprOutlook?: number | undefined;
    mayOutlook?: number | undefined;
    junOutlook?: number | undefined;
    julOutlook?: number | undefined;
    augOutlook?: number | undefined;
    sepOutlook?: number | undefined;
    octOutlook?: number | undefined;
    novOutlook?: number | undefined;
    decOutlook?: number | undefined;
}

export class OnePProjectCostTotalsWithActualsFlagDTO implements IOnePProjectCostTotalsWithActualsFlagDTO {
    initiativeCostTotalsAmount?: OnePProjectCostTotalsDTO;
    initiativeActualsFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
    initiativeActualsEditedFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;

    constructor(data?: IOnePProjectCostTotalsWithActualsFlagDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeCostTotalsAmount = _data["initiativeCostTotalsAmount"] ? OnePProjectCostTotalsDTO.fromJS(_data["initiativeCostTotalsAmount"]) : undefined as any;
            this.initiativeActualsFlags = _data["initiativeActualsFlags"] ? OnePPInitiativeActualCostTotalsFlagsDTO.fromJS(_data["initiativeActualsFlags"]) : undefined as any;
            this.initiativeActualsEditedFlags = _data["initiativeActualsEditedFlags"] ? OnePPInitiativeActualCostTotalsFlagsDTO.fromJS(_data["initiativeActualsEditedFlags"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePProjectCostTotalsWithActualsFlagDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectCostTotalsWithActualsFlagDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeCostTotalsAmount"] = this.initiativeCostTotalsAmount ? this.initiativeCostTotalsAmount.toJSON() : undefined as any;
        data["initiativeActualsFlags"] = this.initiativeActualsFlags ? this.initiativeActualsFlags.toJSON() : undefined as any;
        data["initiativeActualsEditedFlags"] = this.initiativeActualsEditedFlags ? this.initiativeActualsEditedFlags.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePProjectCostTotalsWithActualsFlagDTO {
    initiativeCostTotalsAmount?: OnePProjectCostTotalsDTO;
    initiativeActualsFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
    initiativeActualsEditedFlags?: OnePPInitiativeActualCostTotalsFlagsDTO;
}

export class OnePProjectGeneralSettingsDTO implements IOnePProjectGeneralSettingsDTO {
    key?: string | undefined;
    valueType?: ProjectGeneralSettingsValueType;
    value?: string | undefined;
    description?: string | undefined;
    modifiedOn?: Date;
    modifiedBy?: string | undefined;

    constructor(data?: IOnePProjectGeneralSettingsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.valueType = _data["valueType"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): OnePProjectGeneralSettingsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectGeneralSettingsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["valueType"] = this.valueType;
        data["value"] = this.value;
        data["description"] = this.description;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IOnePProjectGeneralSettingsDTO {
    key?: string | undefined;
    valueType?: ProjectGeneralSettingsValueType;
    value?: string | undefined;
    description?: string | undefined;
    modifiedOn?: Date;
    modifiedBy?: string | undefined;
}

export class OnePProjectGovernanceContacts implements IOnePProjectGovernanceContacts {
    pk?: number;
    onePInitiativeFk?: number;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    preExecutionSupervisor?: string | undefined;
    executionSupervisor?: string | undefined;
    lookbackSupervisor?: string | undefined;
    onePInitiative?: OnePInitiative;

    constructor(data?: IOnePProjectGovernanceContacts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.onePInitiativeFk = _data["onePInitiativeFk"];
            this.areaOwner = _data["areaOwner"];
            this.areaOwnerCC = _data["areaOwnerCC"];
            this.coreTeam = _data["coreTeam"];
            this.coreTeamCC = _data["coreTeamCC"];
            this.portfolioLeadershipTeam = _data["portfolioLeadershipTeam"];
            this.portfolioLeadershipTeamCC = _data["portfolioLeadershipTeamCC"];
            this.preExecutionSupervisor = _data["preExecutionSupervisor"];
            this.executionSupervisor = _data["executionSupervisor"];
            this.lookbackSupervisor = _data["lookbackSupervisor"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePProjectGovernanceContacts {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectGovernanceContacts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["onePInitiativeFk"] = this.onePInitiativeFk;
        data["areaOwner"] = this.areaOwner;
        data["areaOwnerCC"] = this.areaOwnerCC;
        data["coreTeam"] = this.coreTeam;
        data["coreTeamCC"] = this.coreTeamCC;
        data["portfolioLeadershipTeam"] = this.portfolioLeadershipTeam;
        data["portfolioLeadershipTeamCC"] = this.portfolioLeadershipTeamCC;
        data["preExecutionSupervisor"] = this.preExecutionSupervisor;
        data["executionSupervisor"] = this.executionSupervisor;
        data["lookbackSupervisor"] = this.lookbackSupervisor;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePProjectGovernanceContacts {
    pk?: number;
    onePInitiativeFk?: number;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    preExecutionSupervisor?: string | undefined;
    executionSupervisor?: string | undefined;
    lookbackSupervisor?: string | undefined;
    onePInitiative?: OnePInitiative;
}

export class OnePProjectGovernanceContactsDTO implements IOnePProjectGovernanceContactsDTO {
    pk?: number;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    preExecutionSupervisor?: string | undefined;
    executionSupervisor?: string | undefined;
    lookbackSupervisor?: string | undefined;

    constructor(data?: IOnePProjectGovernanceContactsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.areaOwner = _data["areaOwner"];
            this.areaOwnerCC = _data["areaOwnerCC"];
            this.coreTeam = _data["coreTeam"];
            this.coreTeamCC = _data["coreTeamCC"];
            this.portfolioLeadershipTeam = _data["portfolioLeadershipTeam"];
            this.portfolioLeadershipTeamCC = _data["portfolioLeadershipTeamCC"];
            this.preExecutionSupervisor = _data["preExecutionSupervisor"];
            this.executionSupervisor = _data["executionSupervisor"];
            this.lookbackSupervisor = _data["lookbackSupervisor"];
        }
    }

    static fromJS(data: any): OnePProjectGovernanceContactsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectGovernanceContactsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["areaOwner"] = this.areaOwner;
        data["areaOwnerCC"] = this.areaOwnerCC;
        data["coreTeam"] = this.coreTeam;
        data["coreTeamCC"] = this.coreTeamCC;
        data["portfolioLeadershipTeam"] = this.portfolioLeadershipTeam;
        data["portfolioLeadershipTeamCC"] = this.portfolioLeadershipTeamCC;
        data["preExecutionSupervisor"] = this.preExecutionSupervisor;
        data["executionSupervisor"] = this.executionSupervisor;
        data["lookbackSupervisor"] = this.lookbackSupervisor;
        return data;
    }
}

export interface IOnePProjectGovernanceContactsDTO {
    pk?: number;
    areaOwner?: string | undefined;
    areaOwnerCC?: string | undefined;
    coreTeam?: string | undefined;
    coreTeamCC?: string | undefined;
    portfolioLeadershipTeam?: string | undefined;
    portfolioLeadershipTeamCC?: string | undefined;
    preExecutionSupervisor?: string | undefined;
    executionSupervisor?: string | undefined;
    lookbackSupervisor?: string | undefined;
}

export class OnePProjectTeam implements IOnePProjectTeam {
    pk?: number;
    teamNameEn!: string;
    teamNameKz?: string | undefined;
    teamNameRu?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    portfolioLeadershipTeamCCEmail?: string | undefined;
    costCenter?: number;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IOnePProjectTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.teamNameEn = _data["teamNameEn"];
            this.teamNameKz = _data["teamNameKz"];
            this.teamNameRu = _data["teamNameRu"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.projectOwnerPhone = _data["projectOwnerPhone"];
            this.portfolioLeadershipTeamCCEmail = _data["portfolioLeadershipTeamCCEmail"];
            this.costCenter = _data["costCenter"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OnePProjectTeam {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["teamNameEn"] = this.teamNameEn;
        data["teamNameKz"] = this.teamNameKz;
        data["teamNameRu"] = this.teamNameRu;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["projectOwnerPhone"] = this.projectOwnerPhone;
        data["portfolioLeadershipTeamCCEmail"] = this.portfolioLeadershipTeamCCEmail;
        data["costCenter"] = this.costCenter;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IOnePProjectTeam {
    pk?: number;
    teamNameEn: string;
    teamNameKz?: string | undefined;
    teamNameRu?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    portfolioLeadershipTeamCCEmail?: string | undefined;
    costCenter?: number;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    isDeleted?: boolean;
}

export class OnePProjectTeamCreateDTO implements IOnePProjectTeamCreateDTO {
    teamNameEn?: string | undefined;
    teamNameKz?: string | undefined;
    teamNameRu?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    portfolioLeadershipTeamCCEmail?: string | undefined;
    costCenter?: number;

    constructor(data?: IOnePProjectTeamCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamNameEn = _data["teamNameEn"];
            this.teamNameKz = _data["teamNameKz"];
            this.teamNameRu = _data["teamNameRu"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.projectOwnerPhone = _data["projectOwnerPhone"];
            this.portfolioLeadershipTeamCCEmail = _data["portfolioLeadershipTeamCCEmail"];
            this.costCenter = _data["costCenter"];
        }
    }

    static fromJS(data: any): OnePProjectTeamCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectTeamCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamNameEn"] = this.teamNameEn;
        data["teamNameKz"] = this.teamNameKz;
        data["teamNameRu"] = this.teamNameRu;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["projectOwnerPhone"] = this.projectOwnerPhone;
        data["portfolioLeadershipTeamCCEmail"] = this.portfolioLeadershipTeamCCEmail;
        data["costCenter"] = this.costCenter;
        return data;
    }
}

export interface IOnePProjectTeamCreateDTO {
    teamNameEn?: string | undefined;
    teamNameKz?: string | undefined;
    teamNameRu?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    portfolioLeadershipTeamCCEmail?: string | undefined;
    costCenter?: number;
}

export class OnePProjectTeamDetail implements IOnePProjectTeamDetail {
    pk?: number;
    teamName?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    costCenter?: number | undefined;
    onePInitiativeFk?: number;
    onePInitiative?: OnePInitiative;

    constructor(data?: IOnePProjectTeamDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.teamName = _data["teamName"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.projectOwnerPhone = _data["projectOwnerPhone"];
            this.costCenter = _data["costCenter"];
            this.onePInitiativeFk = _data["onePInitiativeFk"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePProjectTeamDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectTeamDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["teamName"] = this.teamName;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["projectOwnerPhone"] = this.projectOwnerPhone;
        data["costCenter"] = this.costCenter;
        data["onePInitiativeFk"] = this.onePInitiativeFk;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePProjectTeamDetail {
    pk?: number;
    teamName?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    costCenter?: number | undefined;
    onePInitiativeFk?: number;
    onePInitiative?: OnePInitiative;
}

export class OnePProjectTeamDetailDTO implements IOnePProjectTeamDetailDTO {
    pk?: number;
    teamName?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    costCenter?: number | undefined;

    constructor(data?: IOnePProjectTeamDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.teamName = _data["teamName"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.projectOwnerPhone = _data["projectOwnerPhone"];
            this.costCenter = _data["costCenter"];
        }
    }

    static fromJS(data: any): OnePProjectTeamDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectTeamDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["teamName"] = this.teamName;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["projectOwnerPhone"] = this.projectOwnerPhone;
        data["costCenter"] = this.costCenter;
        return data;
    }
}

export interface IOnePProjectTeamDetailDTO {
    pk?: number;
    teamName?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    costCenter?: number | undefined;
}

export class OnePProjectTeamUpdateDTO implements IOnePProjectTeamUpdateDTO {
    teamNameEn?: string | undefined;
    teamNameKz?: string | undefined;
    teamNameRu?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    portfolioLeadershipTeamCCEmail?: string | undefined;
    costCenter?: number;

    constructor(data?: IOnePProjectTeamUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamNameEn = _data["teamNameEn"];
            this.teamNameKz = _data["teamNameKz"];
            this.teamNameRu = _data["teamNameRu"];
            this.projectOwnerEmail = _data["projectOwnerEmail"];
            this.projectOwnerPhone = _data["projectOwnerPhone"];
            this.portfolioLeadershipTeamCCEmail = _data["portfolioLeadershipTeamCCEmail"];
            this.costCenter = _data["costCenter"];
        }
    }

    static fromJS(data: any): OnePProjectTeamUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePProjectTeamUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamNameEn"] = this.teamNameEn;
        data["teamNameKz"] = this.teamNameKz;
        data["teamNameRu"] = this.teamNameRu;
        data["projectOwnerEmail"] = this.projectOwnerEmail;
        data["projectOwnerPhone"] = this.projectOwnerPhone;
        data["portfolioLeadershipTeamCCEmail"] = this.portfolioLeadershipTeamCCEmail;
        data["costCenter"] = this.costCenter;
        return data;
    }
}

export interface IOnePProjectTeamUpdateDTO {
    teamNameEn?: string | undefined;
    teamNameKz?: string | undefined;
    teamNameRu?: string | undefined;
    projectOwnerEmail?: string | undefined;
    projectOwnerPhone?: string | undefined;
    portfolioLeadershipTeamCCEmail?: string | undefined;
    costCenter?: number;
}

export class OnePStageHistory implements IOnePStageHistory {
    pk?: number;
    fk?: number;
    initiativeStage?: InitiativeStage;
    changedBy?: string | undefined;
    comment?: string | undefined;
    changedOn?: Date;
    attachmentFileFk?: string | undefined;
    onePInitiative?: OnePInitiative;

    constructor(data?: IOnePStageHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.fk = _data["fk"];
            this.initiativeStage = _data["initiativeStage"];
            this.changedBy = _data["changedBy"];
            this.comment = _data["comment"];
            this.changedOn = _data["changedOn"] ? new Date(_data["changedOn"].toString()) : undefined as any;
            this.attachmentFileFk = _data["attachmentFileFk"];
            this.onePInitiative = _data["onePInitiative"] ? OnePInitiative.fromJS(_data["onePInitiative"]) : undefined as any;
        }
    }

    static fromJS(data: any): OnePStageHistory {
        data = typeof data === 'object' ? data : {};
        let result = new OnePStageHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["fk"] = this.fk;
        data["initiativeStage"] = this.initiativeStage;
        data["changedBy"] = this.changedBy;
        data["comment"] = this.comment;
        data["changedOn"] = this.changedOn ? this.changedOn.toISOString() : undefined as any;
        data["attachmentFileFk"] = this.attachmentFileFk;
        data["onePInitiative"] = this.onePInitiative ? this.onePInitiative.toJSON() : undefined as any;
        return data;
    }
}

export interface IOnePStageHistory {
    pk?: number;
    fk?: number;
    initiativeStage?: InitiativeStage;
    changedBy?: string | undefined;
    comment?: string | undefined;
    changedOn?: Date;
    attachmentFileFk?: string | undefined;
    onePInitiative?: OnePInitiative;
}

export class OnePStageHistoryReadDTO implements IOnePStageHistoryReadDTO {
    initiativeFk?: number;
    stage?: InitiativeStage;
    changedBy?: string | undefined;
    changeComment?: string | undefined;
    changedOn?: Date;

    constructor(data?: IOnePStageHistoryReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeFk = _data["initiativeFk"];
            this.stage = _data["stage"];
            this.changedBy = _data["changedBy"];
            this.changeComment = _data["changeComment"];
            this.changedOn = _data["changedOn"] ? new Date(_data["changedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OnePStageHistoryReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePStageHistoryReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeFk"] = this.initiativeFk;
        data["stage"] = this.stage;
        data["changedBy"] = this.changedBy;
        data["changeComment"] = this.changeComment;
        data["changedOn"] = this.changedOn ? this.changedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IOnePStageHistoryReadDTO {
    initiativeFk?: number;
    stage?: InitiativeStage;
    changedBy?: string | undefined;
    changeComment?: string | undefined;
    changedOn?: Date;
}

export class OnePTopUnitLevelDetailViewRowDTO implements IOnePTopUnitLevelDetailViewRowDTO {
    facilityCode?: string | undefined;
    unitCode?: string | undefined;
    fdmCount?: number;
    badActorCount?: number;
    initiativeCount?: number;
    totalScore?: number;

    constructor(data?: IOnePTopUnitLevelDetailViewRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityCode = _data["facilityCode"];
            this.unitCode = _data["unitCode"];
            this.fdmCount = _data["fdmCount"];
            this.badActorCount = _data["badActorCount"];
            this.initiativeCount = _data["initiativeCount"];
            this.totalScore = _data["totalScore"];
        }
    }

    static fromJS(data: any): OnePTopUnitLevelDetailViewRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OnePTopUnitLevelDetailViewRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityCode"] = this.facilityCode;
        data["unitCode"] = this.unitCode;
        data["fdmCount"] = this.fdmCount;
        data["badActorCount"] = this.badActorCount;
        data["initiativeCount"] = this.initiativeCount;
        data["totalScore"] = this.totalScore;
        return data;
    }
}

export interface IOnePTopUnitLevelDetailViewRowDTO {
    facilityCode?: string | undefined;
    unitCode?: string | undefined;
    fdmCount?: number;
    badActorCount?: number;
    initiativeCount?: number;
    totalScore?: number;
}

export class OrderOverride implements IOrderOverride {
    initiativePk?: number;
    orderIndex?: number;

    constructor(data?: IOrderOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativePk = _data["initiativePk"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): OrderOverride {
        data = typeof data === 'object' ? data : {};
        let result = new OrderOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativePk"] = this.initiativePk;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface IOrderOverride {
    initiativePk?: number;
    orderIndex?: number;
}

export enum ProjectCostTotalCategory {
    Material = "Material",
    Service = "Service",
    Other = "Other",
}

export enum ProjectGeneralSettingsValueType {
    Bool = "Bool",
    Int = "Int",
    Decimal = "Decimal",
    String = "String",
    Url = "Url",
    Json = "Json",
}

export class StageAllInitiativesBudgetHistoryDTO implements IStageAllInitiativesBudgetHistoryDTO {
    initiativeFk?: number;
    event?: string | undefined;
    readonly name?: string | undefined;
    changeComment?: string | undefined;
    changedBy?: string | undefined;
    changedOn?: Date | undefined;
    attachmentFileUrl?: string | undefined;

    constructor(data?: IStageAllInitiativesBudgetHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeFk = _data["initiativeFk"];
            this.event = _data["event"];
            (this as any).name = _data["name"];
            this.changeComment = _data["changeComment"];
            this.changedBy = _data["changedBy"];
            this.changedOn = _data["changedOn"] ? new Date(_data["changedOn"].toString()) : undefined as any;
            this.attachmentFileUrl = _data["attachmentFileUrl"];
        }
    }

    static fromJS(data: any): StageAllInitiativesBudgetHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StageAllInitiativesBudgetHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeFk"] = this.initiativeFk;
        data["event"] = this.event;
        data["name"] = this.name;
        data["changeComment"] = this.changeComment;
        data["changedBy"] = this.changedBy;
        data["changedOn"] = this.changedOn ? this.changedOn.toISOString() : undefined as any;
        data["attachmentFileUrl"] = this.attachmentFileUrl;
        return data;
    }
}

export interface IStageAllInitiativesBudgetHistoryDTO {
    initiativeFk?: number;
    event?: string | undefined;
    name?: string | undefined;
    changeComment?: string | undefined;
    changedBy?: string | undefined;
    changedOn?: Date | undefined;
    attachmentFileUrl?: string | undefined;
}

export class StageAllInitiativesBudgetHistoryDTOGridPagedResult implements IStageAllInitiativesBudgetHistoryDTOGridPagedResult {
    items!: StageAllInitiativesBudgetHistoryDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IStageAllInitiativesBudgetHistoryDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StageAllInitiativesBudgetHistoryDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): StageAllInitiativesBudgetHistoryDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new StageAllInitiativesBudgetHistoryDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IStageAllInitiativesBudgetHistoryDTOGridPagedResult {
    items: StageAllInitiativesBudgetHistoryDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export class StageBudgetHistoryDTO implements IStageBudgetHistoryDTO {
    event?: string | undefined;
    readonly name?: string | undefined;
    changeComment?: string | undefined;
    changedBy?: string | undefined;
    changedOn?: Date | undefined;
    attachmentFileUrl?: string | undefined;

    constructor(data?: IStageBudgetHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            (this as any).name = _data["name"];
            this.changeComment = _data["changeComment"];
            this.changedBy = _data["changedBy"];
            this.changedOn = _data["changedOn"] ? new Date(_data["changedOn"].toString()) : undefined as any;
            this.attachmentFileUrl = _data["attachmentFileUrl"];
        }
    }

    static fromJS(data: any): StageBudgetHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StageBudgetHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["name"] = this.name;
        data["changeComment"] = this.changeComment;
        data["changedBy"] = this.changedBy;
        data["changedOn"] = this.changedOn ? this.changedOn.toISOString() : undefined as any;
        data["attachmentFileUrl"] = this.attachmentFileUrl;
        return data;
    }
}

export interface IStageBudgetHistoryDTO {
    event?: string | undefined;
    name?: string | undefined;
    changeComment?: string | undefined;
    changedBy?: string | undefined;
    changedOn?: Date | undefined;
    attachmentFileUrl?: string | undefined;
}

export class StageBudgetHistoryDTOGridPagedResult implements IStageBudgetHistoryDTOGridPagedResult {
    items!: StageBudgetHistoryDTO[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;
    readonly totalPages?: number;

    constructor(data?: IStageBudgetHistoryDTOGridPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StageBudgetHistoryDTO.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            (this as any).totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): StageBudgetHistoryDTOGridPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new StageBudgetHistoryDTOGridPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IStageBudgetHistoryDTOGridPagedResult {
    items: StageBudgetHistoryDTO[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export enum TaType {
    TA = "TA",
    NonTA = "NonTA",
    MiniTA = "MiniTA",
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUnit {
}

export class UpdateActualCostCodeDictionariesCommand implements IUpdateActualCostCodeDictionariesCommand {
    actualsDictionaryDTO?: OnePInitiativeActualCostCodeDictionaryDTO;

    constructor(data?: IUpdateActualCostCodeDictionariesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualsDictionaryDTO = _data["actualsDictionaryDTO"] ? OnePInitiativeActualCostCodeDictionaryDTO.fromJS(_data["actualsDictionaryDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateActualCostCodeDictionariesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActualCostCodeDictionariesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualsDictionaryDTO"] = this.actualsDictionaryDTO ? this.actualsDictionaryDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateActualCostCodeDictionariesCommand {
    actualsDictionaryDTO?: OnePInitiativeActualCostCodeDictionaryDTO;
}

export class UpdateAreaOwnerCommand implements IUpdateAreaOwnerCommand {
    areaOwnerPk?: number;
    onePAreaOwnerUpdateDTO?: OnePAreaOwnerUpdateDTO;

    constructor(data?: IUpdateAreaOwnerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaOwnerPk = _data["areaOwnerPk"];
            this.onePAreaOwnerUpdateDTO = _data["onePAreaOwnerUpdateDTO"] ? OnePAreaOwnerUpdateDTO.fromJS(_data["onePAreaOwnerUpdateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateAreaOwnerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAreaOwnerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaOwnerPk"] = this.areaOwnerPk;
        data["onePAreaOwnerUpdateDTO"] = this.onePAreaOwnerUpdateDTO ? this.onePAreaOwnerUpdateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateAreaOwnerCommand {
    areaOwnerPk?: number;
    onePAreaOwnerUpdateDTO?: OnePAreaOwnerUpdateDTO;
}

export class UpdateBreakInOutApprovalCommand implements IUpdateBreakInOutApprovalCommand {
    pk?: number;
    decision?: BreakInOutDecision;
    decisionComment?: string | undefined;

    constructor(data?: IUpdateBreakInOutApprovalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.decision = _data["decision"];
            this.decisionComment = _data["decisionComment"];
        }
    }

    static fromJS(data: any): UpdateBreakInOutApprovalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBreakInOutApprovalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["decision"] = this.decision;
        data["decisionComment"] = this.decisionComment;
        return data;
    }
}

export interface IUpdateBreakInOutApprovalCommand {
    pk?: number;
    decision?: BreakInOutDecision;
    decisionComment?: string | undefined;
}

export class UpdateBreakInOutCommand implements IUpdateBreakInOutCommand {
    breakInOutId?: number;
    justification?: string | undefined;
    amount?: number;
    revisedOutlook?: number;

    constructor(data?: IUpdateBreakInOutCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakInOutId = _data["breakInOutId"];
            this.justification = _data["justification"];
            this.amount = _data["amount"];
            this.revisedOutlook = _data["revisedOutlook"];
        }
    }

    static fromJS(data: any): UpdateBreakInOutCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBreakInOutCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breakInOutId"] = this.breakInOutId;
        data["justification"] = this.justification;
        data["amount"] = this.amount;
        data["revisedOutlook"] = this.revisedOutlook;
        return data;
    }
}

export interface IUpdateBreakInOutCommand {
    breakInOutId?: number;
    justification?: string | undefined;
    amount?: number;
    revisedOutlook?: number;
}

export class UpdateBreakInOutCommentFieldsCommand implements IUpdateBreakInOutCommentFieldsCommand {
    breakInOutId?: number;
    justification?: string | undefined;
    statusComment?: string | undefined;
    decisionComment?: string | undefined;

    constructor(data?: IUpdateBreakInOutCommentFieldsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakInOutId = _data["breakInOutId"];
            this.justification = _data["justification"];
            this.statusComment = _data["statusComment"];
            this.decisionComment = _data["decisionComment"];
        }
    }

    static fromJS(data: any): UpdateBreakInOutCommentFieldsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBreakInOutCommentFieldsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breakInOutId"] = this.breakInOutId;
        data["justification"] = this.justification;
        data["statusComment"] = this.statusComment;
        data["decisionComment"] = this.decisionComment;
        return data;
    }
}

export interface IUpdateBreakInOutCommentFieldsCommand {
    breakInOutId?: number;
    justification?: string | undefined;
    statusComment?: string | undefined;
    decisionComment?: string | undefined;
}

export class UpdateBreakInOutConfirmationCommand implements IUpdateBreakInOutConfirmationCommand {
    pk?: number;
    statusName?: BreakInOutStatus;
    statusComment?: string | undefined;

    constructor(data?: IUpdateBreakInOutConfirmationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.statusName = _data["statusName"];
            this.statusComment = _data["statusComment"];
        }
    }

    static fromJS(data: any): UpdateBreakInOutConfirmationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBreakInOutConfirmationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["statusName"] = this.statusName;
        data["statusComment"] = this.statusComment;
        return data;
    }
}

export interface IUpdateBreakInOutConfirmationCommand {
    pk?: number;
    statusName?: BreakInOutStatus;
    statusComment?: string | undefined;
}

export class UpdateFinanceStatusCommand implements IUpdateFinanceStatusCommand {
    onePFinanceStatusDTO?: OnePFinanceStatusCreateUpdateDTO;

    constructor(data?: IUpdateFinanceStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePFinanceStatusDTO = _data["onePFinanceStatusDTO"] ? OnePFinanceStatusCreateUpdateDTO.fromJS(_data["onePFinanceStatusDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateFinanceStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinanceStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePFinanceStatusDTO"] = this.onePFinanceStatusDTO ? this.onePFinanceStatusDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateFinanceStatusCommand {
    onePFinanceStatusDTO?: OnePFinanceStatusCreateUpdateDTO;
}

export class UpdateForecastUpdatedFieldCommand implements IUpdateForecastUpdatedFieldCommand {
    initiativeId?: number;
    isForecastUpdated?: boolean;

    constructor(data?: IUpdateForecastUpdatedFieldCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.isForecastUpdated = _data["isForecastUpdated"];
        }
    }

    static fromJS(data: any): UpdateForecastUpdatedFieldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateForecastUpdatedFieldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["isForecastUpdated"] = this.isForecastUpdated;
        return data;
    }
}

export interface IUpdateForecastUpdatedFieldCommand {
    initiativeId?: number;
    isForecastUpdated?: boolean;
}

export class UpdateInitiativeCommand implements IUpdateInitiativeCommand {
    onePInitiativeDTO?: OnePInitiativeDTO;

    constructor(data?: IUpdateInitiativeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePInitiativeDTO = _data["onePInitiativeDTO"] ? OnePInitiativeDTO.fromJS(_data["onePInitiativeDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateInitiativeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInitiativeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePInitiativeDTO"] = this.onePInitiativeDTO ? this.onePInitiativeDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateInitiativeCommand {
    onePInitiativeDTO?: OnePInitiativeDTO;
}

export class UpdateInitiativeComplexityCommand implements IUpdateInitiativeComplexityCommand {
    initiativeId?: number;
    complexity?: InitiativeComplexity;

    constructor(data?: IUpdateInitiativeComplexityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.complexity = _data["complexity"];
        }
    }

    static fromJS(data: any): UpdateInitiativeComplexityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInitiativeComplexityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["complexity"] = this.complexity;
        return data;
    }
}

export interface IUpdateInitiativeComplexityCommand {
    initiativeId?: number;
    complexity?: InitiativeComplexity;
}

export class UpdateInitiativeCoordinatorCommand implements IUpdateInitiativeCoordinatorCommand {
    updateDTO?: OnePInitiativeCoordinatorCreateUpdateDTO;

    constructor(data?: IUpdateInitiativeCoordinatorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateDTO = _data["updateDTO"] ? OnePInitiativeCoordinatorCreateUpdateDTO.fromJS(_data["updateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateInitiativeCoordinatorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInitiativeCoordinatorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateDTO"] = this.updateDTO ? this.updateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateInitiativeCoordinatorCommand {
    updateDTO?: OnePInitiativeCoordinatorCreateUpdateDTO;
}

export class UpdateInitiativeNoteCommand implements IUpdateInitiativeNoteCommand {
    pk?: number;
    initiativeFk?: number;
    comment?: string | undefined;
    attachmentId?: string | undefined;

    constructor(data?: IUpdateInitiativeNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.initiativeFk = _data["initiativeFk"];
            this.comment = _data["comment"];
            this.attachmentId = _data["attachmentId"];
        }
    }

    static fromJS(data: any): UpdateInitiativeNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInitiativeNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["initiativeFk"] = this.initiativeFk;
        data["comment"] = this.comment;
        data["attachmentId"] = this.attachmentId;
        return data;
    }
}

export interface IUpdateInitiativeNoteCommand {
    pk?: number;
    initiativeFk?: number;
    comment?: string | undefined;
    attachmentId?: string | undefined;
}

export class UpdateInitiativeStageCommand implements IUpdateInitiativeStageCommand {
    onePInitiativeStageUpdateDTO?: OnePInitiativeStageUpdateDTO;

    constructor(data?: IUpdateInitiativeStageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePInitiativeStageUpdateDTO = _data["onePInitiativeStageUpdateDTO"] ? OnePInitiativeStageUpdateDTO.fromJS(_data["onePInitiativeStageUpdateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateInitiativeStageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInitiativeStageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePInitiativeStageUpdateDTO"] = this.onePInitiativeStageUpdateDTO ? this.onePInitiativeStageUpdateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateInitiativeStageCommand {
    onePInitiativeStageUpdateDTO?: OnePInitiativeStageUpdateDTO;
}

export class UpdateMasterInitiativeLinkCommand implements IUpdateMasterInitiativeLinkCommand {
    pk?: number;
    primaryInitiativePk?: number;
    secondaryInitiativePk?: number;

    constructor(data?: IUpdateMasterInitiativeLinkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.primaryInitiativePk = _data["primaryInitiativePk"];
            this.secondaryInitiativePk = _data["secondaryInitiativePk"];
        }
    }

    static fromJS(data: any): UpdateMasterInitiativeLinkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMasterInitiativeLinkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["primaryInitiativePk"] = this.primaryInitiativePk;
        data["secondaryInitiativePk"] = this.secondaryInitiativePk;
        return data;
    }
}

export interface IUpdateMasterInitiativeLinkCommand {
    pk?: number;
    primaryInitiativePk?: number;
    secondaryInitiativePk?: number;
}

export class UpdateMciProgramCommand implements IUpdateMciProgramCommand {
    onePMciProgramDTO?: OnePMciProgramCreateUpdateDTO;

    constructor(data?: IUpdateMciProgramCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePMciProgramDTO = _data["onePMciProgramDTO"] ? OnePMciProgramCreateUpdateDTO.fromJS(_data["onePMciProgramDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateMciProgramCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMciProgramCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePMciProgramDTO"] = this.onePMciProgramDTO ? this.onePMciProgramDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateMciProgramCommand {
    onePMciProgramDTO?: OnePMciProgramCreateUpdateDTO;
}

export class UpdateMejCutLineAreaSettingsCommand implements IUpdateMejCutLineAreaSettingsCommand {
    mejCutLineAreaSettingsDTO?: MejCutLineAreaSettingsDTO;

    constructor(data?: IUpdateMejCutLineAreaSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mejCutLineAreaSettingsDTO = _data["mejCutLineAreaSettingsDTO"] ? MejCutLineAreaSettingsDTO.fromJS(_data["mejCutLineAreaSettingsDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateMejCutLineAreaSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMejCutLineAreaSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mejCutLineAreaSettingsDTO"] = this.mejCutLineAreaSettingsDTO ? this.mejCutLineAreaSettingsDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateMejCutLineAreaSettingsCommand {
    mejCutLineAreaSettingsDTO?: MejCutLineAreaSettingsDTO;
}

export class UpdateMejCutLineSettingsCommand implements IUpdateMejCutLineSettingsCommand {
    mejCutLineSettingsDTO?: MejCutLineSettingsDTO;

    constructor(data?: IUpdateMejCutLineSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mejCutLineSettingsDTO = _data["mejCutLineSettingsDTO"] ? MejCutLineSettingsDTO.fromJS(_data["mejCutLineSettingsDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateMejCutLineSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMejCutLineSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mejCutLineSettingsDTO"] = this.mejCutLineSettingsDTO ? this.mejCutLineSettingsDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateMejCutLineSettingsCommand {
    mejCutLineSettingsDTO?: MejCutLineSettingsDTO;
}

export class UpdateNotificationSettingsCommand implements IUpdateNotificationSettingsCommand {
    pk?: number;
    isEnabled?: boolean;
    initialDelayMinutes?: number | undefined;
    repeatIntervalMinutes?: number | undefined;

    constructor(data?: IUpdateNotificationSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pk = _data["pk"];
            this.isEnabled = _data["isEnabled"];
            this.initialDelayMinutes = _data["initialDelayMinutes"];
            this.repeatIntervalMinutes = _data["repeatIntervalMinutes"];
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pk"] = this.pk;
        data["isEnabled"] = this.isEnabled;
        data["initialDelayMinutes"] = this.initialDelayMinutes;
        data["repeatIntervalMinutes"] = this.repeatIntervalMinutes;
        return data;
    }
}

export interface IUpdateNotificationSettingsCommand {
    pk?: number;
    isEnabled?: boolean;
    initialDelayMinutes?: number | undefined;
    repeatIntervalMinutes?: number | undefined;
}

export class UpdateProjectCoordinatorCommand implements IUpdateProjectCoordinatorCommand {
    onePProjectCoordinatorDTO?: OnePProjectCoordinatorCreateUpdateDTO;

    constructor(data?: IUpdateProjectCoordinatorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onePProjectCoordinatorDTO = _data["onePProjectCoordinatorDTO"] ? OnePProjectCoordinatorCreateUpdateDTO.fromJS(_data["onePProjectCoordinatorDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProjectCoordinatorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectCoordinatorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onePProjectCoordinatorDTO"] = this.onePProjectCoordinatorDTO ? this.onePProjectCoordinatorDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateProjectCoordinatorCommand {
    onePProjectCoordinatorDTO?: OnePProjectCoordinatorCreateUpdateDTO;
}

export class UpdateProjectGeneralSettingsCommand implements IUpdateProjectGeneralSettingsCommand {
    key?: string | undefined;
    valueType?: ProjectGeneralSettingsValueType;
    value?: string | undefined;
    description?: string | undefined;
    modifiedOn?: Date;

    constructor(data?: IUpdateProjectGeneralSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.valueType = _data["valueType"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProjectGeneralSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectGeneralSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["valueType"] = this.valueType;
        data["value"] = this.value;
        data["description"] = this.description;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateProjectGeneralSettingsCommand {
    key?: string | undefined;
    valueType?: ProjectGeneralSettingsValueType;
    value?: string | undefined;
    description?: string | undefined;
    modifiedOn?: Date;
}

export class UpdateProjectTeamCommand implements IUpdateProjectTeamCommand {
    projectTeamPk?: number;
    onePProjectTeamUpdateDTO?: OnePProjectTeamUpdateDTO;

    constructor(data?: IUpdateProjectTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTeamPk = _data["projectTeamPk"];
            this.onePProjectTeamUpdateDTO = _data["onePProjectTeamUpdateDTO"] ? OnePProjectTeamUpdateDTO.fromJS(_data["onePProjectTeamUpdateDTO"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProjectTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTeamPk"] = this.projectTeamPk;
        data["onePProjectTeamUpdateDTO"] = this.onePProjectTeamUpdateDTO ? this.onePProjectTeamUpdateDTO.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateProjectTeamCommand {
    projectTeamPk?: number;
    onePProjectTeamUpdateDTO?: OnePProjectTeamUpdateDTO;
}

export class UpdateProjectTotalCostFieldCommand implements IUpdateProjectTotalCostFieldCommand {
    initiativeId?: number;
    projectTotalsCost?: number;

    constructor(data?: IUpdateProjectTotalCostFieldCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.projectTotalsCost = _data["projectTotalsCost"];
        }
    }

    static fromJS(data: any): UpdateProjectTotalCostFieldCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectTotalCostFieldCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["projectTotalsCost"] = this.projectTotalsCost;
        return data;
    }
}

export interface IUpdateProjectTotalCostFieldCommand {
    initiativeId?: number;
    projectTotalsCost?: number;
}

export class UpsertCostControllerCommand implements IUpsertCostControllerCommand {
    initiativeId?: number;
    costController?: string | undefined;

    constructor(data?: IUpsertCostControllerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initiativeId = _data["initiativeId"];
            this.costController = _data["costController"];
        }
    }

    static fromJS(data: any): UpsertCostControllerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCostControllerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initiativeId"] = this.initiativeId;
        data["costController"] = this.costController;
        return data;
    }
}

export interface IUpsertCostControllerCommand {
    initiativeId?: number;
    costController?: string | undefined;
}

export class WorkOrderDTO implements IWorkOrderDTO {
    woNumberCode?: string | undefined;
    creationDate?: string | undefined;
    woType?: string | undefined;
    woPriority?: string | undefined;
    plannedCompletionDate?: string | undefined;
    actualCompletionDate?: string | undefined;
    workOrderStatusCode?: string | undefined;
    problemDescription?: string | undefined;
    woClassification?: string | undefined;
    equipmentId?: string | undefined;
    equipmentNumber?: string | undefined;
    categoryCode?: string | undefined;
    statusComment?: string | undefined;
    woDescription?: string | undefined;
    locationCode?: string | undefined;
    woDocumentType?: string | undefined;
    assignmentRoleCode?: string | undefined;
    systemGroupCode?: string | undefined;
    leadCraft?: string | undefined;
    branch?: string | undefined;
    actualLaborAmount?: string | undefined;
    actualOtherWorkAmount?: string | undefined;
    actualMaterialAmount?: string | undefined;
    lpoCostJde?: string | undefined;
    plannedStartDate?: string | undefined;
    estimatedEndDate?: string | undefined;
    workOrderStatusName?: string | undefined;
    woTypeSched?: string | undefined;
    woTypeSchedName?: string | undefined;
    locationName?: string | undefined;
    systemGroupName?: string | undefined;
    woDocumentTypeName?: string | undefined;
    leadCraftName?: string | undefined;
    woFirstStatusDate?: Date | undefined;
    woLastStatusDate?: Date | undefined;

    constructor(data?: IWorkOrderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woNumberCode = _data["woNumberCode"];
            this.creationDate = _data["creationDate"];
            this.woType = _data["woType"];
            this.woPriority = _data["woPriority"];
            this.plannedCompletionDate = _data["plannedCompletionDate"];
            this.actualCompletionDate = _data["actualCompletionDate"];
            this.workOrderStatusCode = _data["workOrderStatusCode"];
            this.problemDescription = _data["problemDescription"];
            this.woClassification = _data["woClassification"];
            this.equipmentId = _data["equipmentId"];
            this.equipmentNumber = _data["equipmentNumber"];
            this.categoryCode = _data["categoryCode"];
            this.statusComment = _data["statusComment"];
            this.woDescription = _data["woDescription"];
            this.locationCode = _data["locationCode"];
            this.woDocumentType = _data["woDocumentType"];
            this.assignmentRoleCode = _data["assignmentRoleCode"];
            this.systemGroupCode = _data["systemGroupCode"];
            this.leadCraft = _data["leadCraft"];
            this.branch = _data["branch"];
            this.actualLaborAmount = _data["actualLaborAmount"];
            this.actualOtherWorkAmount = _data["actualOtherWorkAmount"];
            this.actualMaterialAmount = _data["actualMaterialAmount"];
            this.lpoCostJde = _data["lpoCostJde"];
            this.plannedStartDate = _data["plannedStartDate"];
            this.estimatedEndDate = _data["estimatedEndDate"];
            this.workOrderStatusName = _data["workOrderStatusName"];
            this.woTypeSched = _data["woTypeSched"];
            this.woTypeSchedName = _data["woTypeSchedName"];
            this.locationName = _data["locationName"];
            this.systemGroupName = _data["systemGroupName"];
            this.woDocumentTypeName = _data["woDocumentTypeName"];
            this.leadCraftName = _data["leadCraftName"];
            this.woFirstStatusDate = _data["woFirstStatusDate"] ? new Date(_data["woFirstStatusDate"].toString()) : undefined as any;
            this.woLastStatusDate = _data["woLastStatusDate"] ? new Date(_data["woLastStatusDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woNumberCode"] = this.woNumberCode;
        data["creationDate"] = this.creationDate;
        data["woType"] = this.woType;
        data["woPriority"] = this.woPriority;
        data["plannedCompletionDate"] = this.plannedCompletionDate;
        data["actualCompletionDate"] = this.actualCompletionDate;
        data["workOrderStatusCode"] = this.workOrderStatusCode;
        data["problemDescription"] = this.problemDescription;
        data["woClassification"] = this.woClassification;
        data["equipmentId"] = this.equipmentId;
        data["equipmentNumber"] = this.equipmentNumber;
        data["categoryCode"] = this.categoryCode;
        data["statusComment"] = this.statusComment;
        data["woDescription"] = this.woDescription;
        data["locationCode"] = this.locationCode;
        data["woDocumentType"] = this.woDocumentType;
        data["assignmentRoleCode"] = this.assignmentRoleCode;
        data["systemGroupCode"] = this.systemGroupCode;
        data["leadCraft"] = this.leadCraft;
        data["branch"] = this.branch;
        data["actualLaborAmount"] = this.actualLaborAmount;
        data["actualOtherWorkAmount"] = this.actualOtherWorkAmount;
        data["actualMaterialAmount"] = this.actualMaterialAmount;
        data["lpoCostJde"] = this.lpoCostJde;
        data["plannedStartDate"] = this.plannedStartDate;
        data["estimatedEndDate"] = this.estimatedEndDate;
        data["workOrderStatusName"] = this.workOrderStatusName;
        data["woTypeSched"] = this.woTypeSched;
        data["woTypeSchedName"] = this.woTypeSchedName;
        data["locationName"] = this.locationName;
        data["systemGroupName"] = this.systemGroupName;
        data["woDocumentTypeName"] = this.woDocumentTypeName;
        data["leadCraftName"] = this.leadCraftName;
        data["woFirstStatusDate"] = this.woFirstStatusDate ? this.woFirstStatusDate.toISOString() : undefined as any;
        data["woLastStatusDate"] = this.woLastStatusDate ? this.woLastStatusDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkOrderDTO {
    woNumberCode?: string | undefined;
    creationDate?: string | undefined;
    woType?: string | undefined;
    woPriority?: string | undefined;
    plannedCompletionDate?: string | undefined;
    actualCompletionDate?: string | undefined;
    workOrderStatusCode?: string | undefined;
    problemDescription?: string | undefined;
    woClassification?: string | undefined;
    equipmentId?: string | undefined;
    equipmentNumber?: string | undefined;
    categoryCode?: string | undefined;
    statusComment?: string | undefined;
    woDescription?: string | undefined;
    locationCode?: string | undefined;
    woDocumentType?: string | undefined;
    assignmentRoleCode?: string | undefined;
    systemGroupCode?: string | undefined;
    leadCraft?: string | undefined;
    branch?: string | undefined;
    actualLaborAmount?: string | undefined;
    actualOtherWorkAmount?: string | undefined;
    actualMaterialAmount?: string | undefined;
    lpoCostJde?: string | undefined;
    plannedStartDate?: string | undefined;
    estimatedEndDate?: string | undefined;
    workOrderStatusName?: string | undefined;
    woTypeSched?: string | undefined;
    woTypeSchedName?: string | undefined;
    locationName?: string | undefined;
    systemGroupName?: string | undefined;
    woDocumentTypeName?: string | undefined;
    leadCraftName?: string | undefined;
    woFirstStatusDate?: Date | undefined;
    woLastStatusDate?: Date | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}